export const WINE_DATABASE = [
  "1000 Stories Cabernet Sauvignon",
  "1000 Stories Zinfandel",
  "14 Hands Cabernet Sauvignon",
  "14 Hands Hot to Trot Red Blend",
  "14 Hands Winery Cabernet Sauvignon",
  "19 Crimes Red Blend",
  "A & P de Villaine Bourgogne Côte Chalonnaise La Digoine",
  "A to Z Wineworks Chardonnay",
  "A to Z Wineworks Pinot Gris",
  "A to Z Wineworks Pinot Noir",
  "A to Z Wineworks Rosé",
  "A-Mano Primitivo",
  "A-Mano Primitivo Puglia",
  "A. Christmann Gimmeldinger Meerspinne Riesling Spätlese",
  "A. Christmann Riesling",
  "A. Rafanelli Winery Dry Creek Valley Zinfandel",
  "A. Rafanelli Winery Merlot",
  "A.A. Badenhorst Curator White Blend",
  "AA Badenhorst Family Wines Secateurs Red Blend",
  "AA Badenhorst Secateurs Chenin Blanc",
  "AIX Rose Provence Rose",
  "AIX Rosé Aix Provence Rosé",
  "AIX Rosé Coteaux d'Aix-en-Provence Rosé",
  "Aalto Aalto",
  "Aalto Aalto PS",
  "Abacela Winery Pinot Noir",
  "Abadia Retuerta Pago Negralada",
  "Abadía Retuerta Pago Negralada",
  "Abadía Retuerta Pago Valdebellón",
  "Abadía Retuerta Selección Especial",
  "Abbazia di Novacella Kerner",
  "Abbazia di Novacella Sylvaner",
  "Abreu Vineyards Madrona Ranch Cabernet Sauvignon",
  "Acacia Winery Chardonnay",
  "Acacia Winery Pinot Noir",
  "Achaval Ferrer Finca Altamira Malbec",
  "Achaval Ferrer Finca Bella Vista Malbec",
  "Achaval Ferrer Finca Mirador Malbec",
  "Achaval Ferrer Malbec",
  "Achaval Ferrer Malbec Altamira",
  "Achaval Ferrer Quimera",
  "Achával Ferrer Finca Bella Vista Malbec",
  "Acquiesce Winery Grenache Blanc",
  "Acústic Celler Acústic Blanc",
  "Adanti Montefalco Rosso",
  "Adega de Borba Borba Reserva",
  "Adega de Pegões Moscatel de Setúbal",
  "Adegas Galegas Desde Siempre Albariño",
  "Adelaida Cellars HMR Estate Pinot Noir",
  "Adelaida Vineyards & Winery Cabernet Sauvignon",
  "Adelsheim Breaking Ground Pinot Noir",
  "Adelsheim Pinot Gris",
  "Adelsheim Vineyard Bryan Creek Vineyard Pinot Noir",
  "Adelsheim Vineyard Calkins Lane Vineyard Pinot Noir",
  "Adelsheim Vineyard Chardonnay",
  "Adelsheim Vineyard Pinot Gris",
  "Adelsheim Vineyard Pinot Noir",
  "Adelsheim Vineyard Quarter Mile Lane Pinot Noir",
  "Adelsheim Vineyard Ribbon Springs Vineyard Pinot Noir",
  "Aetna Springs Cellars Cabernet Sauvignon",
  "Aglianico del Vulture Cantine del Notaio Il Repertorio",
  "Agrapart & Fils 7 Crus Brut Blanc de Blancs",
  "Agrapart & Fils Terroirs Blanc de Blancs Grand Cru Extra Brut",
  "Aia Vecchia Vermentino",
  "Akarua Pinot Noir",
  "Alain Brumont Bouscassé Madiran",
  "Alamos Malbec",
  "Alban Vineyards Estate Syrah",
  "Alban Vineyards Grenache",
  "Alban Vineyards Reva Syrah",
  "Alban Vineyards Viognier",
  "Albert Bichot Chambolle-Musigny",
  "Albert Bichot Corton-Charlemagne Grand Cru",
  "Albert Bichot Gevrey-Chambertin",
  "Albert Bichot Savigny-les-Beaune",
  "Albert Bichot Savigny-lès-Beaune",
  "Albert Boxler Riesling Brand Grand Cru",
  "Albert Boxler Riesling Réserve",
  "Albert Boxler Riesling Sommerberg Grand Cru",
  "Albert Mann Alsace Riesling",
  "Albert Mann Gewurztraminer Furstentum Grand Cru",
  "Albert Mann Pinot Noir Les Saintes Claires",
  "Albert Mann Riesling Schlossberg Grand Cru",
  "Albino Rocca Barbaresco Ronchi",
  "Aldo Conterno Barbera d'Alba",
  "Alexana Winery Revana Vineyard Pinot Noir",
  "Alexander Valley Vineyards Cabernet Sauvignon",
  "Alexander Valley Vineyards Chardonnay",
  "Alexander Valley Vineyards Zinfandel",
  "Alfaro Family Vineyards Pinot Noir",
  "Alfred Gratien Brut",
  "Alfred Gratien Cuvée Paradis Brut",
  "All Saints Estate Museum Muscat",
  "Allan Scott Sauvignon Blanc",
  "Allegrini Amarone della Valpolicella",
  "Allegrini Amarone della Valpolicella Classico La Poja",
  "Allegrini La Poja",
  "Allegrini La Poja Veronese",
  "Allegrini Palazzo della Torre Veronese",
  "Allegrini Recioto della Valpolicella",
  "Allegrini Soave Classico",
  "Allegrini Valpolicella Classico",
  "Allesverloren Tinta Barocca",
  "Alloro Vineyard Pinot Noir",
  "Almaviva Almaviva",
  "Almaviva EPU",
  "Almaviva Puente Alto",
  "Alois Lageder Krafuss Pinot Noir Alto Adige",
  "Alois Lageder Lagrein Alto Adige",
  "Alois Lageder Pinot Grigio",
  "Alpamanta Natal Malbec",
  "Alpha Estate Xinomavro",
  "Alpha Omega Winery Cabernet Sauvignon",
  "Alpha Omega Winery Proprietary Red Blend",
  "Alphonse Mellot Sancerre Generation XIX",
  "Alphonse Mellot Sancerre La Moussiere",
  "Alphonse Mellot Sancerre La Moussière",
  "Alta Vista Torrontes",
  "Altesino Brunello di Montalcino",
  "Alvaro Castro Dão Reserva",
  "Alvaro Castro Dão Tinto",
  "Alvaro Palacios L'Ermita",
  "Alvaro Palacios Les Terrasses",
  "Alvaro Palacios Rioja",
  "Alvear Pedro Ximenez Montilla-Moriles",
  "Alysian Wines Pinot Noir",
  "Alzinger Grüner Veltliner Smaragd",
  "Amador Foothill Winery Rosé of Sangiovese",
  "Amador Foothill Winery Zinfandel",
  "Amavi Cellars Cabernet Sauvignon",
  "Amelia Park Wines Reserve Cabernet Sauvignon",
  "Ameztoi Txakoli Rubentis",
  "Ampelos Cellars Chardonnay",
  "Ampelos Cellars Pinot Noir",
  "Anakota Helena Montana Cabernet",
  "Anam Cara Cellars Riesling",
  "Ancien Wines Cabernet Sauvignon",
  "Ancien Wines Pinot Noir",
  "Ancient Peaks Merlot",
  "Anderson Family Vineyard Pinot Noir",
  "Andrew Murray Vineyards Esperance",
  "Andrew Murray Vineyards Syrah",
  "Andrew Murray Vineyards Tous les Jours Syrah",
  "Andrew Rich Wines Pinot Gris",
  "Andrew Will Cabernet Sauvignon",
  "Andrew Will Ciel du Cheval",
  "Andrew Will Winery Cabernet Sauvignon",
  "André et Mireille Tissot Arbois Trousseau",
  "Angels Gate Winery Cabernet Franc",
  "Anne Amie Vineyards Pinot Noir",
  "Anne Gros Clos de Vougeot Grand Cru",
  "Anne Gros Richebourg Grand Cru",
  "Anne Gros Vosne-Romanée",
  "Anomaly Vineyards Cabernet Sauvignon",
  "Anselmi San Vincenzo",
  "Anselmo Mendes Contacto Alvarinho",
  "Anselmo Mendes Muros de Vinho Verde",
  "Anthonij Rupert Optima",
  "Anthony Road Wine Company Dry Riesling",
  "Antica Terra Ceras Pinot Noir",
  "Antica Terra Chardonnay",
  "Antica Terra Pinot Noir",
  "Antinori Badia a Passignano Chianti Classico Gran Selezione",
  "Antinori Bramito della Sala Umbria Chardonnay",
  "Antinori Cervaro della Sala Umbria",
  "Antinori Chianti Classico Riserva",
  "Antinori Guado al Tasso Bolgheri",
  "Antinori Guado al Tasso Bolgheri Superiore",
  "Antinori Matarocchio Bolgheri Superiore",
  "Antinori Montenisa Franciacorta Brut",
  "Antinori Pian delle Vigne Brunello di Montalcino",
  "Antinori Pian delle Vigne Rosso di Montalcino",
  "Antinori Pèppoli Chianti Classico",
  "Antinori Santa Cristina",
  "Antinori Santa Cristina Rosso",
  "Antinori Santa Cristina Toscana",
  "Antinori Scalabrone Bolgheri Rosato",
  "Antinori Scalabrone Rosé",
  "Antinori Solaia",
  "Antinori Tenuta Guado al Tasso Il Bruciato Bolgheri",
  "Antinori Tenuta Guado al Tasso Vermentino",
  "Antinori Tignanello",
  "Antinori Villa Antinori Bianco Toscana",
  "Antinori Villa Antinori Chianti Classico Riserva",
  "Antonin Rodet Mercurey Rouge",
  "Antoniolo Gattinara",
  "Antoniolo Gattinara Castelle",
  "Antoniolo Gattinara Osso San Grato Riserva",
  "Antoniolo Gattinara San Francesco Riserva",
  "Apaltagua Envero Carmenère",
  "Apaltagua Gran Reserva Carmenère",
  "Aphros Vinho Verde Loureiro",
  "Apothic Red Blend",
  "Apothic White Blend",
  "Archery Summit Pinot Noir",
  "Archery Summit Premier Cuvée Pinot Noir",
  "Archery Summit Red Hills Estate Pinot Noir",
  "Argiano Brunello di Montalcino",
  "Argiano Rosso di Montalcino",
  "Argiano Solengo Toscana",
  "Argiolas Angialis Nasco di Cagliari",
  "Argiolas Cannonau di Sardegna Costera",
  "Argiolas Costera Cannonau di Sardegna",
  "Argiolas Is Argiolas Vermentino di Sardegna",
  "Argiolas Korem Bovale Isola dei Nuraghi",
  "Argiolas Serra Lori Cannonau Rosato",
  "Argiolas Turriga IGT Sardegna",
  "Argiolas Vermentino di Sardegna Costamolino",
  "Argyle Winery Brut",
  "Argyle Winery Chardonnay",
  "Argyle Winery Extended Tirage Brut",
  "Argyle Winery Pinot Noir",
  "Argyle Winery Reserve Chardonnay",
  "Argyle Winery Reserve Pinot Noir",
  "Argyros Atlantis Assyrtiko",
  "Argyros Santorini Assyrtiko",
  "Arietta On the White Keys Red Wine",
  "Arista Winery Pinot Noir",
  "Arnaldo Caprai Collepiano Sagrantino",
  "Arnaldo Caprai Collepiano Sagrantino di Montefalco",
  "Arnaldo Caprai Grecante Grechetto dei Colli Martani",
  "Arnaldo Caprai Montefalco Rosso",
  "Arnot-Roberts Cabernet Sauvignon",
  "Arnot-Roberts Chardonnay",
  "Arpepe Valtellina Superiore Grumello",
  "Arrowood Vineyards & Winery Cabernet Sauvignon",
  "Arrowood Vineyards Cabernet Sauvignon",
  "Artadi Pagos Viejos",
  "Artadi Rioja Crianza",
  "Artadi Viña El Pisón",
  "Arterberry Maresh Chardonnay",
  "Artesa Vineyards Pinot Noir",
  "Artesa Vineyards Reserve Cabernet Sauvignon",
  "Arzuaga Crianza Ribera del Duero",
  "Astrolabe Marlborough Sauvignon Blanc",
  "Astrolabe Province Sauvignon Blanc",
  "Ata Rangi Craighall Chardonnay",
  "Ata Rangi Crimson Pinot Noir",
  "Ata Rangi Pinot Noir",
  "Ataraxia Chardonnay",
  "Ataraxia Sauvignon Blanc",
  "Atelier Melka Métisse Red Wine",
  "Atlas Peak Vineyards Cabernet Sauvignon",
  "Au Bon Climat Chardonnay",
  "Au Bon Climat Knox Alexander Chardonnay",
  "Au Bon Climat Pinot Noir",
  "Aubert Lauren Estate Vineyard Chardonnay",
  "Aubert UV-SL Vineyard Chardonnay",
  "Aubert Wines Chardonnay",
  "Auguste Clape Cornas",
  "Auguste Clape Cornas Renaissance",
  "Auntsfield Sauvignon Blanc",
  "Austin Hope Cabernet Sauvignon",
  "Avalon Winery Cabernet Sauvignon",
  "Avantis Estate Syrah",
  "Avantis Syrah",
  "Aveleda Casal Garcia Vinho Verde",
  "Aveleda Vinho Verde",
  "Avignonesi Grandi Annate Vino Nobile di Montepulciano Riserva",
  "Avignonesi Rosso di Montepulciano",
  "Avignonesi Vin Santo di Montepulciano Occhio di Pernice",
  "Avignonesi Vino Nobile di Montepulciano",
  "Azienda Agricola COS Cerasuolo di Vittoria",
  "B.R. Cohn Winery Olive Hill Estate Cabernet Sauvignon",
  "BRAND Cabernet Sauvignon",
  "BV Napa Valley Georges de Latour Private Reserve Cabernet Sauvignon",
  "BV Napa Valley Napa Valley Cabernet Sauvignon",
  "Babcock Winery Grand Cuvée Pinot Noir",
  "Babcock Winery Pinot Noir",
  "Babich Black Label Sauvignon Blanc",
  "Babich Hawke's Bay Merlot",
  "Babich Sauvignon Blanc",
  "Babich Wines Sauvignon Blanc",
  "Babylon's Peak Syrah",
  "Bachelet-Monnot Chassagne-Montrachet",
  "Bacio Divino Cellars Bacio Divino Red Wine",
  "Bacio Divino Napa Valley Red",
  "Badia a Coltibuono Chianti Classico",
  "Badia a Coltibuono Chianti Classico Riserva",
  "Badia a Coltibuono Sangioveto Toscana",
  "Baldacci Family Vineyards Cabernet Sauvignon",
  "Baldacci Family Vineyards Thomas Cabernet Sauvignon",
  "Balletto Vineyards Pinot Gris",
  "Balletto Vineyards Pinot Noir",
  "Balnaves of Coonawarra The Tally Reserve Cabernet Sauvignon",
  "Balthasar Ress Rüdesheimer Berg Schlossberg Riesling Kabinett",
  "Banfi Belnero",
  "Banfi Brunello di Montalcino",
  "Banfi Brunello di Montalcino Poggio all'Oro Riserva",
  "Banfi Brunello di Montalcino Riserva",
  "Banfi Centine Rosso Toscana",
  "Banfi Chianti Classico Riserva",
  "Banfi Col di Sasso",
  "Banfi Col di Sasso Toscana",
  "Banfi Excelsus Toscana",
  "Banfi Florus Moscadello di Montalcino",
  "Banfi Fumaio Pinot Grigio-Chardonnay Toscana",
  "Banfi Principesco Rosso d'Italia",
  "Banfi Rosa Regale Brachetto d'Acqui",
  "Banfi Rosso di Montalcino",
  "Banfi Serena Pinot Grigio delle Venezie",
  "Banfi Summus Toscana",
  "Bannockburn Chardonnay",
  "Bannockburn Pinot Noir",
  "Banrock Station Shiraz",
  "Barboursville Vineyards Cabernet Franc",
  "Barboursville Vineyards Merlot",
  "Barboursville Vineyards Octagon",
  "Barca Velha Barca Velha",
  "Barefoot Cabernet Sauvignon",
  "Barefoot Cellars Cabernet Sauvignon",
  "Barefoot Cellars Chardonnay",
  "Barefoot Cellars Rosé",
  "Barmes-Buecher Gewurztraminer Rosenberg",
  "Barmes-Buecher Riesling Hengst Grand Cru",
  "Barnard Griffin Cabernet Sauvignon",
  "Barnard Griffin Merlot",
  "Barnard Griffin Rosé of Sangiovese",
  "Barnett Vineyards Cabernet Sauvignon",
  "Baron Philippe de Rothschild Escudo Rojo Reserva",
  "Baron de Lestac Bordeaux Rouge",
  "Barone Ricasoli Brolio Chianti Classico",
  "Barone Ricasoli Castello di Brolio Chianti Classico Gran Selezione",
  "Barone Ricasoli Chianti Classico Gran Selezione Colledilà",
  "Barone Ricasoli Chianti Classico Gran Selezione Rocca Guicciarda",
  "Barone Ricasoli Formulae Chardonnay Toscana",
  "Bartolo Mascarello Barolo",
  "Basel Cellars Cabernet Sauvignon",
  "Basilisco Teodosio Aglianico del Vulture",
  "Bass Phillip Estate Pinot Noir",
  "Bass Phillip Premium Pinot Noir",
  "Bassermann-Jordan Forster Jesuitengarten Riesling",
  "Battaglini Estate Zinfandel",
  "Beaulieu Vineyard Georges de Latour Private Reserve Cabernet Sauvignon",
  "Beaulieu Vineyard Maestro Collection Cabernet Sauvignon",
  "Beaulieu Vineyard Reserve Chardonnay",
  "Beaulieu Vineyard Tapestry Reserve",
  "Beaux Frères Pinot Noir",
  "Beaux Frères The Beaux Frères Vineyard Pinot Noir",
  "Becker Pinot Noir Spätburgunder",
  "Becker Vineyards Cabernet Sauvignon",
  "Becker Vineyards Cabernet Sauvignon Reserve",
  "Beckmen Vineyards Purisima Mountain Grenache",
  "Beckmen Vineyards Purisima Mountain Vineyard Syrah",
  "Beckmen Vineyards Syrah",
  "Bedell Cellars Cabernet Franc",
  "Bedell Cellars Chardonnay",
  "Bedell Cellars Merlot",
  "Bedrock Wine Co Rosé",
  "Bedrock Wine Co. Evangelho Vineyard Zinfandel",
  "Bedrock Wine Co. Heritage Red Blend",
  "Bedrock Wine Co. Sonoma Valley Old Vine Zinfandel",
  "Bedrock Wine Company Pagani Ranch Heritage",
  "Bedrock Wine Company Sonoma Valley Syrah",
  "Begali Amarone della Valpolicella Classico",
  "Behrens Family Winery Cabernet Sauvignon",
  "Bekkers Syrah",
  "Belden Barns Sauvignon Blanc",
  "Bellavista Franciacorta Brut",
  "Bellbird Spring Pinot Noir",
  "Belle Glos Clark & Telephone Pinot Noir",
  "Belle Glos Dairyman Pinot Noir",
  "Belle Glos Las Alturas Pinot Noir",
  "Belondrade y Lurton Rueda Verdejo",
  "Belondrade y Lurton Verdejo",
  "BenMarco Expresivo",
  "Benanti Etna Bianco Superiore",
  "Benanti Etna Rosso",
  "Benanti Etna Rosso Serra della Contessa",
  "Benanti Pietramarina Etna Bianco Superiore",
  "Benanti Serra della Contessa",
  "Benegas Lynch Malbec",
  "Benessere Vineyards Black Glass Vineyard Cabernet Sauvignon",
  "Benessere Vineyards Cabernet Sauvignon",
  "Benmarco Malbec",
  "Bennett Lane Winery Maximus Red Feasting Wine",
  "Benovia Winery Pinot Noir",
  "Benziger Family Winery Cabernet Sauvignon",
  "Benziger Family Winery Chardonnay",
  "Berberana Dragon Tempranillo",
  "Beresan Winery Cabernet Sauvignon",
  "Bergstrom Wines Cumberland Reserve Pinot Noir",
  "Bergstrom Wines Sigrid Chardonnay",
  "Bergström Wines Bergström Vineyard Pinot Noir",
  "Bergström Wines Cumberland Reserve Pinot Noir",
  "Bergström Wines Old Stones Pinot Noir",
  "Beringer Founders Estate Cabernet Sauvignon",
  "Beringer Knight's Valley Cabernet Sauvignon",
  "Beringer Main & Vine Chardonnay",
  "Beringer Napa Valley Merlot",
  "Beringer Vineyards Bancroft Ranch Merlot",
  "Beringer Vineyards Chabot Vineyard Cabernet Sauvignon",
  "Beringer Vineyards Knights Valley Cabernet Sauvignon",
  "Beringer Vineyards Napa Valley Chardonnay",
  "Beringer Vineyards Nightingale Semillon Sauvignon Blanc",
  "Beringer Vineyards Private Reserve Cabernet Sauvignon",
  "Beringer Vineyards Private Reserve Chardonnay",
  "Beringer Vineyards Quantum Red Wine",
  "Beringer Vineyards White Zinfandel",
  "Bernard Morey Chassagne-Montrachet Les Embrazes Premier Cru",
  "Bernardus Winery Pinot Noir",
  "Bertagna Nuits-Saint-Georges",
  "Bertani Amarone della Valpolicella",
  "Bertani Amarone della Valpolicella Classico",
  "Bertani Amarone della Valpolicella Classico Riserva",
  "Bertani Due Uve Pinot Grigio-Garganega",
  "Bertani Secco Bertani Vintage Edition",
  "Bertani Soave Classico",
  "Bertani Valpolicella Ripasso",
  "Best's Wines Great Western Shiraz",
  "Best's Wines Shiraz",
  "Best's Wines Thomson Family Shiraz",
  "Bethany Wines Shiraz",
  "Bethel Heights Vineyard Chardonnay",
  "Bethel Heights Vineyard Estate Pinot Noir",
  "Bethel Heights Vineyard Pinot Noir",
  "Bethel Heights Vineyard Southeast Block Reserve Pinot Noir",
  "Betz Family Winery Clos de Betz",
  "Betz Family Winery Pere de Famille Cabernet",
  "Betz Family Winery Père de Famille Cabernet Sauvignon",
  "Beyerskloof Pinotage",
  "Beyerskloof Pinotage Reserve",
  "Bibi Graetz Colore Toscana",
  "Bibi Graetz Testamatta",
  "Biblia Chora Areti White",
  "Bichot Clos de la Roche Grand Cru",
  "Bien Nacido Vineyard Chardonnay",
  "Bien Nacido Vineyard Pinot Noir",
  "Billecart-Salmon Blanc de Blancs",
  "Billecart-Salmon Brut Rosé",
  "Billecart-Salmon Brut Réserve",
  "Billecart-Salmon Clos Saint-Hilaire Blanc de Noirs",
  "Billecart-Salmon Nicolas François Billecart Vintage Brut",
  "Bindi Block 5 Pinot Noir",
  "Bindi Original Vineyard Pinot Noir",
  "Biondi Santi Brunello di Montalcino",
  "Biondi Santi Rosso di Montalcino",
  "Biondi-Santi Brunello di Montalcino",
  "Biondi-Santi Rosso di Montalcino",
  "Bisol Jeio Prosecco",
  "Bisol Prosecco di Valdobbiadene Superiore Brut",
  "Black Ankle Vineyards Crumbling Rock",
  "Black Box Wines Cabernet Sauvignon",
  "Black Box Wines Chardonnay",
  "Black Box Wines Sauvignon Blanc",
  "Black Estate Pinot Noir",
  "Blandy's 10 Year Old Malmsey Madeira",
  "Blandy's 15 Year Old Bual Madeira",
  "Blandy's 5 Year Old Dry Sercial Madeira",
  "Blankiet Estate Proprietary Red Wine",
  "Bodega Colome Auténtico Malbec",
  "Bodega El Esteco Don David Reserve Torrontés",
  "Bodegas 1898 Crianza",
  "Bodegas Aalto Ribera del Duero",
  "Bodegas Alejandro Fernández Pesquera Tinto Reserva",
  "Bodegas Alto Moncayo Garnacha",
  "Bodegas Artadi Rioja El Pisón",
  "Bodegas Artadi Rioja Viñas de Gain",
  "Bodegas Artevino Orben Rioja",
  "Bodegas Arzuaga Gran Reserva",
  "Bodegas Arzuaga La Planta",
  "Bodegas Arzuaga Reserva",
  "Bodegas As Laxas Albariño",
  "Bodegas Beronia Reserva",
  "Bodegas Beronia Rioja Reserva",
  "Bodegas Bilbainas La Vicalanda Gran Reserva",
  "Bodegas Bilbainas Viña Pomal Crianza",
  "Bodegas Bilbaínas La Vicalanda Gran Reserva",
  "Bodegas Carrau Tannat",
  "Bodegas Coto de Imaz Rioja Gran Reserva",
  "Bodegas Descendientes de J. Palacios Pétalos del Bierzo",
  "Bodegas El Porvenir Laborum Torrontés",
  "Bodegas Faustino Faustino I Gran Reserva",
  "Bodegas Faustino Faustino V Reserva",
  "Bodegas Godelia Mencía Godelia",
  "Bodegas Godeval Godello",
  "Bodegas Heretat de Cesilia Monastrell",
  "Bodegas Hermanos Peciña Gran Reserva",
  "Bodegas Hermanos Peciña Reserva",
  "Bodegas Hidalgo Amontillado Napoleon",
  "Bodegas Hidalgo La Gitana Manzanilla",
  "Bodegas Hidalgo La Gitana Wellington Manzanilla",
  "Bodegas Izadi Rioja El Regalo",
  "Bodegas Juan Gil Blue Label Monastrell",
  "Bodegas Juan Gil Monastrell",
  "Bodegas LAN Culmen Reserva",
  "Bodegas LAN Gran Reserva",
  "Bodegas LAN Rioja Crianza",
  "Bodegas LAN Rioja Reserva",
  "Bodegas Luberri Rioja Crianza",
  "Bodegas Manas Frontonio El Puente Garnacha",
  "Bodegas Marqués de Griñón Syrah",
  "Bodegas Maurodos Prima",
  "Bodegas Maurodos San Román",
  "Bodegas Menade Verdejo",
  "Bodegas Montecillo Rioja Crianza",
  "Bodegas Montecillo Rioja Gran Reserva",
  "Bodegas Muga Rioja Blanco",
  "Bodegas Muga Rioja Gran Reserva",
  "Bodegas Muga Torre Muga",
  "Bodegas Mustiguillo Finca Terrerazo Bobal",
  "Bodegas Mustiguillo Mestizaje",
  "Bodegas Naverán Cava Brut Nature",
  "Bodegas Nieto Senetiner Malbec",
  "Bodegas Olarra Cerro Anon Rioja Reserva",
  "Bodegas Olarra Cerro Añon Rioja Reserva",
  "Bodegas Ostatu Gloria",
  "Bodegas Ostatu Reserva",
  "Bodegas Ostatu Rioja Blanco",
  "Bodegas Palacios Remondo La Montesa Rioja",
  "Bodegas Palacios Remondo La Vendimia",
  "Bodegas Palacios Remondo Propiedad Rioja",
  "Bodegas Pesquera Gran Reserva",
  "Bodegas Pesquera Janus Gran Reserva",
  "Bodegas Pesquera Reserva",
  "Bodegas Piqueras Black Label Almansa",
  "Bodegas Porta Ribeira Sacra",
  "Bodegas Protos Ribera del Duero Reserva",
  "Bodegas Remirez de Ganuza Rioja Blanco Reserva",
  "Bodegas Renacer Punto Final Malbec",
  "Bodegas Robles Flor de Montilla Fino",
  "Bodegas Roda Cirsion",
  "Bodegas Roda Roda I Reserva",
  "Bodegas Roda Roda Reserva",
  "Bodegas Salentein Portillo Malbec",
  "Bodegas Salentein Reserve Malbec",
  "Bodegas Terras Gauda O Rosal Albariño",
  "Bodegas Toro Albalá Don PX Pedro Ximénez",
  "Bodegas Torres Sangre de Toro",
  "Bodegas Tradicion VORS Palo Cortado Sherry",
  "Bodegas Valduero Ribera del Duero Reserva",
  "Bodegas Vinedos del Contino Rioja Reserva",
  "Bodegas Zárate Albariño Rias Baixas",
  "Bodegas y Viñedos Pintia Toro",
  "Boekenhoutskloof Cabernet Sauvignon",
  "Boekenhoutskloof Syrah",
  "Boekenhoutskloof The Chocolate Block",
  "Boekenoogen Wines Pinot Noir",
  "Boen Pinot Noir",
  "Boeschen Vineyards Cabernet Sauvignon",
  "Bogle Vineyards Cabernet Sauvignon",
  "Bogle Vineyards Chardonnay",
  "Bogle Vineyards Essential Red",
  "Bogle Vineyards Old Vine Zinfandel",
  "Bogle Vineyards Petite Sirah",
  "Bogle Vineyards Phantom",
  "Bogle Vineyards Phantom Red Blend",
  "Bogle Vineyards Sauvignon Blanc",
  "Bolla Amarone della Valpolicella",
  "Bolla Soave",
  "Bollinger La Grande Annee",
  "Bollinger La Grande Année Rosé",
  "Bollinger R.D. Extra Brut",
  "Bollinger Rosé Brut",
  "Bollinger Special Cuvée Brut",
  "Bonaccorsi Wine Company Pinot Noir",
  "Bond Estates Melbury",
  "Bond Estates Pluribus",
  "Bonny Doon Vin Gris de Cigare Rosé",
  "Bonny Doon Vineyard Clos de Gilroy Grenache",
  "Bonny Doon Vineyard Le Cigare Volant",
  "Bonny Doon Vineyard Muscat Vin de Glacière",
  "Bonterra Organic Vineyards Cabernet Sauvignon",
  "Bonterra Organic Vineyards Chardonnay",
  "Bonterra Organic Vineyards Merlot",
  "Booker Vineyard My Favorite Neighbor",
  "Booker Vineyard Oublie",
  "Borgogno Barbera d'Alba",
  "Borgogno Barolo",
  "Borgogno Barolo Fossati",
  "Borgogno Barolo Liste",
  "Borgogno Barolo Riserva",
  "Borgogno Dolcetto d'Alba",
  "Borgogno Langhe Freisa",
  "Borsao Tres Picos Garnacha",
  "Boscarelli Vino Nobile di Montepulciano",
  "Boscarelli Vino Nobile di Montepulciano Costa Grande",
  "Boscarelli Vino Nobile di Montepulciano Il Nocio",
  "Boschendal Chardonnay",
  "Boschendal Jean Garde Chardonnay",
  "Boschendal Sommelier Selection Chardonnay",
  "Bota Box Chardonnay",
  "Bota Box Nighthawk Black Cabernet Sauvignon",
  "Bota Box Pinot Grigio",
  "Bota Box Pinot Noir",
  "Botromagno Primitivo",
  "Bouchaine Vineyards Pinot Noir",
  "Bouchard Finlayson Blanc de Mer",
  "Bouchard Finlayson Tête de Cuvée Galpin Peak Pinot Noir",
  "Bouchard Pere & Fils Nuits-Saint-Georges",
  "Bouchard Pere Fils Le Montrachet Grand Cru",
  "Bouchard Pere Fils Meursault Genevrieres Premier Cru",
  "Bouchard Père & Fils Beaune Grèves Vigne de l'Enfant Jésus",
  "Bouchard Père & Fils Beaune du Château Premier Cru",
  "Bouchard Père & Fils Bourgogne Pinot Noir La Vignée",
  "Bouchard Père & Fils Chambertin-Clos de Bèze Grand Cru",
  "Bouchard Père & Fils Corton-Charlemagne Grand Cru",
  "Bouchard Père & Fils Gevrey-Chambertin",
  "Bouchard Père & Fils Meursault",
  "Bouchard Père & Fils Volnay Caillerets Ancienne Cuvée Carnot Premier Cru",
  "Boutari Naoussa Xinomavro",
  "Bouza Monte Vide Eu Tannat",
  "Braida Barbera d'Asti Bricco dell'Uccellone",
  "Braida Barbera d'Asti Montebruna",
  "Braida Bricco dell'Uccellone Barbera",
  "Braida Moscato d'Asti",
  "Brancaia Chianti Classico",
  "Brancaia Il Blu",
  "Brancaia Il Blu Toscana",
  "Brancaia Tre",
  "Brancaia Tre Toscana",
  "Brancott Estate Sauvignon Blanc",
  "Brassfield Estate Winery Cabernet Sauvignon",
  "Bread & Butter Wines Cabernet Sauvignon",
  "Bread & Butter Wines Chardonnay",
  "Bread & Butter Wines Pinot Noir",
  "Breggo Cellars Pinot Noir",
  "Bret Brothers Saint-Veran",
  "Brewer-Clifton Chardonnay",
  "Brewer-Clifton Pinot Noir",
  "Brian Carter Cellars Solesce",
  "Brick House Wine Company Cuvée du Tonnelier Pinot Noir",
  "Brick House Wine Company Pinot Noir",
  "Brickhouse Wine Company Pinot Noir",
  "Brigaldara Amarone della Valpolicella",
  "Brittan Vineyards Pinot Noir",
  "Broadbent 10 Year Old Malmsey Madeira",
  "Broadbent Rainwater Medium Dry Madeira",
  "Broadbent Vinho Verde",
  "Broadley Vineyards Claudia's Choice Pinot Noir",
  "Broadley Vineyards Pinot Noir",
  "Broglia Gavi La Meirana",
  "Broken Earth Winery Cabernet Sauvignon",
  "Brokenwood Cricket Pitch Cabernet Sauvignon Shiraz",
  "Brokenwood Cricket Pitch Red",
  "Brokenwood Graveyard Vineyard Shiraz",
  "Brooks Wine Pinot Noir",
  "Brooks Wines Ara Pinot Noir",
  "Brooks Wines Pinot Noir",
  "Broquel Malbec",
  "Brovia Barolo Rocche di Castiglione",
  "Brovia Barolo Villero",
  "Brown Brothers Prosecco",
  "Brown Estate Cabernet Sauvignon",
  "Browne Family Vineyards Cabernet Sauvignon",
  "Bruliam Wines Pinot Noir",
  "Brundlmayer Grüner Veltliner Lamm",
  "Bruno Clair Gevrey-Chambertin Clos Saint-Jacques Premier Cru",
  "Bruno Clair Marsannay Rouge",
  "Bruno Giacosa Barbaresco",
  "Bruno Giacosa Barbaresco Asili",
  "Bruno Giacosa Barbaresco Rabajà",
  "Bruno Giacosa Barbaresco Santo Stefano",
  "Bruno Giacosa Barbaresco Santo Stefano Riserva",
  "Bruno Giacosa Barbera d'Alba",
  "Bruno Giacosa Barolo Falletto",
  "Bruno Giacosa Roero Arneis",
  "Bruno Rocca Barbaresco Coparossa",
  "Bryant Family Cabernet Sauvignon",
  "Bryant Family Vineyard Cabernet Sauvignon",
  "Bründlmayer Riesling Heiligenstein",
  "Bründlmayer Riesling Langenlois",
  "Bucci Verdicchio dei Castelli di Jesi Classico",
  "Bucklin Old Hill Ranch Zinfandel",
  "Buena Vista Winery Cabernet Sauvignon",
  "Buena Vista Winery Chardonnay",
  "Buitenverwachting Christine",
  "Burgans Albarino",
  "Burge Family Draycott Shiraz",
  "Burgess Cellars Cabernet Sauvignon",
  "Burgess Cellars Chardonnay",
  "Burgess Cellars Syrah",
  "Burgáns Albariño",
  "Burklin-Wolf Riesling GG",
  "Burlotto Barolo",
  "Burn Cottage Pinot Noir",
  "Burrowing Owl Estate Merlot",
  "Buttonwood Farm Cabernet Franc",
  "Buttonwood Farm Merlot",
  "Buty Winery Cabernet Sauvignon",
  "Buty Winery Rediviva of the Stones",
  "By Farr Farrside Pinot Noir",
  "By Farr Sangreal Pinot Noir",
  "Bürklin-Wolf Kirchenstück Riesling Grosses Gewächs",
  "Bürklin-Wolf Pechstein Riesling Grosses Gewächs",
  "Bürklin-Wolf Riesling Trocken",
  "COS Cerasuolo di Vittoria",
  "COS Pithos Rosso Sicilia",
  "CVNE Cune Crianza",
  "CVNE Cune Rioja Crianza",
  "CVNE Imperial Gran Reserva",
  "CVNE Imperial Reserva",
  "CVNE Imperial Rioja Reserva",
  "CVNE Viña Real Gran Reserva",
  "Ca dei Frati Lugana",
  "Ca' dei Frati I Frati Lugana",
  "Ca' dei Frati Lugana I Frati",
  "Ca' del Bosco Franciacorta Annamaria Clementi Rosé Riserva",
  "Ca' del Bosco Franciacorta Cuvee Prestige",
  "Ca' del Bosco Franciacorta Cuvée Prestige Brut",
  "Ca'Viola Barolo Sottocastello di Novello",
  "Ca'Viola Dolcetto d'Alba Barturot",
  "Cadaretta Cabernet Sauvignon",
  "Cade Estate Howell Mountain Cabernet Sauvignon",
  "Cade Estate Winery Cabernet Sauvignon",
  "Cadence Bel Canto",
  "Cadence Winery Bel Canto",
  "Cadence Winery Cabernet Sauvignon",
  "Cadence Winery Coda",
  "Cain Vineyard & Winery Cain Concept",
  "Cain Vineyard Cain Concept",
  "Cain Vineyard Cain Five",
  "Cakebread Cellars Cabernet Sauvignon",
  "Cakebread Cellars Chardonnay",
  "Cakebread Cellars Dancing Bear Ranch Cabernet Sauvignon",
  "Cakebread Cellars Reserve Chardonnay",
  "Cakebread Cellars Sauvignon Blanc",
  "Cakebread Cellars Two Creeks Vineyards Cabernet Sauvignon",
  "Cakebread Cellars Two Creeks Vineyards Pinot Noir",
  "Calcareous Vineyard Cabernet Sauvignon",
  "Caldwell Vineyard Cabernet Sauvignon",
  "Calera Wine Company Mount Harlan Pinot Noir",
  "Calera Wine Company Viognier",
  "Cambria Estate Winery Katherine's Vineyard Chardonnay",
  "Camel Valley Bacchus",
  "Cameron Winery Pinot Noir",
  "Camille Giroud Gevrey-Chambertin",
  "Campo Viejo Rioja Tempranillo",
  "Campo di Sasso Cabernet Sauvignon Bolgheri",
  "Can Feixes Cava Blanc de Blancs",
  "Canalicchio di Sopra Brunello di Montalcino",
  "Canalicchio di Sopra Rosso di Montalcino",
  "Canoe Ridge Estate Cabernet Sauvignon",
  "Canoe Ridge Vineyard Cabernet Sauvignon",
  "Cantele Negroamaro Salento",
  "Cantele Primitivo Salento",
  "Cantele Salice Salentino",
  "Cantina Terlano Nova Domus Riserva Alto Adige",
  "Cantina Terlano Pinot Bianco",
  "Cantina Terlano Pinot Bianco Vorberg Riserva Alto Adige",
  "Cantina Terlano Sauvignon Blanc Alto Adige",
  "Cantina Terlano Terlaner Cuvée Alto Adige",
  "Cantina Tramin Gewurztraminer",
  "Cantina del Taburno Aglianico del Taburno",
  "Cantine Florio Targa Marsala",
  "Canyon Road Cabernet Sauvignon",
  "Canyon Road Chardonnay",
  "Caparzo Brunello di Montalcino",
  "Cape Chamonix Pinot Noir",
  "Cape Mentelle Cabernet Sauvignon",
  "Cape Mentelle Chardonnay",
  "Cape Point Vineyards Sauvignon Blanc",
  "Caraccioli Cellars Pinot Noir",
  "Cargasacchi Vineyard Pinot Noir",
  "Carl Loewen Loerscher Maximiner Klosterlay Riesling Kabinett",
  "Carl Loewen Longuicher Maximiner Herrenberg Riesling",
  "Carl Loewen Riesling Kabinett",
  "Carlisle Winery Two Acres Zinfandel",
  "Carlisle Winery Zinfandel",
  "Carmen Cabernet Sauvignon",
  "Carmen Gold Reserve Cabernet",
  "Caro Amancaya Malbec Cabernet",
  "Caro Aruma Malbec",
  "Caro Caro Malbec Cabernet",
  "Carobbio Chianti Classico",
  "Carol Shelton Karma Zinfandel",
  "Carol Shelton Wines Karma Zinfandel",
  "Carol Shelton Wines Wild Thing Zinfandel",
  "Carpineto Brunello di Montalcino Riserva",
  "Carpineto Chianti Classico Riserva",
  "Carpineto Vino Nobile di Montepulciano",
  "Carr Vineyards Chardonnay",
  "Cartuxa Pêra Manca Tinto",
  "Cartuxa Reserva Tinto",
  "Caruso & Minini Naturalmente Bio Nero d'Avola",
  "Casa Castillo Las Gravas",
  "Casa Castillo Monastrell",
  "Casa Ferreirinha Callabriga",
  "Casa Lapostolle Alexandre Cabernet Sauvignon",
  "Casa Lapostolle Alexandre Merlot",
  "Casa Lapostolle Atalayas de Pirque Cabernet",
  "Casa Lapostolle Clos Apalta",
  "Casa Lapostolle Cuvée Alexandre Cabernet Sauvignon",
  "Casa Silva Microterroir Carmenère",
  "Casa de Cello Vinho Verde",
  "Casal Branco Falcoaria Tinto",
  "Casal Garcia Vinho Verde",
  "Casanova di Neri Brunello di Montalcino",
  "Casanova di Neri Brunello di Montalcino Cerretalto",
  "Casanova di Neri Brunello di Montalcino Tenuta Nuova",
  "Casanova di Neri Rosso di Montalcino",
  "Casas del Bosque Reserva Sauvignon Blanc",
  "Cascina Garitina Nizza DOCG",
  "Cass Winery Grenache",
  "Cass Winery Rockin One Syrah",
  "Castaño Monastrell",
  "Castellare di Castellina Chianti Classico",
  "Castello Banfi Rosso di Montalcino",
  "Castello Vicchiomaggio Chianti Classico",
  "Castello dei Rampolla Chianti Classico",
  "Castello dei Rampolla D'Alceo Toscana",
  "Castello dei Rampolla Sammarco Toscana",
  "Castello della Sala Cervaro della Sala",
  "Castello di Ama Al Poggio Chardonnay",
  "Castello di Ama Chianti Classico",
  "Castello di Ama Chianti Classico Gran Selezione San Lorenzo",
  "Castello di Ama Chianti Classico Gran Selezione Vigneto La Casuccia",
  "Castello di Ama L'Apparita Merlot Toscana",
  "Castello di Amorosa Cabernet Sauvignon",
  "Castello di Bossi Chianti Classico Riserva Berardo",
  "Castello di Bossi Dimarco Toscana",
  "Castello di Brolio Chianti Classico",
  "Castello di Brolio Chianti Classico Gran Selezione",
  "Castello di Gabbiano Chianti Classico Riserva",
  "Castoro Cellars Cabernet Sauvignon",
  "Castoro Cellars Zinfandel",
  "Cataldi Madonna Montepulciano d'Abruzzo Toni",
  "Cataldi Madonna Toni Montepulciano d'Abruzzo",
  "Catena Zapata Adrianna Vineyard Malbec",
  "Catena Zapata Adrianna Vineyard River Stones Malbec",
  "Catena Zapata Adrianna Vineyard White Bones Chardonnay",
  "Catena Zapata Catena Alta Cabernet Sauvignon",
  "Catena Zapata Catena Alta Historic Rows Malbec",
  "Catena Zapata Catena Alta Malbec",
  "Catena Zapata Catena Cabernet Sauvignon",
  "Catena Zapata Malbec Argentino",
  "Catena Zapata Nicolas Catena Zapata",
  "Cavallotto Barolo Bricco Boschis",
  "Cave Spring CSV Riesling",
  "Cave Spring Chardonnay",
  "Cave de Rasteau Rasteau",
  "Cave de Turckheim Riesling Herrenweg",
  "Cavit Pinot Grigio",
  "Caymus Vineyards Bonanza Cabernet Sauvignon",
  "Caymus Vineyards Conundrum Red",
  "Caymus Vineyards Conundrum White",
  "Caymus Vineyards Napa Valley Cabernet Sauvignon",
  "Caymus Vineyards Special Selection Cabernet Sauvignon",
  "Cayuse Vineyards Cailloux Syrah",
  "Cecchi Chianti Classico",
  "Cecchi Chianti Classico Riserva",
  "Cecchi Morellino di Scansano",
  "Cecchi Storia di Famiglia Toscana",
  "Cederberg Bukettraube",
  "Cederberg Private Cellar Chenin Blanc",
  "Ceja Vineyards Carneros Chardonnay",
  "Celler de Capçanes Mas Collet",
  "Cerbaiona Brunello di Montalcino",
  "Ceretto Barbaresco Asij",
  "Ceretto Barbera d'Alba Piana",
  "Ceretto Barolo Bricco Rocche",
  "Ceretto Barolo Brunate",
  "Ceretto Barolo Prapo",
  "Ceretto Barolo Zonchera",
  "Ceretto Blangé Arneis",
  "Ceretto Blangé Rosé",
  "Ceretto Langhe Nebbiolo",
  "Ceretto Moscato d'Asti Monsordo",
  "Ceretto Rossana Dolcetto d'Alba",
  "Ceretto Santo Stefano Moscato d'Asti",
  "Cerise Cabernet Sauvignon",
  "Ceritas Chardonnay",
  "Ceritas Pinot Noir",
  "Ceritas Porter-Bass Chardonnay",
  "Ceritas Porter-Bass Vineyard Chardonnay",
  "Chalk Hill Estate Cabernet Sauvignon",
  "Chalk Hill Estate Chardonnay",
  "Chalone Vineyard Chardonnay",
  "Chambers Rosewood Rutherglen Muscat",
  "Chamonix Wine Farm Chardonnay",
  "Chandon Blanc de Noirs",
  "Chandon Brut Classic",
  "Chanson Père & Fils Savigny-lès-Beaune Premier Cru",
  "Chapel Down Brut NV",
  "Chapel Hill The Parson Shiraz",
  "Chapoutier Belleruche Cotes du Rhone",
  "Chapoutier Belleruche Côtes du Rhône Rouge",
  "Chapoutier Condrieu Invitare",
  "Chapoutier Crozes-Hermitage Les Meysonniers",
  "Chapoutier Deschants Saint-Joseph Rouge",
  "Chapoutier Hermitage Monier de la Sizeranne",
  "Chapoutier Les Meysonniers Crozes-Hermitage Rouge",
  "Chapter 24 Vineyards Pinot Noir",
  "Charles Heidsieck Blanc des Millenaires",
  "Charles Heidsieck Brut Millésimé",
  "Charles Heidsieck Brut Réserve",
  "Charles Joguet Chinon Clos de la Dioterie",
  "Charles Joguet Chinon Clos du Chêne Vert",
  "Charles Krug Winery Cabernet Sauvignon",
  "Charles Krug Winery Family Reserve Generations Cabernet Sauvignon",
  "Charles Melton Nine Popes",
  "Charles Melton Shiraz",
  "Charles Shaw Cabernet Sauvignon",
  "Charles Shaw Chardonnay",
  "Chartogne-Taillet Sainte Anne Brut",
  "Chateau Batailley Pauillac",
  "Chateau Bonnet Bordeaux Rouge",
  "Chateau Bourgneuf Pomerol",
  "Chateau Branaire-Ducru Saint-Julien",
  "Chateau Brane-Cantenac Margaux",
  "Chateau Calon-Segur Saint-Estephe",
  "Chateau Cantenac Brown Margaux",
  "Chateau Clerc Milon Pauillac",
  "Chateau Climens Barsac",
  "Chateau Felice Pinot Noir",
  "Chateau Feytit-Clinet Pomerol",
  "Chateau Fonroque Saint-Emilion Grand Cru",
  "Chateau Fuisse Pouilly-Fuisse",
  "Chateau Fuisse Pouilly-Fuisse Tete de Cru",
  "Chateau Gazin Pomerol",
  "Chateau Grand Mayne Saint-Emilion Grand Cru",
  "Chateau Grand-Puy-Lacoste Pauillac",
  "Chateau Gruaud Larose Saint-Julien",
  "Chateau Guillot Clauzel Pomerol",
  "Chateau Guiraud Sauternes",
  "Chateau Haut-Batailley Pauillac",
  "Chateau Haut-Marbuzet Saint-Estephe",
  "Chateau Kirwan Margaux",
  "Chateau La Couspaude Saint-Emilion Grand Cru",
  "Chateau La Nerthe Chateauneuf-du-Pape Blanc",
  "Chateau Langoa Barton Saint-Julien",
  "Chateau Lascombes Margaux",
  "Chateau Lynch-Moussas Pauillac",
  "Chateau Malescot St-Exupery Margaux",
  "Chateau Minuty M de Minuty Rose",
  "Chateau Montelena Cabernet Sauvignon",
  "Chateau Montelena Chardonnay",
  "Chateau Montelena Winery Cabernet Sauvignon",
  "Chateau Montelena Winery Chardonnay",
  "Chateau Montelena Winery Estate Cabernet Sauvignon",
  "Chateau Musar Blanc",
  "Chateau Musar Rouge",
  "Chateau Nenin Pomerol",
  "Chateau Pajzos Tokaji Aszu 5 Puttonyos",
  "Chateau Pedesclaux Pauillac",
  "Chateau Phelan Segur Saint-Estephe",
  "Chateau Pierre-Bise Anjou Blanc",
  "Chateau Pontet-Canet Pauillac",
  "Chateau Potelle Zinfandel",
  "Chateau Prieure-Lichine Margaux",
  "Chateau Puyfromage Francs Cotes de Bordeaux",
  "Chateau Rauzan-Segla Margaux",
  "Chateau Rayas Pignan",
  "Chateau Reynella Old Cave Tawny",
  "Chateau Rieussec Sauternes",
  "Chateau Roubine Lion and Dragon Rose",
  "Chateau Saint-Pierre Saint-Julien",
  "Chateau Siran Margaux",
  "Chateau Soutard Saint-Emilion Grand Cru",
  "Chateau Souverain Cabernet Sauvignon",
  "Chateau St. Jean Cabernet Sauvignon",
  "Chateau St. Jean Chardonnay",
  "Chateau St. Jean Cinq Cepages Cabernet Sauvignon",
  "Chateau St. Jean Robert Young Vineyard Chardonnay",
  "Chateau Ste. Michelle Canoe Ridge Estate Chardonnay",
  "Chateau Ste. Michelle Chardonnay",
  "Chateau Ste. Michelle Cold Creek Vineyard Cabernet Sauvignon",
  "Chateau Ste. Michelle Columbia Valley Cabernet Sauvignon",
  "Chateau Ste. Michelle Eroica Riesling",
  "Chateau Ste. Michelle Ethos Reserve Cabernet Sauvignon",
  "Chateau Ste. Michelle Ethos Reserve Riesling",
  "Chateau Ste. Michelle Harvest Select Riesling",
  "Chateau Ste. Michelle Indian Wells Cabernet Sauvignon",
  "Chateau Ste. Michelle Indian Wells Chardonnay",
  "Chateau Ste. Michelle Merlot",
  "Chateau Ste. Michelle Mimi Sparkling Brut",
  "Chateau Ste. Michelle Pinot Gris",
  "Chateau Ste. Michelle Riesling",
  "Chateau Ste. Michelle Riesling Columbia Valley",
  "Chateau Suduiraut Sauternes",
  "Chateau Talbot Saint-Julien",
  "Chateau Thivin Brouilly",
  "Chateau Troplong Mondot Saint-Emilion Grand Cru",
  "Chateau Trotanoy Pomerol",
  "Chateau Vannières Bandol Rose",
  "Chateau d'Aqueria Tavel Rose",
  "Chateau d'Armailhac Pauillac",
  "Chateau d'Esclans Rock Angel Rose",
  "Chateau d'Issan Margaux",
  "Chateau d'Yquem Sauternes",
  "Chateau de Coulaine Chinon",
  "Chateau de Fargues Sauternes",
  "Chateau de Fesles Bonnezeaux",
  "Chateau de Pibarnon Bandol Rose",
  "Chateau de Sales Pomerol",
  "Chateau de Tracy Pouilly-Fume",
  "Chateau des Jacques Moulin-a-Vent",
  "Chateau du Tertre Margaux",
  "Checkerboard Vineyards Cabernet Sauvignon",
  "Chehalem 3 Vineyard Pinot Noir",
  "Chehalem INOX Chardonnay",
  "Chehalem INOX Pinot Noir",
  "Chehalem Pinot Gris",
  "Chehalem Ridgecrest Vineyards Pinot Noir",
  "Chehalem Three Vineyard Pinot Noir",
  "Cheval des Andes Cheval des Andes",
  "Cheval des Andes Malbec Blend",
  "Cheval des Andes Mendoza",
  "Chimney Rock Winery Cabernet Sauvignon",
  "Chris Ringland Three Rivers Shiraz",
  "Christian Moreau Chablis Premier Cru Vaillons",
  "Christopher Creek Syrah",
  "Chronic Cellars Suite Petite",
  "Churchill's Douro Tinto",
  "Château Angludet Margaux",
  "Château Angélus Saint-Émilion Premier Grand Cru",
  "Château Beau-Séjour Bécot Saint-Émilion Premier Grand Cru",
  "Château Beaucastel Châteauneuf-du-Pape",
  "Château Beaucastel Hommage à Jacques Perrin Châteauneuf-du-Pape",
  "Château Belgrave Haut-Médoc",
  "Château Beychevelle Saint-Julien",
  "Château Bonnet Bordeaux Blanc",
  "Château Branaire-Ducru Saint-Julien",
  "Château Brane-Cantenac Margaux",
  "Château Calon-Ségur Saint-Estèphe",
  "Château Camensac Haut-Médoc",
  "Château Canon Saint-Émilion Grand Cru",
  "Château Cantemerle Haut-Médoc",
  "Château Cantemerle Haut-Médoc 5ème Grand Cru Classé",
  "Château Cantenac Brown Margaux",
  "Château Carbonnieux Pessac-Léognan Blanc",
  "Château Carsin Cadillac Côtes de Bordeaux",
  "Château Certan de May Pomerol",
  "Château Chasse-Spleen Moulis-en-Médoc",
  "Château Cheval Blanc Saint-Émilion Premier Grand Cru",
  "Château Clarke Listrac-Médoc",
  "Château Clerc Milon Pauillac",
  "Château Clos Fourtet Saint-Émilion Premier Grand Cru",
  "Château Cos d'Estournel Saint-Estèphe",
  "Château Coufran Haut-Médoc",
  "Château Desmirail Margaux",
  "Château Ducru-Beaucaillou Saint-Julien",
  "Château Durfort-Vivens Margaux",
  "Château Ferrière Margaux",
  "Château Figeac Saint-Émilion Grand Cru",
  "Château Fonroque Saint-Émilion Grand Cru",
  "Château Fortia Baron Leroy de Boiseaumarié",
  "Château Fortia Châteauneuf-du-Pape",
  "Château Fourcas Dupré Listrac-Médoc",
  "Château Fuissé Pouilly-Fuissé Tête de Cru",
  "Château Fuissé Tête de Cru Pouilly-Fuissé",
  "Château Galoupet Cru Classé Rosé",
  "Château Gigondas Gigondas",
  "Château Giscours La Sirène de Giscours",
  "Château Giscours Margaux",
  "Château Gloria Saint-Julien",
  "Château Greysac Cru Bourgeois Médoc",
  "Château Gruaud Larose Saint-Julien",
  "Château Grézan Faugères",
  "Château Haut-Bages Libéral Pauillac",
  "Château Haut-Bailly Pessac-Léognan",
  "Château Haut-Batailley Pauillac",
  "Château Haut-Brion Pessac-Léognan",
  "Château Haut-Ségur Bordeaux Supérieur",
  "Château Kirwan Margaux",
  "Château Ksara Cuvée du Troisième Millénaire",
  "Château L'Eglise-Clinet Pomerol",
  "Château La Conseillante Pomerol",
  "Château La Coste Rosé",
  "Château La Croix de Gay Pomerol",
  "Château La Dominique Saint-Émilion Grand Cru",
  "Château La Gaffelière Saint-Émilion Premier Grand Cru",
  "Château La Gordonne Pierrefeu Rosé",
  "Château La Gordonne Vérité du Terroir Rosé",
  "Château La Lagune Haut-Médoc",
  "Château La Nerthe Châteauneuf-du-Pape",
  "Château La Tour de Mons Margaux",
  "Château La Tour de l'Evêque Pétale de Rose",
  "Château Lafite Rothschild Pauillac",
  "Château Lafon-Rochet Saint-Estèphe",
  "Château Lagrange Saint-Julien",
  "Château Lanessan Haut-Médoc",
  "Château Larcis Ducasse Saint-Émilion Premier Grand Cru",
  "Château Larose-Trintaudon Haut-Médoc",
  "Château Larose-Trintaudon Haut-Médoc Cru Bourgeois",
  "Château Laroze Saint-Émilion Grand Cru",
  "Château Latour Pauillac",
  "Château Leoville Barton Réserve de Léoville",
  "Château Les Carmes-Haut-Brion Pessac-Léognan",
  "Château Les Ormes de Pez Saint-Estèphe",
  "Château Lynch Moussas Pauillac",
  "Château Lynch-Bages Pauillac",
  "Château Léoville Barton La Réserve de Léoville Barton",
  "Château Léoville Las Cases Saint-Julien",
  "Château Léoville-Barton Clos du Marquis",
  "Château Léoville-Barton Saint-Julien",
  "Château Léoville-Poyferré Saint-Julien",
  "Château Malartic-Lagravière Pessac-Léognan Rouge",
  "Château Malescot-Saint-Exupéry Margaux",
  "Château Margaux Margaux",
  "Château Maucaillou Moulis-en-Médoc",
  "Château Meyney Saint-Estèphe",
  "Château Minuty M de Minuty Rosé",
  "Château Minuty Prestige Rosé",
  "Château Minuty Rosé et Or",
  "Château Miraval Côtes de Provence Rosé",
  "Château Mont-Redon Châteauneuf-du-Pape",
  "Château Mont-Redon Côtes du Rhône Rouge",
  "Château Montelena Chardonnay",
  "Château Montelena Zinfandel",
  "Château Montus Madiran",
  "Château Moulin Haut-Laroque Fronsac",
  "Château Moulin Saint-Georges Saint-Émilion Grand Cru",
  "Château Mouton Rothschild Pauillac",
  "Château Musar Bekaa Valley Rouge",
  "Château Musar Bekaa Valley White",
  "Château Ormes de Pez Saint-Estèphe Cru Bourgeois",
  "Château Palmer Margaux",
  "Château Pape Clément Pessac-Léognan",
  "Château Pavie-Macquin Saint-Émilion Grand Cru",
  "Château Penin Bordeaux Supérieur",
  "Château Phélan Ségur Saint-Estèphe",
  "Château Pichon Baron Pauillac",
  "Château Pichon Lalande Pauillac",
  "Château Pichon Lalande Réserve de la Comtesse",
  "Château Picque Caillou Pessac-Léognan",
  "Château Pierre-Bise Anjou Blanc",
  "Château Pigoudet La Chapelle Rosé",
  "Château Pontet-Canet Pauillac",
  "Château Potensac Médoc",
  "Château Poujeaux Moulis-en-Médoc",
  "Château Pradeaux Bandol Rouge",
  "Château Preuillac Médoc",
  "Château Pétrus Pomerol",
  "Château Raspail-Ay Gigondas",
  "Château Rauzan-Gassies Margaux",
  "Château Rayas Châteauneuf-du-Pape",
  "Château Rayas Châteauneuf-du-Pape Blanc",
  "Château Rayas Châteauneuf-du-Pape Pignan",
  "Château Rayas Châteauneuf-du-Pape Réservé",
  "Château Revelette Grand Rosé",
  "Château Rieussec Sauternes",
  "Château Roubine Lion & Dragon Rosé",
  "Château Roubine Premium Rosé",
  "Château Rouget Pomerol",
  "Château Sainte Anne Bandol Rosé",
  "Château Sainte Marguerite Symphonie Rosé",
  "Château Sainte Roseline Lampe de Méduse Rosé",
  "Château Signac Côtes du Rhône-Villages",
  "Château Simian Châteauneuf-du-Pape",
  "Château Simone Palette Blanc",
  "Château Smith Haut Lafitte Pessac-Léognan Rouge",
  "Château Sociando-Mallet Haut-Médoc",
  "Château Ste. Michelle Columbia Valley Chardonnay",
  "Château Ste. Michelle Columbia Valley Merlot",
  "Château Ste. Michelle Sauvignon Blanc",
  "Château Talbot Saint-Julien",
  "Château Thieuley Bordeaux Blanc Sec",
  "Château Thivin Brouilly",
  "Château Thivin Côte de Brouilly",
  "Château Tour Haut-Caussan Médoc",
  "Château Troplong Mondot Saint-Émilion Grand Cru",
  "Château Unang Ventoux",
  "Château Vannières Bandol Rosé",
  "Château Vignelaure Coteaux d'Aix-en-Provence Rouge",
  "Château Villars Fronsac",
  "Château Yvonne Saumur-Champigny",
  "Château d'Aiguilhe Côtes de Castillon",
  "Château d'Esclans Garrus Rosé",
  "Château d'Esclans Rock Angel Rosé",
  "Château d'Esclans Whispering Angel Rock Angel Rosé",
  "Château d'Esclans Whispering Angel Rosé",
  "Château d'Issan Margaux",
  "Château d'Yquem Sauternes",
  "Château de Beaucastel Châteauneuf-du-Pape Blanc",
  "Château de Chénas Chénas",
  "Château de Fesles Bonnezeaux",
  "Château de Fuissé Pouilly-Fuissé",
  "Château de Meursault Meursault Clos du Château",
  "Château de Nages Costières de Nîmes Rosé",
  "Château de Pez Saint-Estèphe",
  "Château de Pibarnon Bandol Rosé",
  "Château de Pibarnon Bandol Rouge",
  "Château de Rully Rully Blanc",
  "Château de Sancerre Sancerre",
  "Château de Tracy Pouilly-Fumé",
  "Château de Villeneuve Saumur-Champigny",
  "Château des Charmes Riesling",
  "Château des Charmes St. David's Bench Chardonnay",
  "Château des Jacques Moulin-à-Vent",
  "Château des Jacques Moulin-à-Vent Clos du Grand Carquelin",
  "Château des Tours Vacqueyras",
  "Ciacci Piccolomini d'Aragona Brunello di Montalcino",
  "Ciacci Piccolomini d'Aragona Brunello di Montalcino Vigna di Pianrosso",
  "Ciacci Piccolomini d'Aragona Rosso di Montalcino",
  "Cillar de Silos Crianza",
  "Cillar de Silos Torresilo",
  "Cims de Porrera Clàssic Priorat",
  "Cindy's Backstreet Kitchen Red Blend",
  "Clape Cornas",
  "Clarendon Hills Astralis Syrah",
  "Clarendon Hills Piggott Range Syrah",
  "Clearview Estate Reserve Chardonnay",
  "Clemens Busch Pündericher Marienburg Riesling Spätlese",
  "Clemens Busch Vom Roten Schiefer Riesling",
  "Cliff Lede Vineyards Cabernet Sauvignon",
  "Cliff Lede Vineyards Chardonnay",
  "Cliff Lede Vineyards Claret",
  "Cliff Lede Vineyards FEL Cabernet Sauvignon",
  "Cline Cellars Ancient Vines Zinfandel",
  "Cline Cellars Cashmere",
  "Cline Cellars Cool Climate Pinot Noir",
  "Cline Cellars Lodi Zinfandel",
  "Cline Cellars Sonoma Coast Chardonnay",
  "Clonakilla Hilltops Shiraz",
  "Clonakilla Shiraz Viognier",
  "Clos Canarelli Figari Blanc",
  "Clos Cibonne Tentations Rosé",
  "Clos Du Val Cabernet Sauvignon",
  "Clos Du Val Chardonnay",
  "Clos Du Val Hirondelle Estate Cabernet Sauvignon",
  "Clos Du Val Hirondelle Merlot",
  "Clos Du Val Hirondelle Vineyard Merlot",
  "Clos Du Val Merlot",
  "Clos Du Val Stags Leap Cabernet",
  "Clos Erasmus Priorat",
  "Clos Henri Pinot Noir",
  "Clos Henri Sauvignon Blanc",
  "Clos LaChance Winery Cabernet Sauvignon",
  "Clos LaChance Winery Chardonnay",
  "Clos LaChance Winery Petite Sirah",
  "Clos Mogador Manyetes",
  "Clos Mogador Priorat",
  "Clos Pegase Mitsuko's Vineyard Cabernet Sauvignon",
  "Clos Pepe Vineyards Pinot Noir",
  "Clos Rougeard Saumur-Champigny Le Bourg",
  "Clos Rougeard Saumur-Champigny Les Poyeux",
  "Clos Sainte-Magdeleine Cassis Blanc",
  "Clos Solène Harmonie Red Wine",
  "Clos de l'Oratoire Saint-Émilion Grand Cru",
  "Clos de l'Oratoire des Papes Châteauneuf-du-Pape",
  "Clos de la Roilette Fleurie",
  "Clos de las Siete Monteviejo Lindaflor Malbec",
  "Clos de los Siete Clos",
  "Clos de los Siete Clos de los Siete",
  "Clos de los Siete Malbec Blend",
  "Clos de los Siete Mendoza",
  "Clos de los Siete Monteviejo Lindaflor Malbec",
  "Clos de los Siete White",
  "Clos des Epeneaux Pommard Premier Cru",
  "Clos des Papes Châteauneuf-du-Pape Rouge",
  "Clos du Bois Briarcrest Cabernet Sauvignon",
  "Clos du Bois Cabernet Sauvignon",
  "Clos du Caillou Bouquet des Garrigues",
  "Clos du Caillou Châteauneuf-du-Pape",
  "Clos du Val Reserve Cabernet Sauvignon",
  "Closson Chase Pinot Noir",
  "Cloudy Bay Pinot Gris",
  "Cloudy Bay Pinot Noir",
  "Cloudy Bay Sauvignon Blanc",
  "Cloudy Bay Te Koko Sauvignon Blanc",
  "Cobos Bramare Malbec",
  "Coche-Dury Corton-Charlemagne Grand Cru",
  "Coche-Dury Meursault",
  "Cockburn's Special Reserve Port",
  "Codorníu Anna de Codorníu Brut Cava",
  "Codorníu Pinot Noir",
  "Coelho Winery Pinot Noir",
  "Coeur de Terre Vineyard Pinot Noir",
  "Coffele Soave Classico",
  "Col Solare Cabernet Sauvignon",
  "Col Solare Red Mountain",
  "Col d'Orcia Brunello di Montalcino",
  "Col d'Orcia Olmaia Cabernet Sauvignon Toscana",
  "Col d'Orcia Rosso di Montalcino",
  "Coldstream Hills Pinot Noir",
  "Colgin Cellars IX Estate",
  "Colgin Cellars IX Estate Red Wine",
  "Colome Estate Malbec",
  "Colterenzio Pinot Grigio",
  "Coltibuono RS Toscana",
  "Columbia Crest Grand Estates Cabernet Sauvignon",
  "Columbia Crest Grand Estates Chardonnay",
  "Columbia Crest Grand Estates Merlot",
  "Columbia Crest H3 Cabernet Sauvignon",
  "Columbia Crest H3 Chardonnay",
  "Columbia Crest H3 Merlot",
  "Columbia Crest Two Vines Cabernet Sauvignon",
  "Columbia Winery Pinot Noir",
  "Columbia Winery Syrah",
  "Comando G El Tamboril",
  "Comando G La Bruja de Rozas",
  "Comando G Las Umbrías",
  "Comte Georges de Vogüé Musigny Grand Cru",
  "Comtes Lafon Meursault Charmes",
  "Concannon Vineyard Petite Sirah",
  "Concannon Vineyard Reserve Cabernet Sauvignon",
  "Concha y Toro Carmin de Peumo Carmenere",
  "Concha y Toro Carmin de Peumo Carmenère",
  "Concha y Toro Casillero del Diablo Carmenere",
  "Concha y Toro Casillero del Diablo Merlot",
  "Concha y Toro Casillero del Diablo Sauvignon Blanc",
  "Concha y Toro Don Melchor Cabernet Sauvignon",
  "Concha y Toro Frontera Cabernet Sauvignon",
  "Concha y Toro Gran Reserva Serie Riberas Merlot",
  "Concha y Toro Marques de Casa Concha Cabernet",
  "Concha y Toro Marques de Casa Concha Cabernet Sauvignon",
  "Concha y Toro Terrunyo Carmenere",
  "Concha y Toro Terrunyo Carmenère",
  "Condado de Haza Alenza Gran Reserva",
  "Condado de Haza Ribera del Duero",
  "Condado de Haza Ribera del Duero Crianza",
  "Condes de Albarei Albariño",
  "Conn Creek Anthology",
  "Conn Creek Winery Cabernet Sauvignon",
  "Conn Valley Vineyards Cabernet Sauvignon",
  "Cono Sur 20 Barrels Cabernet Sauvignon",
  "Cono Sur 20 Barrels Limited Edition Pinot Noir",
  "Cono Sur 20 Barrels Pinot Noir",
  "Cono Sur Bicicleta Pinot Noir",
  "Cono Sur Ocio Pinot Noir",
  "Contador Contador",
  "Contador La Cueva del Contador",
  "Contador Predicador",
  "Conterno-Fantino Barbera d'Alba Vignota",
  "Conterno-Fantino Barolo Mosconi",
  "Conterno-Fantino Barolo Sorì Ginestra",
  "Continuum Estate Cabernet Sauvignon Blend",
  "Contratto For England Brut",
  "Contucci Vino Nobile di Montepulciano",
  "Cooper Mountain Vineyards Pinot Gris",
  "Coopers Creek Sauvignon Blanc",
  "Copain Wine Cellars Pinot Noir",
  "Copain Wine Cellars Rosé",
  "Copain Wine Cellars Tous Ensemble Pinot Noir",
  "Coppo Barbera d'Asti L'Avvocata",
  "Coppo Barbera d'Asti Pomorosso",
  "Coppo Moncalvina Moscato d'Asti",
  "Coppo Pomorosso Barbera d'Asti",
  "Coppola Chardonnay Reserve",
  "Coppola Diamond Collection Pinot Noir",
  "Coppola Director's Cut Cabernet Sauvignon",
  "Coppola Director's Cut Chardonnay",
  "Coppola Director's Reserve Cabernet",
  "Coppola Rosso",
  "Coppola Sofia Blanc de Blancs",
  "Coppola Sofia Rosé",
  "Coppola Votre Santé Pinot Noir",
  "Coppola Winery Archimedes Cabernet Sauvignon",
  "Coppola Winery Cabernet Sauvignon Reserve",
  "Coppola Winery Diamond Collection Cabernet Sauvignon",
  "Coppola Winery Diamond Collection Chardonnay",
  "Coppola Winery Director's Cut Cabernet Sauvignon",
  "Coppola Winery Eleanor Red Blend",
  "Coppola Winery Rosso Red Blend",
  "Cordero di Montezemolo Barolo Enrico VI",
  "Cordero di Montezemolo Barolo Monfalletto",
  "Coriole Lloyd Reserve Shiraz",
  "Coriole Sangiovese",
  "Coriole Shiraz",
  "Corison Winery Cabernet Sauvignon",
  "Corison Winery Kronos Vineyard Cabernet Sauvignon",
  "Corison Winery Napa Valley Cabernet Sauvignon",
  "Cornelissen Munjebel Rosso",
  "Cornelissen Susucaru Rosso",
  "Corte Sant'Alda Valpolicella Mithas",
  "Cortes de Cima Chamine",
  "Cortes de Cima Reserva Tinto",
  "Cortes de Cima Touriga Nacional",
  "Corvo Rosso",
  "Cosentino Winery Cabernet Sauvignon",
  "Cosentino Winery The Novelist",
  "Costanti Brunello di Montalcino",
  "Costers del Siurana Clos de l'Obac",
  "Coturri Winery Zinfandel",
  "Coulee de Serrant Savennieres Coulee de Serrant",
  "Cousino Macul Antiguas Reservas Cabernet",
  "Covenant Cabernet Sauvignon",
  "Craggy Range Gimblett Gravels Cabernet Merlot",
  "Craggy Range Pinot Noir Martinborough",
  "Craggy Range Sauvignon Blanc",
  "Craggy Range Te Muna Road Pinot Noir",
  "Craggy Range Te Muna Road Sauvignon Blanc",
  "Creation Wines Syrah Grenache",
  "Crios Malbec",
  "Crios Rosé of Malbec",
  "Crios Torrontes",
  "Cristom Vineyards Louise Vineyard Pinot Noir",
  "Cristom Vineyards Mt. Jefferson Cuvée Pinot Noir",
  "Cristom Vineyards Pinot Gris",
  "Cristom Vineyards Pinot Noir",
  "Cristom Vineyards Sommers Reserve Pinot Noir",
  "Croad Vineyards Grenache",
  "Crocker & Starr Cabernet Franc",
  "Crocker & Starr Cabernet Sauvignon",
  "Crystallum The Agnes Chardonnay",
  "Crémant d'Alsace Lucien Albrecht Brut",
  "Cuentavinas Malbec",
  "Cullen Wines Diana Madeline",
  "Cullen Wines Diana Madeline Cabernet Merlot",
  "Cullen Wines Kevin John Chardonnay",
  "Cullen Wines Mangan",
  "Cune Rioja Crianza",
  "Cune Rioja Rosado",
  "Cupcake Vineyards Chardonnay",
  "Cupcake Vineyards Red Velvet",
  "Curtis Winery Ambassador's Vineyard Syrah",
  "Cusumano Angimbe",
  "Cusumano Nero d'Avola",
  "Cuvaison Estate Chardonnay",
  "Cuvaison Estate Pinot Noir",
  "Cycles Gladiator Cabernet Sauvignon",
  "Cycles Gladiator Chardonnay",
  "Cycles Gladiator Pinot Noir",
  "Côtes du Roussillon Villages Domaine Gauby Vieilles Vignes",
  "Côté Bonneville DuBrul Vineyard Cabernet Sauvignon",
  "D'Angelo Aglianico del Vulture",
  "Dal Forno Romano Amarone della Valpolicella",
  "Dal Forno Romano Amarone della Valpolicella Monte Lodoletta",
  "Dal Forno Romano Valpolicella Superiore",
  "Dalla Valle Vineyards Cabernet Sauvignon",
  "Dalla Valle Vineyards Maya",
  "Dalva 10 Year Old Tawny Port",
  "Damilano Barbera d'Alba",
  "Damilano Barolo Cannubi Riserva 1752",
  "Damilano Barolo Lecinquevigne",
  "Damilano Dolcetto d'Alba",
  "Damilano Langhe Arneis",
  "Dana Estates Hershey Vineyard Cabernet Sauvignon",
  "Daou Vineyards Cabernet Sauvignon",
  "Daou Vineyards Reserve Cabernet Sauvignon",
  "Darioush Caravan Cabernet Sauvignon",
  "Darioush Darius II",
  "Darioush Signature Cabernet Sauvignon",
  "Darioush Viognier",
  "Dark Horse Cabernet Sauvignon",
  "Dark Horse Chardonnay",
  "Dark Horse Rosé",
  "Dark Horse Wines Cabernet Sauvignon",
  "Dark Horse Wines Chardonnay",
  "Dark Horse Wines Pinot Grigio",
  "Dark Horse Wines Rosé",
  "Darling Cellars Onyx Shiraz",
  "Dashe Cellars Dry Creek Valley Zinfandel",
  "Dashe Cellars Les Enfants Terribles Grenache",
  "David Arthur Cabernet Sauvignon",
  "David Bruce Winery Petite Sirah",
  "David Bruce Winery Pinot Noir",
  "David Leflaive Puligny-Montrachet",
  "Davis Bynum Winery Pinot Noir",
  "De Bartoli Vecchio Samperi Ventennale",
  "De Bortoli Estate Grown Pinot Noir",
  "De Bortoli Estate Grown Shiraz",
  "De Bortoli Noble One Botrytis Semillon",
  "De Bortoli Villages Pinot Noir",
  "De Bortoli Yarra Valley Pinot Noir",
  "De Grendel Koetshuis Sauvignon Blanc",
  "De Ladoucette Pouilly-Fumé",
  "De Loach Vineyards OFS Pinot Noir",
  "De Martino Gallardia Cinsault",
  "De Martino Legado Reserva Cabernet Sauvignon",
  "De Martino Legado Reserva Carmenère",
  "De Morgenzon Chardonnay",
  "De Trafford Chenin Blanc",
  "De Wetshof Lesca Chardonnay",
  "DeLille Cellars Chaleur Estate Blanc",
  "DeLille Cellars Chaleur Estate Red Wine",
  "DeLille Cellars D2",
  "DeLille Cellars D2 Red Wine",
  "DeLille Cellars Harrison Hill Cabernet",
  "DeLoach Vineyards Chardonnay",
  "DeLoach Vineyards OFS Chardonnay",
  "DeMorgenzon DMZ Sauvignon Blanc",
  "Deaver Vineyards Zinfandel",
  "Decoy Cabernet Sauvignon",
  "Decoy Chardonnay",
  "Decoy Limited Napa Valley Cabernet Sauvignon",
  "Decoy Merlot",
  "Decoy Rosé",
  "Decoy by Duckhorn Cabernet Sauvignon",
  "Decoy by Duckhorn Chardonnay",
  "Decoy by Duckhorn Merlot",
  "Decoy by Duckhorn Pinot Noir",
  "Dehesa Gago Toro",
  "Dehlinger Winery Chardonnay",
  "Dehlinger Winery Pinot Noir",
  "Dei Vino Nobile di Montepulciano",
  "Del Rio Vineyards Pinot Noir",
  "Delaforce His Eminence's Choice Tawny",
  "Delamotte Blanc de Blancs Brut",
  "Delamotte Brut",
  "Delas Freres Saint-Joseph Sainte Epine",
  "Delas Frères Condrieu La Galopine",
  "Delas Frères Hermitage Bessards",
  "Delas Frères Hermitage Les Bessards",
  "Delas Frères Les Launes Crozes-Hermitage Rouge",
  "Delas Frères Saint Esprit Côtes du Rhône Rouge",
  "Delas Frères Saint-Joseph François de Tournon",
  "Delas Saint-Joseph Sainte-Epine",
  "Denis Mortet Gevrey-Chambertin",
  "Denner Vineyards Cabernet Sauvignon",
  "Descendientes de J. Palacios Las Lamas",
  "Descendientes de J. Palacios Moncerbal",
  "Descendientes de J. Palacios Pétalos del Bierzo",
  "Descendientes de J. Palacios Villa de Corullón",
  "Detert Family Vineyards Cabernet Franc",
  "Deutz Amour de Deutz Blanc de Blancs",
  "Deutz Blanc de Blancs Brut Millésimé",
  "Deutz Brut Classic",
  "Deutz Brut Rosé",
  "Deutzerhof Ahr Spatburgunder",
  "Deviation Road Altair Pinot Noir",
  "Devil's Lair Chardonnay",
  "Diamond Creek Vineyards Volcanic Hill Cabernet Sauvignon",
  "Didier Dagueneau Pouilly-Fume Buisson Renard",
  "Didier Dagueneau Pouilly-Fume Silex",
  "Didier Dagueneau Pouilly-Fumé Buisson Renard",
  "Didier Dagueneau Pouilly-Fumé Silex",
  "Diemersdal Sauvignon Blanc",
  "Dierberg Estate Chardonnay",
  "Dierberg Estate Pinot Noir",
  "Dierberg Vineyard Chardonnay",
  "Dierberg Vineyard Pinot Noir",
  "Dievole Chianti Classico",
  "Dinastía Vivanco Reserva de Familia",
  "Dirk Niepoort Charme",
  "Dirk Niepoort Drink Me Vinho Verde",
  "Dirk Niepoort Fabelhaft",
  "Dirk Niepoort Fabrico",
  "Dirk Niepoort Tiara Branco",
  "Disznoko Tokaji Aszu 5 Puttonyos",
  "Disznoko Tokaji Late Harvest",
  "Disznókő Tokaji Aszú 5 Puttonyos",
  "Division Wine Company Pinot Noir",
  "Do Ferreiro Albariño",
  "Do Ferreiro Cepas Vellas",
  "Do Ferreiro Cepas Vellas Albariño",
  "Dog Point Sauvignon Blanc",
  "Dog Point Vineyard Sauvignon Blanc",
  "Dolcetto d'Alba Vietti Dolcetto d'Alba Tre Vigne",
  "Dom Pérignon Vintage Brut",
  "Domaine Alain Graillot Crozes-Hermitage",
  "Domaine Albert Mann Riesling Schlossberg",
  "Domaine Arlaud Charmes-Chambertin Grand Cru",
  "Domaine Arlaud Clos de la Roche Grand Cru",
  "Domaine Arlaud Morey-Saint-Denis",
  "Domaine Armand Rousseau Chambertin Grand Cru",
  "Domaine Armand Rousseau Clos de la Roche Grand Cru",
  "Domaine Armand Rousseau Gevrey-Chambertin",
  "Domaine Armand Rousseau Gevrey-Chambertin Clos Saint-Jacques Premier Cru",
  "Domaine Arnoux-Lachaux Nuits-Saint-Georges",
  "Domaine Bachelet Gevrey-Chambertin Vieilles Vignes",
  "Domaine Bachelet-Monnot Maranges",
  "Domaine Barmes-Buecher Riesling Rosenberg",
  "Domaine Bernard Baudry Chinon Grézeaux",
  "Domaine Bernard Baudry Chinon La Croix Boissée",
  "Domaine Bernard Baudry Chinon Les Granges",
  "Domaine Bernard Moreau Chassagne-Montrachet Morgeot",
  "Domaine Bernard Morey Chassagne-Montrachet Blanc",
  "Domaine Bertagna Vougeot",
  "Domaine Binner Kaefferkopf Gewurztraminer",
  "Domaine Bonneau du Martray Corton-Charlemagne Grand Cru",
  "Domaine Bott-Geyl Alsace Pinot Gris",
  "Domaine Bouchard Père Beaune Clos de la Mousse",
  "Domaine Bousquet Gran Reserve Malbec",
  "Domaine Bousquet Malbec Reserve",
  "Domaine Bret Brothers Macon-Villages",
  "Domaine Brusset Cairanne Grande Montagne",
  "Domaine Canet-Valette Mourvèdre Maghani",
  "Domaine Carneros Blanc de Noirs",
  "Domaine Carneros Brut",
  "Domaine Carneros Brut Cuvée",
  "Domaine Carneros Le Rêve Blanc de Blancs",
  "Domaine Carneros Pinot Noir",
  "Domaine Carneros Rose",
  "Domaine Cazes Rivesaltes Ambre",
  "Domaine Chandon de Briailles Pernand-Vergelesses",
  "Domaine Chanson Bourgogne Pinot Noir",
  "Domaine Charvin Châteauneuf-du-Pape",
  "Domaine Charvin Côtes du Rhône",
  "Domaine Chidaine Montlouis Sec",
  "Domaine Chignard Fleurie Les Moriers",
  "Domaine Coeur de Lion Nuits-Saint-Georges",
  "Domaine Comte Abbatucci Ajaccio Faustine Rouge",
  "Domaine Comte Armand Pommard Clos des Epeneaux",
  "Domaine Comte Georges de Vogüé Chambolle-Musigny",
  "Domaine Comte Georges de Vogüé Chambolle-Musigny Les Amoureuses Premier Cru",
  "Domaine Confuron-Cotetidot Gevrey-Chambertin",
  "Domaine Confuron-Cotétidot Bourgogne Rouge",
  "Domaine Confuron-Cotétidot Vosne-Romanée",
  "Domaine Couly-Dutheil Chinon",
  "Domaine Daniel Rion Nuits-Saint-Georges",
  "Domaine Didier Dagueneau Pouilly-Fumé Pur Sang",
  "Domaine Didier Dagueneau Pouilly-Fumé Silex",
  "Domaine Diochon Moulin-à-Vent Vieilles Vignes",
  "Domaine Drouhin Oregon Arthur Chardonnay",
  "Domaine Drouhin Oregon Laurène Pinot Noir",
  "Domaine Drouhin Oregon Pinot Noir",
  "Domaine Drouhin Oregon Roserock Pinot Noir",
  "Domaine Drouhin Oregon Rosé of Pinot Noir",
  "Domaine Drouhin-Laroze Chambertin-Clos de Bèze",
  "Domaine Drouhin-Laroze Gevrey-Chambertin",
  "Domaine Dubreuil-Fontaine Pernand-Vergelesses",
  "Domaine Dujac Chambolle-Musigny Premier Cru Les Gruenchers",
  "Domaine Dujac Clos de la Roche Grand Cru",
  "Domaine Dujac Morey-Saint-Denis",
  "Domaine Dupeuble Beaujolais",
  "Domaine Duroche Gevrey-Chambertin",
  "Domaine Etienne Sauzet Puligny-Montrachet",
  "Domaine Faiveley Bourgogne Rouge",
  "Domaine Faiveley Nuits-Saint-Georges",
  "Domaine Ferret Pouilly-Fuisse Tournant de Pouilly",
  "Domaine Filliatreau Saumur-Champigny Vieilles Vignes",
  "Domaine Forey Père et Fils Vosne-Romanée",
  "Domaine Fourrier Gevrey-Chambertin Combe aux Moines Premier Cru",
  "Domaine Fourrier Gevrey-Chambertin Vieilles Vignes",
  "Domaine Ganevat Gamay de Mâche",
  "Domaine Gauby La Foun Blanc",
  "Domaine Gauby Muntada",
  "Domaine Geantet-Pansiot Gevrey-Chambertin Vieilles Vignes",
  "Domaine Gerovassiliou Avaton",
  "Domaine Gerovassiliou Malagousia",
  "Domaine Gerovassiliou Viognier",
  "Domaine Gourt de Mautens Rasteau",
  "Domaine Gramenon Cotes du Rhone Sierra du Sud",
  "Domaine Gramenon Côtes du Rhône La Mémé",
  "Domaine Gramenon Côtes du Rhône Sierra du Sud",
  "Domaine Gros Frère et Soeur Clos de Vougeot Grand Cru",
  "Domaine Gros Frère et Soeur Vosne-Romanée",
  "Domaine Guiberteau Saumur Blanc",
  "Domaine Guillemot-Michel Mâcon-Verzé",
  "Domaine Génot-Boulanger Pommard",
  "Domaine Génot-Boulanger Pommard Clos Blanc",
  "Domaine Henri Boillot Puligny-Montrachet",
  "Domaine Henri Bourgeois Sancerre",
  "Domaine Henri Gouges Nuits-Saint-Georges Clos des Porrets",
  "Domaine Henri Gouges Nuits-Saint-Georges Les Pruliers Premier Cru",
  "Domaine Henri Gouges Nuits-Saint-Georges Les Vaucrains Premier Cru",
  "Domaine Henri Pelle Menetou-Salon",
  "Domaine Henri Pellé Menetou-Salon",
  "Domaine Henri Rebourseau Chambertin Grand Cru",
  "Domaine Henri Rebourseau Gevrey-Chambertin",
  "Domaine Henri Rebourseau Gevrey-Chambertin Clos Prieur",
  "Domaine Huet Vouvray Le Haut-Lieu Sec",
  "Domaine Huet Vouvray Le Mont Demi-Sec",
  "Domaine Huet Vouvray Petillant Brut",
  "Domaine Humbert Freres Gevrey-Chambertin",
  "Domaine Jacques Prieur Chambertin Grand Cru",
  "Domaine Jacques Prieur Volnay Santenots Premier Cru",
  "Domaine Jean-Louis Chave Saint-Joseph Rouge",
  "Domaine Jean-Marc Boillot Pommard",
  "Domaine Jean-Marc Brocard Chablis",
  "Domaine Lamarche Vosne-Romanée",
  "Domaine Laplace Pacherenc du Vic-Bilh Sec",
  "Domaine Laroche Chablis Saint-Martin",
  "Domaine Le Sang des Cailloux Vacqueyras",
  "Domaine Leflaive Batard-Montrachet Grand Cru",
  "Domaine Leflaive Bourgogne Blanc",
  "Domaine Leflaive Chevalier-Montrachet Grand Cru",
  "Domaine Leflaive Macon-Verze",
  "Domaine Leflaive Mâcon-Verzé",
  "Domaine Leflaive Puligny-Montrachet",
  "Domaine Leflaive Puligny-Montrachet Clavoillon Premier Cru",
  "Domaine Leflaive Puligny-Montrachet Les Folatieres Premier Cru",
  "Domaine Leflaive Puligny-Montrachet Les Pucelles Premier Cru",
  "Domaine Leflaive Rully",
  "Domaine Leroy Bourgogne Rouge",
  "Domaine Leroy Chambolle-Musigny",
  "Domaine Leroy Gevrey-Chambertin",
  "Domaine Leroy Nuits-Saint-Georges",
  "Domaine Leroy Vosne-Romanée",
  "Domaine Les Pallières Gigondas",
  "Domaine Luneau-Papin Muscadet Clisson",
  "Domaine Léon Barral Faugères",
  "Domaine Maillard Chorey-les-Beaune",
  "Domaine Maillard Père et Fils Chorey-lès-Beaune",
  "Domaine Marc Colin Chassagne-Montrachet Blanc",
  "Domaine Marcel Deiss Alsace Blanc",
  "Domaine Marcel Richaud Cairanne",
  "Domaine Marchand-Grillot Gevrey-Chambertin",
  "Domaine Marchand-Tawse Gevrey-Chambertin",
  "Domaine Marcoux Châteauneuf-du-Pape",
  "Domaine Marcoux Châteauneuf-du-Pape Vieilles Vignes",
  "Domaine Maume Gevrey-Chambertin",
  "Domaine Michel Lafarge Volnay",
  "Domaine Michel Lafarge Volnay Premier Cru Clos des Chênes",
  "Domaine Michel Lafarge Volnay Premier Cru Clos du Château des Ducs",
  "Domaine Michel Magnien Morey-Saint-Denis",
  "Domaine Mittnacht Alsace Riesling",
  "Domaine Morey-Coffinet Chassagne-Montrachet",
  "Domaine Olga Raffault Chinon",
  "Domaine Olga Raffault Chinon Les Picasses",
  "Domaine Ostertag Gewurztraminer Fronholz",
  "Domaine Ostertag Pinot Gris Muenchberg",
  "Domaine Ott By Ott Rosé",
  "Domaine Ott Château Romassan Rosé",
  "Domaine Ott Clos Mireille Rose",
  "Domaine Ott Clos Mireille Rosé",
  "Domaine Overnoy-Houillon Poulsard",
  "Domaine Parent Pommard Premier Cru Les Épenots",
  "Domaine Paul Pernot Puligny-Montrachet",
  "Domaine Pepiere Muscadet Clisson",
  "Domaine Perrot-Minot Gevrey-Chambertin Vieilles Vignes",
  "Domaine Pierre Damoy Chambertin-Clos de Bèze",
  "Domaine Plageoles Gaillac Mauzac",
  "Domaine Ponsot Chambolle-Musigny",
  "Domaine Ponsot Clos Saint-Denis Grand Cru",
  "Domaine Ponsot Clos de la Roche Vieilles Vignes Grand Cru",
  "Domaine Prieuré-Roch Vosne-Romanée",
  "Domaine Ramonet Bourgogne Blanc",
  "Domaine Ramonet Chassagne-Montrachet",
  "Domaine Ramonet Chassagne-Montrachet Premier Cru Les Ruchottes",
  "Domaine Raveneau Chablis Premier Cru Montée de Tonnerre",
  "Domaine Richeaume Coteaux d'Aix-en-Provence",
  "Domaine Roger Sabon Chateauneuf-du-Pape",
  "Domaine Roger Sabon Châteauneuf-du-Pape",
  "Domaine Roger Sabon Châteauneuf-du-Pape Le Secret des Sabon",
  "Domaine Rossignol Savigny-les-Beaune",
  "Domaine Rossignol Savigny-lès-Beaune",
  "Domaine Rossignol-Fevrier Pommard",
  "Domaine Rossignol-Fevrier Volnay",
  "Domaine Rossignol-Trapet Chambertin Grand Cru",
  "Domaine Rossignol-Trapet Gevrey-Chambertin",
  "Domaine Roulot Meursault Meix Chavaux",
  "Domaine Santa Duc Châteauneuf-du-Pape La Crau Ouest",
  "Domaine Santa Duc Gigondas Aux Lieu-Dits",
  "Domaine Schlumberger Riesling Grand Cru",
  "Domaine Schoffit Pinot Gris Harth",
  "Domaine Serene Evenstad Reserve Pinot Noir",
  "Domaine Serene Grace Vineyard Pinot Noir",
  "Domaine Serene Winery Hill Vineyard Pinot Noir",
  "Domaine Serene Yamhill Cuvée Pinot Noir",
  "Domaine Servin Chablis Premier Cru",
  "Domaine Sigalas Assyrtiko",
  "Domaine Sigalas Santorini Assyrtiko",
  "Domaine Skouras Megas Oenos",
  "Domaine Skouras Nemea Agiorgitiko",
  "Domaine Skouras Nemea Grande Cuvée Agiorgitiko",
  "Domaine Sylvain Cathiard Nuits-Saint-Georges",
  "Domaine Sylvain Cathiard Nuits-Saint-Georges Aux Thorey Premier Cru",
  "Domaine Sylvain Cathiard Vosne-Romanée",
  "Domaine Sylvain Cathiard Vosne-Romanée Aux Reignots Premier Cru",
  "Domaine Sylvain Cathiard Vosne-Romanée Les Malconsorts Premier Cru",
  "Domaine Sylvain Pataille Bourgogne Passetoutgrain",
  "Domaine Taupenot-Merme Chambolle-Musigny",
  "Domaine Tempier Bandol Rosé",
  "Domaine Tempier Bandol Rouge",
  "Domaine Tollot-Beaut Chorey-lès-Beaune",
  "Domaine Trapet Gevrey-Chambertin",
  "Domaine Tselepos Mantinia Moscofilero",
  "Domaine Vacheron Sancerre",
  "Domaine Vacheron Sancerre Rouge",
  "Domaine Valette Pouilly-Fuisse",
  "Domaine Valette Pouilly-Fuissé",
  "Domaine Vico Île de Beauté Nielluccio",
  "Domaine Vincent Dancer Meursault",
  "Domaine Vincent Paris Cornas Granit 60",
  "Domaine Vincent Paris Cornas La Geynale",
  "Domaine Weinbach Alsace Riesling",
  "Domaine Weinbach Gewurztraminer Cuvée Laurence",
  "Domaine Weinbach Pinot Blanc Reserve",
  "Domaine Weinbach Pinot Gris Altenbourg",
  "Domaine Weinbach Pinot Gris Cuvée Laurence",
  "Domaine Weinbach Pinot Noir",
  "Domaine Weinbach Riesling Clos des Capucins",
  "Domaine Weinbach Riesling Cuvee Sainte Catherine",
  "Domaine Weinbach Riesling Cuvée Théo",
  "Domaine Weinbach Riesling Schlossberg Grand Cru",
  "Domaine Weinbach Tokay Pinot Gris Altenbourg Cuvee Laurence",
  "Domaine Zind-Humbrecht Pinot Gris Rangen de Thann",
  "Domaine Zind-Humbrecht Riesling",
  "Domaine de Bellene Beaune Premier Cru",
  "Domaine de Chevalier Pessac-Léognan Blanc",
  "Domaine de Chevalier Pessac-Léognan Rouge",
  "Domaine de Coyeux Muscat de Beaumes-de-Venise",
  "Domaine de Durban Muscat de Beaumes-de-Venise",
  "Domaine de Montille Pommard",
  "Domaine de Montille Pommard Premier Cru Les Pézerolles",
  "Domaine de Montille Volnay Premier Cru Les Champans",
  "Domaine de Montille Volnay Premier Cru Taillepieds",
  "Domaine de Triennes IGP Méditerranée Rouge",
  "Domaine de Triennes Rosé",
  "Domaine de Trévallon Alpilles Rouge",
  "Domaine de l'Ecu Muscadet Expression de Gneiss",
  "Domaine de l'Ecu Muscadet Granite",
  "Domaine de l'Hortus Cuvee Classique Rouge",
  "Domaine de la Bégude Bandol Rosé",
  "Domaine de la Charmoise Touraine Sauvignon Blanc",
  "Domaine de la Chevalerie Bourgueil Galichets",
  "Domaine de la Cote La Cote Chardonnay",
  "Domaine de la Grange des Pères Vin de Pays de l'Hérault",
  "Domaine de la Janasse Chateauneuf-du-Pape",
  "Domaine de la Janasse Châteauneuf-du-Pape",
  "Domaine de la Janasse Châteauneuf-du-Pape Chaupin",
  "Domaine de la Janasse Châteauneuf-du-Pape Vieilles Vignes",
  "Domaine de la Janasse Côtes du Rhône Blanc",
  "Domaine de la Madone Fleurie",
  "Domaine de la Madone Régnié",
  "Domaine de la Mordoree Tavel Rose",
  "Domaine de la Mordorée La Reine des Bois Tavel",
  "Domaine de la Romanée-Conti Bourgogne Rouge",
  "Domaine de la Romanée-Conti Grands Échezeaux Grand Cru",
  "Domaine de la Romanée-Conti Richebourg Grand Cru",
  "Domaine de la Romanée-Conti Romanée-Saint-Vivant Grand Cru",
  "Domaine de la Romanée-Conti Vosne-Romanée Aux Reignots Premier Cru",
  "Domaine de la Romanée-Conti Échézeaux Grand Cru",
  "Domaine de la Taille aux Loups Montlouis Clos de la Bretonnière",
  "Domaine de la Taille aux Loups Montlouis-sur-Loire Triple Zero",
  "Domaine de la Vougeraie Bourgogne Pinot Noir",
  "Domaine de la Vougeraie Chablis",
  "Domaine des Amouriers Vacqueyras",
  "Domaine des Baumard Quarts de Chaume",
  "Domaine des Baumard Quarts de Chaume Grand Cru",
  "Domaine des Baumard Savennières Clos du Papillon",
  "Domaine des Comtes Lafon Meursault",
  "Domaine des Comtes Lafon Meursault Charmes Premier Cru",
  "Domaine des Comtes Lafon Meursault Perrieres Premier Cru",
  "Domaine des Lambrays Clos des Lambrays Grand Cru",
  "Domaine des Lambrays Morey-Saint-Denis",
  "Domaine des Marnes Blanches Savagnin Ouillé",
  "Domaine des Roches Neuves Saumur-Champigny Insolite",
  "Domaine du Bel Air Bourgueil",
  "Domaine du Closel Savennieres",
  "Domaine du Collier Saumur Blanc",
  "Domaine du Cros Marcillac",
  "Domaine du Pesquier Gigondas",
  "Domaine du Possible Vin de France Rouge",
  "Domaine du Vieux Télégraphe Châteauneuf-du-Pape La Crau",
  "Domaine du Vieux Télégraphe Télégramme",
  "Domaine la Garrigue Côtes du Rhône",
  "Domaine la Suffrène Bandol Rouge",
  "Domaines Ott Château de Selle Rosé",
  "Domenico Clerico Barolo Ciabot Mentin Ginestra",
  "Dominio de Atauta La Mala",
  "Dominio de Atauta Ribera del Duero",
  "Dominio de Eguren Protocolo Tinto",
  "Dominio de Pingus Flor de Pingus",
  "Dominio de Tares Cepas Viejas",
  "Dominio de Tares P3 Mencía",
  "Dominio do Bibei Lapola",
  "Dominique Piron Morgon Côte du Py",
  "Dominique Piron Moulin-à-Vent",
  "Dominus Estate Napa Valley",
  "Domäne Wachau Grüner Veltliner Federspiel Terrassen",
  "Domäne Wachau Grüner Veltliner Smaragd",
  "Domäne Wachau Grüner Veltliner Smaragd Terrassen",
  "Domäne Wachau Riesling Smaragd Achleiten",
  "Donelan Family Wines Syrah",
  "Donnafugata Anthilia",
  "Donnafugata Anthìlia",
  "Donnafugata Ben Rye Passito",
  "Donnafugata Ben Rye Passito di Pantelleria",
  "Donnafugata Chardonnay Sicilia Chiaranda",
  "Donnafugata Lighea Zibibbo Sicilia",
  "Donnafugata Mille e Una Notte",
  "Donnafugata Nero d'Avola",
  "Donnafugata Sedàra Nero d'Avola",
  "Donnafugata Sherazade Nero d'Avola Rosato",
  "Donnafugata Sul Vulcano Etna Rosso",
  "Donnafugata Sur Sur Grillo Sicilia",
  "Donnafugata Tancredi Contessa Entellina",
  "Donnhoff Niederhäuser Hermannshöhle Riesling Spatlese",
  "Donnhoff Oberhauser Brucke Riesling Auslese",
  "Donnhoff Riesling Tonschiefer",
  "Dopff au Moulin Gewurztraminer",
  "Dow's 10 Year Tawny Port",
  "Dow's 20 Year Old Tawny Port",
  "Dow's Late Bottled Vintage Port",
  "Dow's Vintage Port",
  "Doña Paula Los Cardos Malbec",
  "Dr. Bürklin-Wolf Riesling Trocken",
  "Dr. Konstantin Frank Dry Riesling",
  "Dr. Konstantin Frank Gewurztraminer",
  "Dr. Loosen Blue Slate Riesling Kabinett",
  "Dr. Loosen Dr. L Pinot Noir",
  "Dr. Loosen Dr. L Riesling",
  "Dr. Loosen Erdener Prälat Riesling Auslese",
  "Dr. Loosen Erdener Treppchen Riesling Spatlese",
  "Dr. Loosen Erdener Treppchen Riesling Spätlese",
  "Dr. Loosen Urziger Wurzgarten Riesling Auslese Gold Cap",
  "Dr. Loosen Wehlener Sonnenuhr Riesling Auslese",
  "Dr. Loosen Wehlener Sonnenuhr Riesling Spätlese",
  "Dr. Loosen Ürziger Würzgarten Riesling Spätlese",
  "Dragonette Cellars Chardonnay",
  "Dragonette Cellars Pinot Noir",
  "Drew Family Cellars Pinot Noir",
  "Drouhin Chambolle-Musigny",
  "Drouhin Laforêt Bourgogne Pinot Noir",
  "Dry Creek Vineyard Cabernet Sauvignon",
  "Dry Creek Vineyard Chardonnay",
  "Dry Creek Vineyard Fumé Blanc",
  "Dry Creek Vineyard Heritage Vines Zinfandel",
  "Dry Creek Vineyard Meritage",
  "Dry Creek Vineyard Old Vine Zinfandel",
  "Dry Creek Vineyard Sauvignon Blanc",
  "Dry Creek Vineyard Zinfandel",
  "DuMol Chardonnay",
  "Duck Pond Cellars Pinot Noir",
  "Duckhorn Vineyards Cabernet Sauvignon",
  "Duckhorn Vineyards Chardonnay",
  "Duckhorn Vineyards Decoy Cabernet Sauvignon",
  "Duckhorn Vineyards Decoy Chardonnay",
  "Duckhorn Vineyards Discussion Cabernet Sauvignon",
  "Duckhorn Vineyards Migration Chardonnay",
  "Duckhorn Vineyards Monitor Ledge Vineyard Cabernet Sauvignon",
  "Duckhorn Vineyards Napa Valley Cabernet Sauvignon",
  "Duckhorn Vineyards Napa Valley Merlot",
  "Duckhorn Vineyards Paraduxx Red Blend",
  "Duckhorn Vineyards Paraduxx Red Wine",
  "Duckhorn Vineyards Sauvignon Blanc",
  "Duckhorn Vineyards Three Palms Vineyard Merlot",
  "Duemani Cabernet Franc Costa Toscana",
  "Duemani Suisassi Syrah Costa Toscana",
  "Dumol Pinot Noir",
  "Dumol Winery Chardonnay",
  "Dunham Cellars Cabernet Sauvignon",
  "Dunn Vineyards Howell Mountain Cabernet Sauvignon",
  "Durigutti Malbec",
  "Dutschke St Jakobi Shiraz",
  "Dutton-Goldfield Winery Dutton Ranch Pinot Noir",
  "Dutton-Goldfield Winery Pinot Noir",
  "Dönnhoff Kreuznacher Kahlenberg Riesling Spätlese",
  "Dönnhoff Niederhäuser Hermannshöhle Riesling Spätlese",
  "Dönnhoff Oberhäuser Brücke Riesling Spätlese",
  "Dönnhoff Oberhäuser Leistenberg Riesling Kabinett",
  "Dönnhoff Riesling Estate",
  "Dönnhoff Riesling Spätlese",
  "Dönnhoff Riesling Trocken",
  "E. Guigal Château d'Ampuis",
  "E. Guigal Condrieu",
  "E. Guigal Crozes-Hermitage Rouge",
  "E. Guigal Côte-Rôtie La Turque",
  "E. Guigal Côtes du Rhône Rouge",
  "E. Guigal Gigondas",
  "E. Guigal Hermitage Rouge",
  "E. Guigal La Landonne",
  "E. Guigal La Mouline",
  "Early Mountain Vineyards Cabernet Franc",
  "Easton Wines Zinfandel",
  "Eberle Winery Barbera",
  "Eberle Winery Cabernet Sauvignon",
  "Eberle Winery Syrah",
  "Edi Kante Terrano",
  "Edmeades Winery Zinfandel",
  "Edmeades Zinfandel",
  "Edna Valley Vineyard Chardonnay",
  "Educated Guess Cabernet Sauvignon",
  "Efestē Cabernet Sauvignon",
  "Egly-Ouriet Blanc de Noirs",
  "Egly-Ouriet Brut Tradition Grand Cru",
  "Egon Muller Scharzhofberger Riesling Trockenbeerenauslese",
  "Egon Müller Le Gallais Wiltinger Braune Kupp Riesling Spätlese",
  "Egon Müller Scharzhofberger Riesling Auslese",
  "Egon Müller Scharzhofberger Riesling Spätlese",
  "Ehlers Estate 1886 Cabernet Sauvignon",
  "Ehlers Estate Cabernet Sauvignon",
  "Einaudi Barolo",
  "Eisele Vineyard Cabernet Sauvignon",
  "El Coto Rioja Crianza",
  "El Enemigo El Enemigo Malbec",
  "El Enemigo Gran Enemigo Cabernet Franc",
  "El Esteco Don David Malbec",
  "El Porvenir de Los Andes Laborum Malbec",
  "Elderton Command Shiraz",
  "Elderton Estate Shiraz",
  "Elena Fucci Aglianico del Vulture Titolo",
  "Elena Walch Alto Adige Gewurztraminer",
  "Elena Walch Beyond the Clouds Alto Adige",
  "Elena Walch Cardinalizio Alto Adige",
  "Elena Walch Lagrein Alto Adige",
  "Elephant Hill Reserve Syrah",
  "Elio Altare Barolo",
  "Elio Altare Barolo Arborina",
  "Elio Altare Barolo Brunate",
  "Elio Altare Dolcetto d'Alba",
  "Elio Altare Langhe Nebbiolo La Villa",
  "Elio Altare Vigna Larigi Langhe",
  "Elio Perrone Moscato d'Asti",
  "Elk Cove Vineyards Chardonnay",
  "Elk Cove Vineyards Clay Court Pinot Noir",
  "Elk Cove Vineyards La Bohème Pinot Noir",
  "Elk Cove Vineyards Pinot Gris",
  "Elk Cove Vineyards Pinot Noir",
  "Elk Cove Vineyards Roosevelt Pinot Noir",
  "Elk Cove Vineyards Rosé of Pinot Noir",
  "Elouan Pinot Noir",
  "Elvio Cogno Barbera d'Alba Bricco dei Merli",
  "Elvio Cogno Barolo Bricco Pernice",
  "Elvio Cogno Barolo Cascina Nuova",
  "Elvio Cogno Barolo Ravera",
  "Elvio Cogno Nascetta Anas-Cëtta Langhe",
  "Elvio Tintero Moscato d'Asti Sori Gramella",
  "Emeritus Vineyards Hallberg Ranch Pinot Noir",
  "Emidio Pepe Montepulciano d'Abruzzo",
  "Emiliana Adobe Reserva Carmenère",
  "Emiliana Coyam",
  "Emiliana Novas Gran Reserva Carmenère",
  "Emilio Lustau East India Solera Sherry",
  "Emilio Moro Emilio Moro Reserva",
  "Emilio Moro Malleolus",
  "Emilio Moro Malleolus de Sanchomartín",
  "Emilio Moro Ribera del Duero",
  "Emmanuel Rouget Vosne-Romanée",
  "Emmanuel Rouget Échézeaux Grand Cru",
  "Emmerich Knoll Grüner Veltliner Smaragd",
  "Emmerich Knoll Grüner Veltliner Smaragd Loibenberg",
  "Emmerich Knoll Riesling Smaragd Loibenberg",
  "Emmerich Knoll Riesling Smaragd Schutt",
  "Emmolo Cabernet Sauvignon",
  "Emmolo Merlot",
  "Emrich-Schonleber Monzinger Halenberg Riesling",
  "Emrich-Schönleber Monzinger Frühlingsplätzchen Riesling",
  "Enric Soler Nun Vinya dels Taus",
  "Enrique Mendoza Monastrell",
  "Envinate Migan",
  "Envinate Taganan",
  "Envínate Benje Blanco",
  "Eola Hills Wine Cellars Pinot Noir",
  "Epiphany Cellars Syrah",
  "Epoch Estate Wines Authenticity",
  "Epoch Estate Wines Cabernet Sauvignon",
  "Erath Oregon Pinot Gris",
  "Erath Pinot Noir",
  "Erath Rosé of Pinot Noir",
  "Erath Winery Estate Selection Pinot Noir",
  "Erath Winery Pinot Gris",
  "Erath Winery Pinot Noir",
  "Erath Winery Rosé of Pinot Noir",
  "Ermelinda Freitas Fernando de Castilha Vintage Port",
  "Erni Loosen Erdener Treppchen Riesling Kabinett",
  "Ernie Els Proprietor's Blend",
  "Ernst Triebaumer Blaufränkisch Mariental",
  "Errazuriz Estate Sauvignon Blanc",
  "Errazuriz Max Reserva Cabernet Sauvignon",
  "Errázuriz Aconcagua Costa Pinot Noir",
  "Errázuriz Don Maximiano Founder's Reserve",
  "Errázuriz Don Maximiano Founders Reserve",
  "Errázuriz La Cumbre Syrah",
  "Errázuriz Max Reserva Cabernet Sauvignon",
  "Errázuriz Viñedo Chadwick",
  "Escarpment Pinot Noir",
  "Esporao Monte Velho Red",
  "Esporao Reserva White",
  "Esporão Alentejo Branco",
  "Esporão Monte Velho Tinto",
  "Esporão Private Selection Tinto",
  "Esporão Reserva Tinto",
  "Estancia Estates Cabernet Sauvignon",
  "Estancia Estates Chardonnay",
  "Estancia Piedra Toro Roble",
  "Estandon Cotes de Provence Rose",
  "Et Fille Pinot Noir",
  "Etienne Sauzet Puligny-Montrachet",
  "Etienne Sauzet Puligny-Montrachet Les Combettes Premier Cru",
  "Etude Wines Cabernet Sauvignon",
  "Etude Wines Chardonnay",
  "Etude Wines Pinot Noir",
  "Evening Land Vineyards La Source Pinot Noir",
  "Evening Land Vineyards Seven Springs Pinot Noir",
  "Evening Land Vineyards Seven Springs Rosé",
  "Evening Land Vineyards Seven Springs Vineyard Pinot Noir",
  "Evesham Wood Winery Pinot Noir",
  "Eyrie Vineyards Pinot Noir",
  "Eyrie Vineyards Reserve Pinot Noir",
  "F.X. Pichler Grüner Veltliner Smaragd Loibner Berg",
  "F.X. Pichler Grüner Veltliner Smaragd M",
  "F.X. Pichler Riesling Smaragd Loibner Berg",
  "FT Winery Russian River Valley Chardonnay",
  "FX Pichler Riesling Smaragd Loibenberg",
  "Fabre Montmayou Grand Vin Malbec",
  "Failla Pinot Noir",
  "Failla Sonoma Coast Chardonnay",
  "Fairview Goats do Roam",
  "Fairview La Capra Pinotage",
  "Fairview Pinotage",
  "Faiveley Bourgogne Pinot Noir",
  "Faiveley Chambertin-Clos de Bèze Grand Cru",
  "Faiveley Corton-Charlemagne Grand Cru",
  "Faiveley Gevrey-Chambertin Combe aux Moines Premier Cru",
  "Faiveley Mazis-Chambertin Grand Cru",
  "Faiveley Mercurey Premier Cru Clos des Myglands",
  "Faiveley Nuits-Saint-Georges",
  "Faiveley Nuits-Saint-Georges Aux Chaignots",
  "Falesco Est! Est!! Est!!! di Montefiascone",
  "Falesco Montiano Lazio",
  "Familia Deicas Preludio Tannat",
  "Familia Torres Nerola",
  "Famille Perrin Cotes du Rhone Villages",
  "Famille Perrin Luberon Rosé",
  "Fantesca Estate & Winery Cabernet Sauvignon",
  "Far Niente Cabernet Sauvignon",
  "Far Niente Chardonnay",
  "Far Niente Dolce Late Harvest",
  "Far Niente Nickel & Nickel Branding Iron Cabernet",
  "Far Niente Winery Cabernet Sauvignon",
  "Far Niente Winery Chardonnay",
  "Farnese Edizione Cinque Autoctoni",
  "Farnese Fantini Montepulciano d'Abruzzo",
  "Fasoli Gino Soave Classico",
  "Fattoria Le Pupille Morellino di Scansano",
  "Fattoria Le Pupille Morellino di Scansano Riserva",
  "Fattoria Le Pupille Saffredi Maremma Toscana",
  "Fattoria Le Terrazze Conero Riserva Sassi Neri",
  "Fattoria Nittardi Chianti Classico",
  "Fattoria dei Barbi Rosso di Montalcino",
  "Fattoria di Felsina Berardenga Chianti Classico",
  "Faust Cabernet Sauvignon",
  "Faust The Pact Red Wine",
  "Faustino Faustino V Rioja Reserva",
  "Fazi Battaglia Titulus Verdicchio dei Castelli di Jesi",
  "Feiler-Artinger Ruster Ausbruch",
  "Feiler-Artinger Ruster Ausbruch Pinot Cuvee",
  "Felsina Chianti Classico Riserva Rancia",
  "Felsina Fontalloro",
  "Felton Road Bannockburn Pinot Noir",
  "Felton Road Block 2 Chardonnay",
  "Felton Road Pinot Noir Block 3",
  "Ferrari-Carano Cabernet Sauvignon",
  "Ferrari-Carano Chardonnay",
  "Ferrari-Carano Tresor Red Blend",
  "Ferrari-Carano Vineyards Cabernet Sauvignon",
  "Ferrari-Carano Vineyards Fumé Blanc",
  "Ferrari-Carano Vineyards and Winery Cabernet Sauvignon",
  "Ferrari-Carano Vineyards and Winery Chardonnay",
  "Ferrari-Carano Vineyards and Winery Fumé Blanc",
  "Ferrari-Carano Vineyards and Winery Tre Terre Chardonnay",
  "Ferraton Hermitage La Méal",
  "Ferraton Père & Fils Hermitage Le Méal",
  "Ferreira Duque de Braganca 20 Year Old Tawny Port",
  "Ferrer Bobet Priorat",
  "Ferrer Bobet Selecció Especial",
  "Fess Parker Winery Cabernet Sauvignon",
  "Fess Parker Winery Chardonnay",
  "Fess Parker Winery Pinot Noir",
  "Fess Parker Winery Syrah",
  "Fetzer Vineyards Sundial Chardonnay",
  "Fetzer Vineyards Valley Oaks Cabernet Sauvignon",
  "Feudi del Pisciotto Cerasuolo di Vittoria",
  "Feudi di San Gregorio Aglianico Rubrato",
  "Feudi di San Gregorio Cutizzi Greco di Tufo",
  "Feudi di San Gregorio Dubl Falanghina Spumante",
  "Feudi di San Gregorio Falanghina",
  "Feudi di San Gregorio Fiano di Avellino",
  "Feudi di San Gregorio Greco di Tufo",
  "Feudi di San Gregorio Pietracalda Fiano di Avellino",
  "Feudi di San Gregorio Primitivo",
  "Feudi di San Gregorio Rubrato Aglianico",
  "Feudi di San Gregorio Serpico Irpinia",
  "Feudi di San Gregorio Taurasi",
  "Feudi di San Gregorio Taurasi Piano di Montevergine Riserva",
  "Feudo Montoni Nero d'Avola",
  "Fiddlehead Cellars Pinot Noir",
  "Fidelitas Cabernet Sauvignon",
  "Fife Vineyards Cabernet Sauvignon",
  "Fife Vineyards Redhead Vineyard Petite Sirah",
  "Figgins Estate Cabernet Sauvignon",
  "Filipa Pato Baga",
  "Fillaboa Albariño",
  "Fillaboa Monte Alto Albarino",
  "Finca Allende Allende Rioja",
  "Finca Allende Aurus",
  "Finca Allende Rioja Allende",
  "Finca Decero Amano Malbec",
  "Finca Flichman Expressions Malbec",
  "Finca Sandoval Salia",
  "Finca Sophenia Altosur Malbec",
  "Finca Sophenia Reserve Malbec",
  "Firesteed Pinot Noir",
  "Firestone Vineyard Cabernet Sauvignon",
  "Firestone Vineyard Syrah",
  "Firriato Camelot",
  "Firriato Camelot Sicilia",
  "Fisher Vineyards Wedding Vineyard Cabernet Sauvignon",
  "Flaneur Wines Pinot Noir",
  "Flat Creek Estate Super Texan",
  "Flecha de los Andes Gran Malbec",
  "Flip Flop Wines Cabernet Sauvignon",
  "Flip Flop Wines Pinot Grigio",
  "Flora Springs Winery Trilogy",
  "Flowers Vineyard & Winery Camp Meeting Ridge Chardonnay",
  "Flowers Vineyard & Winery Pinot Noir",
  "Flowers Vineyard & Winery Rosé of Pinot Noir",
  "Flowers Vineyard & Winery Sonoma Coast Chardonnay",
  "Flowers Vineyard Camp Meeting Ridge Pinot Noir",
  "Flowers Vineyard Chardonnay",
  "Flowers Vineyard Pinot Noir",
  "Flowers Vineyard Sonoma Coast Pinot Noir",
  "Fog Crest Vineyard Pinot Noir",
  "Foley Estate Pinot Noir",
  "Foley Estate Winery Cabernet Sauvignon",
  "Foley Estate Winery Pinot Noir",
  "Folie a Deux Old Vine Zinfandel",
  "Folie à Deux Winery Zinfandel",
  "Fonseca Bin 27 Reserve Port",
  "Fonseca Bin No. 27 Port",
  "Fonseca Vintage Port",
  "Fontanafredda Asti Spumante",
  "Fontanafredda Barbaresco",
  "Fontanafredda Barbera d'Alba",
  "Fontanafredda Barolo",
  "Fontanafredda Barolo Serralunga d'Alba",
  "Fontanafredda Briccotondo Barbera Piemonte",
  "Fontanafredda Dolcetto d'Alba",
  "Fontanafredda Gavi di Gavi",
  "Fontanafredda Moscato d'Asti",
  "Fontanafredda Nebbiolo d'Alba",
  "Fontanafredda Roero Arneis",
  "Fontanafredda Serralunga Barolo",
  "Fonterutoli Mazzei Chianti Classico",
  "Fontodi Case Via Syrah Colli della Toscana Centrale",
  "Fontodi Chianti Classico",
  "Fontodi Chianti Classico Gran Selezione Vigna del Sorbo",
  "Fontodi Flaccianello della Pieve",
  "Fontodi Pinot Nero Colli della Toscana Centrale",
  "Foppiano Vineyards Petite Sirah",
  "Foradori Granato Vigneti delle Dolomiti",
  "Foradori Pinot Grigio Fuoripista Vigneti delle Dolomiti",
  "Foradori Teroldego Rotaliano",
  "Force Majeure Vineyards Red Mountain Cabernet Sauvignon",
  "Foreau Vouvray Moelleux Reserve",
  "Forgeron Cellars Cabernet Sauvignon",
  "Forgeron Cellars Merlot",
  "Forjas del Salnés Goliardo Albariño",
  "Forjas del Salnés Leirana Albariño",
  "Forrest Estate Sauvignon Blanc",
  "Foursight Wines Pinot Noir",
  "Fox Creek Reserve Shiraz",
  "Fox Run Vineyards Riesling",
  "Foxen Vineyard Chardonnay Bien Nacido",
  "Foxen Vineyard Pinot Noir",
  "Foxen Winery Chardonnay",
  "Foxen Winery Pinot Noir",
  "Framingham Classic Riesling",
  "Framingham Marlborough Riesling",
  "Francis Ford Coppola Winery Claret",
  "Franciscan Estate Cabernet Sauvignon",
  "Franciscan Estate Chardonnay",
  "Franciscan Estate Magnificat",
  "Franciscan Estate Magnificat Red Wine",
  "Franciscan Estate Merlot",
  "Francois Cotat Sancerre Les Monts Damnes",
  "Frank Family Vineyards Cabernet Sauvignon",
  "Frank Family Vineyards Chardonnay",
  "Frank Family Vineyards Reserve Cabernet Sauvignon",
  "Frank Family Vineyards Winston Hill Red Wine",
  "François Chidaine Montlouis Les Choisilles",
  "Fred Loimer Grüner Veltliner Langenlois",
  "Freeman Vineyard & Winery Pinot Noir",
  "Freeman Vineyard Akiko's Cuvée Pinot Noir",
  "Freeman Vineyard Pinot Noir",
  "Freeman Vineyard Ryo-fu Chardonnay",
  "Freemark Abbey Cabernet Sauvignon",
  "Freemark Abbey Merlot",
  "Freemark Abbey Sycamore Vineyard Cabernet",
  "Freemark Abbey Winery Cabernet Sauvignon",
  "Freemark Abbey Winery Chardonnay",
  "Freemark Abbey Winery Merlot",
  "Freemark Abbey Winery Sycamore Vineyard Cabernet Sauvignon",
  "Freestone Vineyards Pinot Noir",
  "Frei Brothers Reserve Cabernet Sauvignon",
  "Freixenet Cordon Negro Brut",
  "Freixenet Cordon Negro Brut Cava",
  "Frescobaldi Albizzia Chardonnay Toscana",
  "Frescobaldi Brunello di Montalcino Castelgiocondo",
  "Frescobaldi Castelgiocondo Brunello",
  "Frescobaldi Castelgiocondo Rosso di Montalcino",
  "Frescobaldi Chianti Classico Nipozzano Vecchie Viti",
  "Frescobaldi Chianti Classico Riserva Tenuta Perano",
  "Frescobaldi Chianti Rufina Nipozzano Riserva",
  "Frescobaldi Danzante Pinot Grigio delle Venezie",
  "Frescobaldi Gorgona Costa Toscana Bianco",
  "Frescobaldi Lamaione Merlot Toscana",
  "Frescobaldi Luce",
  "Frescobaldi Luce della Vite",
  "Frescobaldi Mormoreto",
  "Frescobaldi Mormoreto Toscana",
  "Frescobaldi Nipozzano Chianti Rufina",
  "Frescobaldi Nipozzano Chianti Rufina Riserva",
  "Frescobaldi Pomino Bianco",
  "Frescobaldi Remole Toscana",
  "Freycinet Vineyard Chardonnay",
  "Freycinet Vineyard Pinot Noir",
  "Friedrich Wilhelm Gymnasium Riesling Mosel",
  "Fritz Haag Brauneberger Juffer Riesling Spatlese",
  "Fritz Haag Brauneberger Juffer Riesling Spätlese",
  "Frog's Leap Cabernet Sauvignon",
  "Frog's Leap Merlot",
  "Frog's Leap Sauvignon Blanc",
  "Frog's Leap Winery Cabernet Sauvignon",
  "Frog's Leap Winery Merlot",
  "Frog's Leap Winery Sauvignon Blanc",
  "Frog's Leap Winery Zinfandel",
  "Frog's Leap Zinfandel",
  "Fromm Winery Pinot Noir",
  "Fromm Winery Sauvignon Blanc",
  "Fuligni Brunello di Montalcino",
  "Fèlsina Chianti Classico Berardenga",
  "G.B. Burlotto Barbera d'Alba",
  "G.B. Burlotto Barolo Monvigliero",
  "G.D. Vajra Barbera d'Alba",
  "G.D. Vajra Barolo",
  "G.D. Vajra Barolo Albe",
  "G.D. Vajra Barolo Bricco delle Viole",
  "G.D. Vajra Dolcetto d'Alba Coste e Fossati",
  "G.D. Vajra Langhe Freisa Kyè",
  "G.D. Vajra Moscato d'Asti",
  "G.D. Vajra Riesling Langhe",
  "G.H. Mumm Grand Cordon Brut",
  "G.H. Mumm Grand Cordon Rose",
  "G.H. Mumm RSRV Blanc de Blancs Grand Cru",
  "Gaia Wines Notios Red",
  "Gaia Wines Notios White",
  "Gaia Wines Thalassitis Assyrtiko",
  "Gainey Vineyard Riesling",
  "Gaja Alteni di Brassica Langhe",
  "Gaja Barbaresco",
  "Gaja Barbera d'Alba Sperss",
  "Gaja Barolo",
  "Gaja Ca'Marcanda Camarcanda",
  "Gaja Ca'Marcanda Magari",
  "Gaja Ca'Marcanda Promis",
  "Gaja Costa Russi Barbaresco",
  "Gaja Costa Russi Langhe",
  "Gaja Darmagi Langhe",
  "Gaja Gaia & Rey Chardonnay",
  "Gaja Langhe Nebbiolo",
  "Gaja Rossj-Bass Langhe",
  "Gaja Sito Moresco",
  "Gaja Sori San Lorenzo Barbaresco",
  "Gaja Sori Tildin Barbaresco",
  "Gaja Sori Tildin Langhe",
  "Gaja Sperss Barolo",
  "Galardi Terra di Lavoro Campania",
  "Gallo Family Chardonnay",
  "Gallo Family Hearty Burgundy",
  "Gallo Family Pinot Noir",
  "Gallo Family Vineyards Sonoma Reserve Cabernet Sauvignon",
  "Gallo Signature Series Cabernet Sauvignon",
  "Gallo Signature Series Chardonnay",
  "Gallo Signature Series Russian River Valley Chardonnay",
  "Gancia Moscato d'Asti",
  "Garage Wine Co Lot Series Cabernet Franc",
  "Garage Wine Co Truquilemu Vineyard Carignan",
  "Gargiulo Vineyards Cabernet Sauvignon",
  "Garofoli Rosso Conero Grosso Agontano",
  "Garofoli Verdicchio dei Castelli di Jesi",
  "Gary Farrell Vineyards & Winery Hallberg Ranch Pinot Noir",
  "Gary Farrell Vineyards & Winery Olivet Lane Vineyard Chardonnay",
  "Gary Farrell Vineyards & Winery Pinot Noir",
  "Gary Farrell Vineyards & Winery Russian River Selection Chardonnay",
  "Gary Farrell Vineyards Chardonnay",
  "Gary Farrell Vineyards Rochioli-Allen Pinot Noir",
  "Gaston Chiquet Blanc de Blancs d'Aÿ Grand Cru",
  "Gavi di Gavi La Scolca",
  "Gazela Vinho Verde",
  "Gemtree Obsidian Shiraz",
  "Gemtree Vineyards Obsidian Shiraz",
  "Geografico Chianti Classico",
  "Georg Breuer Berg Schlossberg Riesling",
  "Georg Breuer Charm Riesling",
  "Georg Breuer Riesling Rauenthal Nonnenberg",
  "Georg Breuer Rüdesheim Riesling",
  "Georg Breuer Rüdesheimer Berg Rottland Riesling",
  "Georg Breuer Rüdesheimer Berg Schlossberg Riesling",
  "Georg Müller Stiftung Hattenheimer Nussbrunnen Riesling",
  "Georges Duboeuf Morgon Jean Descombes",
  "Georges Duboeuf Moulin-a-Vent",
  "Georges Duboeuf Moulin-à-Vent",
  "Georges Duboeuf Pouilly-Fuissé",
  "Georges Roumier Chambolle-Musigny",
  "Georges Roumier Chambolle-Musigny Les Amoureuses Premier Cru",
  "Georges Roumier Musigny Grand Cru",
  "Gerard Bertrand Chateau l'Hospitalet",
  "Gesellmann Blaufränkisch Hochacker",
  "Geyser Peak Winery Block Collection Cabernet Sauvignon",
  "Geyser Peak Winery Cabernet Sauvignon",
  "Geyser Peak Winery Walking Tree Cabernet",
  "Ghislaine Barthod Chambolle-Musigny",
  "Ghislaine Barthod Chambolle-Musigny Les Charmes Premier Cru",
  "Ghislaine Barthod Chambolle-Musigny Les Cras Premier Cru",
  "Ghost Block Cabernet Sauvignon",
  "Ghost Block Estate Cabernet Sauvignon",
  "Giacomo Conterno Barbera d'Alba Cascina Francia",
  "Giacomo Conterno Barbera d'Alba Francia",
  "Giacomo Conterno Barbera d'Asti Superiore",
  "Giacomo Conterno Barolo Arione",
  "Giacomo Conterno Barolo Cascina Francia",
  "Giacomo Conterno Barolo Monfortino Riserva",
  "Giacomo Fenocchio Barolo",
  "Giacomo Fenocchio Barolo Bussia",
  "Giacomo Fenocchio Barolo Cannubi",
  "Giaconda Chardonnay",
  "Giacosa Fratelli Barbaresco",
  "Gianni Gagliardo Barolo La Serra",
  "Gianni Gagliardo Barolo Serra dei Turchi",
  "Giant Steps Sexton Vineyard Chardonnay",
  "Giant Steps Wombat Creek Vineyard Pinot Noir",
  "Giesen Sauvignon Blanc",
  "Gini Soave Classico La Froscà",
  "Girard Winery Artistry Red Wine",
  "Girolamo Russo Etna Bianco San Lorenzo",
  "Girolamo Russo Etna Rosso Feudo",
  "Girolamo Russo Etna Rosso San Lorenzo",
  "Giuseppe Mascarello Barolo Monprivato",
  "Giuseppe Quintarelli Amarone della Valpolicella Classico",
  "Glatzer Grüner Veltliner",
  "Glen Carlou Chardonnay",
  "Gloria Ferrer Caves & Vineyards Brut",
  "Gloria Ferrer Caves & Vineyards Sonoma Brut",
  "Gloria Ferrer Sonoma Brut",
  "Gnarly Head Old Vine Zinfandel",
  "Godeval Godello",
  "Goldeneye Winery Migration Pinot Noir",
  "Goldeneye Winery Pinot Gris",
  "Goldeneye Winery Pinot Noir",
  "Goldschmidt Vineyards Game Ranch Cabernet Sauvignon",
  "Gonzalez Byass Apostoles Palo Cortado Sherry",
  "Gonzalez Byass Tio Pepe Fino Sherry",
  "González Byass Apostoles Palo Cortado",
  "González Byass Tío Pepe Fino",
  "Goose Ridge Cabernet Sauvignon",
  "Goosecross Cellars Cabernet Sauvignon",
  "Gosset Celebris Extra Brut",
  "Gosset Grand Millésime Brut",
  "Gosset Grande Reserve Brut",
  "Gosset Grande Rose Brut",
  "Gosset Grande Réserve Brut",
  "Graf Hardegg Grüner Veltliner",
  "Grafen zu Neipperg Schwaigerner Ruthe Riesling Spätlese",
  "Graham Beck Brut",
  "Graham Beck Chardonnay",
  "Graham Beck Pheasants Run Sauvignon Blanc",
  "Graham Beck Pinot Noir",
  "Graham's 10 Year Tawny Port",
  "Graham's 20 Year Old Tawny Port",
  "Graham's LBV Port",
  "Graham's Late Bottled Vintage Port",
  "Graham's Six Grapes Reserve Port",
  "Graham's Vintage Port",
  "Gramercy Cellars Cabernet Sauvignon",
  "Gramercy Cellars Syrah",
  "Gramona Argent Blanc de Blancs",
  "Gramona III Lustros Cava Gran Reserva",
  "Gramona Imperial Gran Reserva Cava",
  "Grangehurst Pinotage",
  "Grant Burge Meshach Shiraz",
  "Grattamacco Bolgheri Rosso",
  "Grattamacco Bolgheri Superiore",
  "Gravner Anfora Bianco",
  "Greenock Creek Seven Acre Shiraz",
  "Greenwood Ridge Anderson Valley Pinot Noir",
  "Greystone Pinot Noir",
  "Greywacke Sauvignon Blanc",
  "Greywacke Wild Sauvignon",
  "Grgich Hills Chardonnay",
  "Grgich Hills Estate Cabernet Sauvignon",
  "Grgich Hills Estate Chardonnay",
  "Grgich Hills Estate Fumé Blanc",
  "Groot Constantia Gouverneurs Reserve Red",
  "Gros Frère et Soeur Bourgogne Hautes-Côtes de Nuits",
  "Gross Nussberg Riesling",
  "Grosset Gaia",
  "Grosset Gaia Cabernet Blend",
  "Grosset Polish Hill Riesling",
  "Grosset Springvale Riesling",
  "Grosset Watervale Riesling",
  "Groth Vineyards & Winery Cabernet Sauvignon",
  "Groth Vineyards & Winery Hillview Vineyard Cabernet Sauvignon",
  "Groth Vineyards & Winery Reserve Beckstoffer To Kalon Cabernet Sauvignon",
  "Groth Vineyards & Winery Reserve Cabernet Sauvignon",
  "Groth Vineyards & Winery Sauvignon Blanc",
  "Groth Vineyards Cabernet Sauvignon",
  "Groth Vineyards Reserve Cabernet Sauvignon",
  "Groth Vineyards Sauvignon Blanc",
  "Gruet Blanc de Noirs Brut",
  "Grüner Veltliner Schloss Gobelsburg Cistercien",
  "Guerrieri Rizzardi Soave Classico",
  "Guffens-Heynen Pouilly-Fuisse",
  "Guido Berlucchi 61 Franciacorta Brut",
  "Guigal Cotes du Rhone Blanc",
  "Guigal Crozes-Hermitage Rouge",
  "Guigal Côtes du Rhône Rouge",
  "Guigal Saint-Joseph Rouge",
  "Guimaro Ribeira Sacra Mencia",
  "Gulfi Nerojbleo Nero d'Avola",
  "Gunderloch Fritz's Riesling",
  "Gunderloch Nackenheimer Rothenberg Riesling Spätlese",
  "Gundlach Bundschu Cabernet Sauvignon",
  "Gundlach Bundschu Estate Pinot Noir",
  "Gundlach Bundschu Mountain Cuvée Red Blend",
  "Gundlach Bundschu Rosé",
  "Gundlach Bundschu Winery Gewurztraminer",
  "Gundlach Bundschu Winery Mountain Cuvée",
  "Gusbourne Estate Blanc de Blancs",
  "Guy Breton Morgon Vieilles Vignes",
  "Guy Saget Pouilly-Fumé",
  "Guímaro Ribeira Sacra Mencía",
  "Gérard Bertrand Grand Terroir Minervois",
  "H. Billiot & Fils Brut Grand Cru",
  "HALL Wines Cabernet Sauvignon",
  "Hacienda Monasterio Reserva",
  "Hacienda Monasterio Ribera del Duero",
  "Hacienda Monasterio Ribera del Duero Crianza",
  "Hafner Vineyard Cabernet Sauvignon",
  "Hafner Vineyard Chardonnay",
  "Hahn Family Wines Chardonnay",
  "Hahn Family Wines SLH Pinot Noir",
  "Hahn Winery Cabernet Sauvignon",
  "Hahn Winery Chardonnay",
  "Hahn Winery GSM Red Blend",
  "Hahn Winery SLH Estate Pinot Noir",
  "Hall Wines Kathryn Hall Cabernet Sauvignon",
  "Hallberg Ranch Pinot Noir",
  "Halleck Vineyard Pinot Noir",
  "Halter Ranch Ancestor Red Blend",
  "Halter Ranch Synthesis",
  "Halter Ranch Vineyard Cabernet Sauvignon",
  "Hamacher Wines Pinot Noir",
  "Hamilton Russell Vineyards Chardonnay",
  "Hamilton Russell Vineyards Pinot Noir",
  "Handley Cellars Pinot Noir",
  "Hanging Rock Heathcote Shiraz",
  "Hanna Winery Cabernet Sauvignon",
  "Hannes Reeh Unplugged Zweigelt",
  "Hans Herzog Pinot Noir",
  "Hansel Family Vineyards Chardonnay",
  "Hanzell Vineyards Chardonnay",
  "Hanzell Vineyards Pinot Noir",
  "Haras de Pirque Cabernet Sauvignon Reserva",
  "Hardy's Eileen Hardy Shiraz",
  "Hardys Crest Cabernet Sauvignon",
  "Hardys Eileen Hardy Shiraz",
  "Hardys Stamp Series Riesling Gewurztraminer",
  "Hardys Tintara Shiraz",
  "Harlan Estate Napa Valley",
  "Harlan Estate The Maiden",
  "Hartford Court Far Coast Vineyard Pinot Noir",
  "Hartford Court Four Hearts Vineyard Chardonnay",
  "Hartford Court Land's Edge Vineyard Pinot Noir",
  "Hartford Court Pinot Noir",
  "Hartford Court Russian River Valley Pinot Noir",
  "Hartford Court Zinfandel",
  "Hartwell Vineyards Cabernet Sauvignon",
  "Harvest Moon Estate Pinot Noir",
  "Hatcher Winery Pinot Noir",
  "Hattingley Valley Classic Reserve Brut",
  "Hatzidakis Santorini Assyrtiko",
  "Hauner Malvasia delle Lipari",
  "Havens Wine Cellars Merlot",
  "Hawkes Cabernet Sauvignon",
  "Hawkes Winery Cabernet Sauvignon",
  "HdV Wines Chardonnay",
  "Healdsburg Ranches Cabernet Sauvignon",
  "Heartland Wines Limestone Coast Shiraz",
  "Hecht & Bannier Côtes de Provence Rosé",
  "Hedges Family Estate CMS Red Blend",
  "Heinrich Blaufränkisch",
  "Heitz Wine Cellars Bella Oaks Vineyard Cabernet Sauvignon",
  "Heitz Wine Cellars Cabernet Sauvignon",
  "Heitz Wine Cellars Chardonnay",
  "Heitz Wine Cellars Martha's Vineyard Cabernet Sauvignon",
  "Heitz Wine Cellars Napa Valley Cabernet Sauvignon",
  "Heitz Wine Cellars Trailside Vineyard Cabernet Sauvignon",
  "Hendry Winery Cabernet Sauvignon",
  "Henri Boillot Meursault Genevrieres Premier Cru",
  "Henri Boillot Puligny-Montrachet",
  "Henri Boillot Puligny-Montrachet Les Pucelles Premier Cru",
  "Henri Bonneau Châteauneuf-du-Pape Réserve des Célestins",
  "Henri Bourgeois Pouilly-Fume En Travertin",
  "Henri Bourgeois Sancerre",
  "Henri Bourgeois Sancerre La Bourgeoise",
  "Henri Bourgeois Sancerre Les Baronnes",
  "Henriot Blanc de Blancs Brut",
  "Henriot Brut Souverain",
  "Henriot Cuvée des Enchanteleurs",
  "Henry of Pelham Baco Noir",
  "Henry of Pelham Cabernet Merlot",
  "Henschke Cyril Henschke Cabernet Sauvignon",
  "Henschke Hill of Grace",
  "Henschke Hill of Grace Shiraz",
  "Henschke Julius Eden Valley Riesling",
  "Henschke Keyneton Euphonium",
  "Henschke Mount Edelstone Shiraz",
  "Herdade da Malhadinha Nova Malhadinha Tinto",
  "Herdade do Esporão Esporão Reserva Branco",
  "Herdade do Esporão Monte Velho Tinto",
  "Herdade do Esporão Reserva Tinto",
  "Herdade do Esporão Touriga Nacional",
  "Herdade do Mouchao Alentejo",
  "Herdade do Mouchão Alentejo Tinto",
  "Herdade do Mouchão Mouchão Tinto",
  "Herdade do Peso Trinca Bolotas",
  "Herdade do Sobroso Alentejo Tinto",
  "Herdade dos Grous Moon Harvested",
  "Herencia Altes Garnatxa Blanca",
  "Hermann J. Wiemer Cabernet Franc",
  "Hermann J. Wiemer Late Harvest Riesling",
  "Hermann J. Wiemer Riesling",
  "Heron Hill Winery Riesling",
  "Hess Collection Winery 19 Block Cuvée Cabernet Sauvignon",
  "Hess Collection Winery Lionhead Cabernet Sauvignon",
  "Hess Select Chardonnay",
  "Hewitson Lulu Riesling",
  "Hewitt Vineyard Cabernet Sauvignon",
  "Hidalgo Jerez Palo Cortado Wellington",
  "Hidalgo La Gitana Manzanilla",
  "Hidalgo La Gitana Manzanilla Sherry",
  "Hidalgo Pastrana Manzanilla Pasada",
  "Hiedler Grüner Veltliner Kamptal",
  "Hightower Cellars Cabernet Sauvignon",
  "Hilberg-Pasquero Langhe Nebbiolo",
  "Hirsch Vineyards Chardonnay",
  "Hirsch Vineyards Grüner Veltliner Gaisberg",
  "Hirsch Vineyards Pinot Noir",
  "Hirsch Vineyards San Andreas Fault Chardonnay",
  "Hirsch Vineyards San Andreas Fault Pinot Noir",
  "Hirtzberger Grüner Veltliner Smaragd Honivogl",
  "Hitching Post Wines Pinot Noir",
  "Hoddles Creek Chardonnay",
  "Hoddles Creek Pinot Noir",
  "Hofstatter Pinot Bianco",
  "Hofstätter Barthenau Vigna S. Urbano Pinot Nero",
  "Hofstätter Pinot Bianco",
  "Hofstätter Pinot Nero Alto Adige",
  "Hogue Cellars Cabernet Sauvignon",
  "Hogue Cellars Chardonnay",
  "Hogue Cellars Columbia Valley Riesling",
  "Hogue Cellars Genesis Cabernet Sauvignon",
  "Hogue Cellars Genesis Merlot",
  "Hogue Cellars Riesling",
  "Holly's Hill Vineyards Grenache",
  "Honig Vineyard & Winery Bartolucci Vineyard Cabernet Sauvignon",
  "Honig Vineyard & Winery Cabernet Sauvignon",
  "Honig Vineyard & Winery Reserve Cabernet Sauvignon",
  "Honig Vineyard & Winery Sauvignon Blanc",
  "Honig Vineyard Cabernet Sauvignon",
  "Honig Vineyard Sauvignon Blanc",
  "Honoro Vera Monastrell",
  "Hoopes Vineyard Cabernet Sauvignon",
  "Hope Family Wines Troublemaker Red Blend",
  "Horácio Simões Quinta do Carmo",
  "Hospices de Beaune Beaune Nicolas Rolin",
  "Howard Park Chardonnay",
  "Howell Mountain Vineyards Cabernet Sauvignon",
  "Hubert Lignier Clos de la Roche Grand Cru",
  "Hubert Lignier Morey-Saint-Denis",
  "Hubert de Montille Volnay Taillepieds",
  "Hugel Gentil",
  "Hugel Gewurztraminer Jubilée",
  "Hugel Gewurztraminer Tradition",
  "Hugel Gewurztraminer Vendanges Tardives",
  "Hugel Riesling",
  "Hugel Riesling Jubilée",
  "Hugel Riesling Vendanges Tardives",
  "Huia Vineyards Sauvignon Blanc",
  "Husch Vineyards Pinot Noir",
  "Hyde de Villaine Chardonnay",
  "Hyland Estates Old Vine Pinot Noir",
  "I Vigneri Etna Rosso Viti Centenarie del Vinupetra",
  "IXSIR El Ixsir Grande Reserve Red",
  "Iby Blaufränkisch",
  "Ijalba Rioja Tempranillo Ecológico",
  "Il Borro Sangiovese",
  "Il Marroneto Brunello di Montalcino Madonna delle Grazie",
  "Il Poggione Brunello di Montalcino",
  "Il Poggione Rosso di Montalcino",
  "Illahe Vineyards Pinot Noir",
  "Illuminati Montepulciano d'Abruzzo Riparosso",
  "Illuminati Montepulciano d'Abruzzo Zanna",
  "Illuminati Zanna Montepulciano d'Abruzzo",
  "Imagery Estate Cabernet Franc",
  "Imagery Estate Malbec",
  "Imagery Estate Rose",
  "Imagery Estate Rosé",
  "Imagery Estate Viognier",
  "Imagery Estate Winery Barbera",
  "Imagery Estate Winery Cabernet Franc",
  "Imagery Estate Winery Cabernet Sauvignon",
  "Imagery Estate Winery Pinot Noir",
  "Inama Soave Classico",
  "Inama Soave Classico Vintage Collection",
  "Inama Vigneti di Foscarino Soave Classico",
  "Indómita Gran Reserva Carmenère",
  "Inglenook Blancaneaux",
  "Inglenook Cabernet Franc",
  "Inglenook Rubicon",
  "Inniskillin Riesling",
  "Inniskillin Riesling Ice Wine",
  "Inniskillin Vidal Ice Wine",
  "Innocent Bystander Pinot Gris",
  "Innocent Bystander Pinot Noir",
  "Iron Horse Vineyards Classic Vintage Brut",
  "Iron Horse Vineyards Pinot Noir",
  "Iron Horse Vineyards Unoaked Chardonnay",
  "Iron Horse Vineyards Wedding Cuvée",
  "Ironstone Vineyards Cabernet Franc",
  "Isenhower Cellars Cabernet Sauvignon",
  "Isole e Olena Cepparello",
  "Isole e Olena Cepparello Toscana",
  "Isole e Olena Chianti Classico",
  "Isole e Olena Vin Santo del Chianti Classico",
  "J Dusi Zinfandel",
  "J Vineyards & Winery Cuvée 20 Brut",
  "J Vineyards Brut Rosé",
  "J Vineyards Chardonnay",
  "J Vineyards Cuvée 20 Brut",
  "J Vineyards Pinot Gris",
  "J Vineyards Pinot Noir",
  "J. Christopher Wines Pinot Noir",
  "J. Lassalle Blanc de Blancs Premier Cru Chigny-les-Roses",
  "J. Lohr Cuvée POM",
  "J. Lohr Hilltop Cabernet Sauvignon",
  "J. Lohr Vineyards & Wines Hilltop Cabernet Sauvignon",
  "J. Lohr Vineyards & Wines Seven Oaks Cabernet Sauvignon",
  "J. Rochioli Vineyard Pinot Noir",
  "J. Scott Cellars Pinot Noir",
  "J.J. Prum Graacher Himmelreich Riesling Kabinett",
  "J.J. Prum Wehlener Sonnenuhr Riesling Spatlese",
  "JJ Prum Wehlener Sonnenuhr Riesling Beerenauslese",
  "JJ Prum Wehlener Sonnenuhr Riesling Trockenbeerenauslese",
  "JJ Prüm Graacher Himmelreich Riesling Spätlese",
  "JJ Prüm Wehlener Sonnenuhr Riesling Auslese",
  "JJ Prüm Wehlener Sonnenuhr Riesling Kabinett",
  "JJ Prüm Wehlener Sonnenuhr Riesling Spätlese",
  "Jaboulet Domaine de Thalabert Crozes-Hermitage",
  "Jaboulet Hermitage La Chapelle",
  "Jaboulet Le Grand Pompée Saint-Joseph Rouge",
  "Jaboulet Parallèle 45 Côtes du Rhône Rouge",
  "Jackson Estate Sauvignon Blanc",
  "Jackson-Triggs Proprietors Grand Reserve Vidal Ice Wine",
  "Jacob's Creek Double Barrel Shiraz",
  "Jacob's Creek Reserve Shiraz",
  "Jacob's Creek Shiraz Cabernet",
  "Jacques Selosse Initial Blanc de Blancs",
  "Jacques Selosse Substance Blanc de Blancs",
  "Jacquesson Cuvee 745",
  "Jacquesson Dizy Terres Rouges Rosé de Saignée",
  "Jaffurs Wine Cellars Syrah",
  "Januik Winery Cabernet Sauvignon",
  "Januik Winery Merlot",
  "Jarvis Estate Cabernet Sauvignon",
  "Jasper Hill Emily's Paddock Shiraz",
  "Jasper Hill Emily's Paddock Shiraz Cabernet Franc",
  "Jasper Hill Georgia's Paddock Riesling",
  "Jasper Hill Georgia's Paddock Shiraz",
  "Jaume Serra Cristalino Brut Cava",
  "Jean Foillard Morgon 3.14",
  "Jean Royer Châteauneuf-du-Pape",
  "Jean-Louis Chave Hermitage Rouge",
  "Jean-Louis Chave Saint-Joseph Rouge",
  "Jean-Marc Burgaud Morgon Côte du Py",
  "Jean-Marc Burgaud Morgon Les Charmes",
  "Jean-Marc Pillot Chassagne-Montrachet",
  "Jean-Marc Roulot Bourgogne Blanc",
  "Jean-Max Roger Menetou-Salon",
  "Jean-Noel Gagnard Chassagne-Montrachet",
  "Jean-Paul & Benoît Droin Chablis",
  "Jean-Paul Benoit Droin Chablis",
  "Jean-Paul Brun Moulin-à-Vent",
  "Jeanneret Wines Riesling",
  "Jermann Dreams Chardonnay Venezia Giulia",
  "Jermann Pinot Grigio Venezia Giulia",
  "Jermann Vintage Tunina",
  "Jermann Were Dreams Chardonnay",
  "Jessie's Grove Winery Royal Tee Old Vine Zinfandel",
  "Jim Barry Lodge Hill Riesling",
  "Jim Barry The Armagh Shiraz",
  "Jim Barry The Lodge Hill Riesling",
  "Jim Barry Watervale Riesling",
  "Joel Gott Wines 815 Cabernet Sauvignon",
  "Joel Gott Wines Cabernet Sauvignon",
  "Joel Gott Wines Chardonnay",
  "Joel Gott Wines Sauvignon Blanc",
  "Joel Gott Wines Zinfandel",
  "Joh. Jos. Prum Wehlener Sonnenuhr Kabinett",
  "Joh. Jos. Prum Wehlener Sonnenuhr Riesling Kabinett",
  "John Duval Wines Entity Shiraz",
  "John Duval Wines Plexus Shiraz Grenache Mourvedre",
  "Jonata La Flor de Jonata Sauvignon Blanc",
  "Jordan Chardonnay",
  "Jordan Vineyard & Winery Cabernet Sauvignon",
  "Jordan Vineyard & Winery Chardonnay",
  "Jordan Vineyard Chardonnay",
  "Jordan Wine Estate Cabernet Sauvignon",
  "Jordan Winery The Prospector Syrah",
  "Jorge Ordonez Victoria Nº3",
  "Jose Maria da Fonseca Periquita Classico",
  "Jose Maria da Fonseca Periquita Tinto",
  "Jose Pariente Verdejo",
  "Josef Chromy Pinot Noir",
  "Joseph Drouhin Chambolle-Musigny",
  "Joseph Drouhin Clos de Vougeot Grand Cru",
  "Joseph Drouhin Clos de la Roche Grand Cru",
  "Joseph Drouhin Gevrey-Chambertin",
  "Joseph Drouhin Griotte-Chambertin Grand Cru",
  "Joseph Drouhin Meursault",
  "Joseph Drouhin Puligny-Montrachet",
  "Joseph Drouhin Volnay Premier Cru",
  "Joseph Phelps Backus Vineyard Cabernet",
  "Joseph Phelps Insignia",
  "Joseph Phelps Vineyards Eisele Vineyard Cabernet Sauvignon",
  "Joseph Phelps Vineyards Insignia",
  "Joseph Phelps Vineyards Napa Valley Cabernet Sauvignon",
  "Joseph Swan Vineyards Pinot Noir",
  "Joseph Voillot Volnay",
  "Josh Cellars Cabernet Sauvignon",
  "Josh Cellars Chardonnay",
  "Josh Cellars Reserve Cabernet Sauvignon",
  "Josmeyer Riesling Le Kottabe",
  "José Pariente Sauvignon Blanc",
  "José Pariente Verdejo",
  "João Portugal Ramos Marques de Borba",
  "João Portugal Ramos Marquês de Borba Reserva",
  "Juan Gil Jumilla",
  "Judd's Hill Winery Cabernet Sauvignon",
  "Jules Taylor Sauvignon Blanc",
  "Juliusspital Würzburger Stein Riesling",
  "Juniper Estate Cabernet Sauvignon",
  "Justin Vineyards & Winery Cabernet Sauvignon",
  "Justin Vineyards & Winery Isosceles",
  "Justin Vineyards & Winery Syrah",
  "Justin Vineyards Cabernet Sauvignon",
  "Justin Vineyards Isosceles",
  "Justin Vineyards Sauvignon Blanc",
  "Juve y Camps Cava Reserva de la Familia",
  "Juve y Camps Reserva de la Familia Cava",
  "Juvé y Camps Reserva de la Familia Cava",
  "K Vintners The Beautiful Syrah",
  "K Vintners The Creator Cabernet Sauvignon",
  "Kaena Wine Company Grenache",
  "Kaesler Old Bastard Shiraz",
  "Kaesler Stonehorse Shiraz Grenache",
  "Kaiken Malbec",
  "Kanonkop Pinotage",
  "Kapcsandy Family Winery State Lane Vineyard Cabernet Sauvignon",
  "Karl Schmitt-Wagner Longuicher Maximiner Herrenberg Riesling Auslese",
  "Katnook Estate Cabernet Sauvignon",
  "Katnook Estate Odyssey Cabernet Sauvignon",
  "Kay Brothers Amery Shiraz",
  "Keenan Winery Reserve Mernet",
  "Keever Vineyards Cabernet Sauvignon",
  "Keller Riesling Trocken",
  "Kelley Fox Wines Pinot Noir",
  "Ken Forrester FMC Chenin Blanc",
  "Ken Forrester The FMC Chenin Blanc",
  "Ken Wright Cellars Carter Vineyard Pinot Noir",
  "Ken Wright Cellars McCrone Vineyard Pinot Noir",
  "Ken Wright Cellars Pinot Noir",
  "Kendall-Jackson Grand Reserve Cabernet Sauvignon",
  "Kendall-Jackson Grand Reserve Chardonnay",
  "Kendall-Jackson Vintner's Reserve Cabernet Sauvignon",
  "Kendall-Jackson Vintner's Reserve Chardonnay",
  "Kendall-Jackson Zinfandel",
  "Kenneth Volk Pinot Noir",
  "Kenneth Volk Vineyards Pinot Noir",
  "Kenwood Vineyards Artist Series Cabernet Sauvignon",
  "Kenwood Vineyards Cabernet Sauvignon",
  "Kenwood Vineyards Chardonnay",
  "Kenwood Vineyards Jack London Ranch Cabernet Sauvignon",
  "Kenwood Vineyards Pinot Noir",
  "Kenwood Vineyards Sauvignon Blanc",
  "Kenzo Estate Rindo",
  "Kilikanoon Covenant Riesling",
  "Kilikanoon Oracle Shiraz",
  "Kim Crawford Pinot Gris",
  "Kim Crawford Rosé",
  "Kim Crawford Sauvignon Blanc",
  "King Estate Domaine Pinot Gris",
  "King Estate Pinot Gris",
  "King Estate Pinot Noir",
  "King Estate Signature Pinot Noir",
  "King Estate Willamette Valley Pinot Noir",
  "King Estate Winery Pinot Gris",
  "King Estate Winery Pinot Noir",
  "King Estate Winery Rosé of Pinot Gris",
  "King Estate Winery Signature Pinot Noir",
  "Kingston Family Bayo Oscuro Syrah",
  "Kiona Vineyards Cabernet Sauvignon",
  "Kiona Vineyards Chenin Blanc",
  "Kiona Vineyards Red Mountain Cabernet Sauvignon",
  "Kir-Yianni Akakies Xinomavro Rosé",
  "Kir-Yianni Diaporos Xinomavro",
  "Kistler Vineyards Les Noisetiers Chardonnay",
  "Kistler Vineyards Sonoma Coast Chardonnay",
  "Kistler Vineyards Sonoma Mountain Chardonnay",
  "Klein Constantia Vin de Constance",
  "Kleine Zalze Vineyard Selection Shiraz",
  "Kloster Eberbach Steinberger Riesling",
  "Knappstein Enterprise Riesling",
  "Knipser Riesling Trocken",
  "Knoll Grüner Veltliner Loibner Federspiel",
  "Knudsen Vineyards Pinot Noir",
  "Kokomo Winery Pinot Noir",
  "Kokomo Winery Zinfandel",
  "Kongsgaard Chardonnay",
  "Kongsgaard Winery Chardonnay",
  "Kongsgaard Winery Syrah",
  "Kooyong Chardonnay",
  "Kooyong Pinot Noir",
  "Korbel Brut",
  "Kosta Browne Gap's Crown Vineyard Pinot Noir",
  "Kosta Browne Keefer Ranch Vineyard Chardonnay",
  "Kosta Browne One Sixteen Chardonnay",
  "Kosta Browne Pisoni Vineyard Pinot Noir",
  "Kosta Browne Rosé of Pinot Noir",
  "Kosta Browne Russian River Valley Pinot Noir",
  "Kosta Browne Sonoma Coast Pinot Noir",
  "Koyle Gran Reserva Carmenère",
  "Kracher Cuvee Beerenauslese",
  "Kracher Cuvée Auslese",
  "Kracher Trockenbeerenauslese No 7",
  "Kracher Trockenbeerenauslese Nummer 7",
  "Kracher Welschriesling Trockenbeerenauslese",
  "Kris Pinot Grigio",
  "Krug Clos d'Ambonnay Blanc de Noirs",
  "Krug Clos du Mesnil",
  "Krug Grande Cuvée Brut",
  "Krug Rosé Brut",
  "Krug Vintage Brut",
  "Krutzler Perwolff Blaufränkisch",
  "Ktima Gerovassiliou Avaton",
  "Ktima Gerovassiliou Chardonnay",
  "Ktima Kir-Yianni Ramnista Xinomavro",
  "Ktima Papaioannou Agiorgitiko",
  "Kukkula Palaa",
  "Kuleto Estate Cabernet Sauvignon",
  "Kuleto Estate Syrah",
  "Kumeu River Chardonnay",
  "Kumeu River Mate's Vineyard Chardonnay",
  "Kumeu River Village Chardonnay",
  "Kunde Estate Winery Cabernet Sauvignon",
  "Kunde Estate Winery Chardonnay",
  "Kunde Estate Winery Zinfandel",
  "Kunde Family Winery Century Vines Zinfandel",
  "Kunde Family Winery Chardonnay",
  "Kunde Family Winery Magnolia Lane Sauvignon Blanc",
  "Kung Fu Girl Riesling",
  "Kutch Wines Pinot Noir",
  "Kutch Wines Sonoma Coast Pinot Noir",
  "Künstler Hochheimer Hölle Riesling Grosses Gewächs",
  "Künstler Hochheimer Kirchenstück Riesling Spätlese",
  "Künstler Riesling Rheingau",
  "L'Aventure Estate Cuvée",
  "L'Aventure Winery Estate Cuvée",
  "L'Aventure Winery Optimus",
  "L'Ecole No 41 Cabernet Sauvignon",
  "L'Ecole No 41 Chardonnay",
  "L'Ecole No 41 Merlot",
  "L'Ecole No 41 Semillon",
  "L'Ecole No. 41 Cabernet Sauvignon",
  "La Crema Pinot Gris",
  "La Crema Pinot Noir",
  "La Crema Russian River Valley Chardonnay",
  "La Crema Russian River Valley Pinot Noir",
  "La Crema Sonoma Coast Chardonnay",
  "La Crema Winery Nine Barrel Chardonnay",
  "La Crema Winery Pinot Noir",
  "La Crema Winery Russian River Valley Chardonnay",
  "La Crema Winery Russian River Valley Pinot Noir",
  "La Crema Winery Sonoma Coast Chardonnay",
  "La Crema Winery Sonoma County Cabernet Sauvignon",
  "La Gerla Brunello di Montalcino",
  "La Grange de Quatre Sous Hildago",
  "La Jota Vineyard Cabernet Sauvignon",
  "La Marca Prosecco",
  "La Marca Rosé",
  "La Massa Chianti Classico",
  "La Mondotte Saint-Émilion Grand Cru",
  "La Motte Chardonnay",
  "La Motte Pierneef Shiraz Viognier",
  "La Rioja Alta Gran Reserva 890",
  "La Rioja Alta Gran Reserva 904",
  "La Rioja Alta Rioja Gran Reserva 904",
  "La Rioja Alta Rioja Reserva",
  "La Rioja Alta Rioja Vina Ardanza Reserva",
  "La Rioja Alta Viña Alberdi Rioja Crianza",
  "La Rioja Alta Viña Ardanza Reserva",
  "La Rochelle Winery Pinot Noir",
  "La Spinetta Barbaresco Gallina",
  "La Spinetta Barbaresco Starderi",
  "La Spinetta Barbaresco Valeirano",
  "La Spinetta Barbaresco Vuorsu",
  "La Spinetta Barbera d'Asti Superiore Bionzo",
  "La Spinetta Barbera d'Asti Superiore Ca' di Pian",
  "La Spinetta Barolo Campe",
  "La Spinetta Moscato d'Asti",
  "La Spinetta Moscato d'Asti Bricco Quaglia",
  "La Spinetta Pin Langhe Rosso",
  "La Spinetta Vermentino Toscana",
  "La Vieille Ferme Côtes du Ventoux Rouge",
  "Lackner-Tinnacher Sauvignon Blanc Steinbach",
  "Ladera Vineyards Howell Mountain Cabernet Sauvignon",
  "Ladera Vineyards Napa Valley Cabernet Sauvignon",
  "Laetitia Vineyard Chardonnay",
  "Laetitia Vineyard Pinot Noir",
  "Lafond Winery Pinot Noir",
  "Lagar de Fornelos Lagar de Cervera Albariño",
  "Lagarde Malbec",
  "Lageder Pinot Grigio",
  "Laherte Frères Blanc de Blancs Extra Brut",
  "Laherte Frères Ultradition Brut",
  "Lail Vineyards J. Daniel Cuvée Cabernet Sauvignon",
  "Lake's Folly Cabernets",
  "Lamole di Lamole Chianti Classico",
  "Lamoreaux Landing Riesling",
  "Lancaster Estate Cabernet Sauvignon",
  "Lancaster Estate Winemaker's Blend Cabernet Sauvignon",
  "Landmark Vineyards Damaris Reserve Chardonnay",
  "Landmark Vineyards Grand Détour Pinot Noir",
  "Landmark Vineyards Overlook Chardonnay",
  "Lang & Reed Wine Company Cabernet Franc",
  "Lang Blaufränkisch Reserve",
  "Lange Estate Pinot Noir",
  "Lange Estate Winery Freedom Hill Vineyard Pinot Noir",
  "Lange Estate Winery Pinot Noir",
  "Lange Estate Winery Reserve Pinot Noir",
  "LangeTwins Family Winery Zinfandel",
  "Langmeil The Freedom Shiraz",
  "Langmeil Valley Floor Shiraz",
  "Langtry Estate & Vineyards Cabernet Sauvignon",
  "Lanson Black Label Brut",
  "Lanson Gold Label Vintage Brut",
  "Lanson Rosé Label Brut",
  "Lapostolle Alexandre Merlot",
  "Lapostolle Clos Apalta",
  "Lapostolle Grand Selection Carmenere",
  "Lapostolle Grand Selection Carmenère",
  "Lardera Vino Nobile di Montepulciano",
  "Larkmead Vineyards Cabernet Sauvignon",
  "Larkmead Vineyards LMV Salon Cabernet Sauvignon",
  "Larmandier-Bernier Longitude Blanc de Blancs",
  "Larmandier-Bernier Terre de Vertus Premier Cru Non Dosé",
  "Las Moradas de San Martín Initio",
  "Las Moradas de San Martín Las Luces",
  "Laughing Stock Vineyards Portfolio",
  "Laurel Glen Vineyard Cabernet Sauvignon",
  "Laurent-Perrier Blanc de Blancs Brut Nature",
  "Laurent-Perrier Grand Siècle Itération",
  "Laurent-Perrier La Cuvée Brut",
  "Laurent-Perrier Rose",
  "Lava Cap Winery Cabernet Sauvignon",
  "Lawson's Dry Hills Gewurztraminer",
  "Lawson's Dry Hills Pinot Gris",
  "Lawson's Dry Hills Sauvignon Blanc",
  "Layer Cake Cabernet Sauvignon",
  "Layer Cake Chardonnay",
  "Layer Cake Wines Cabernet Sauvignon",
  "Layer Cake Wines Malbec",
  "Layer Cake Wines Primitivo",
  "Lazy Creek Vineyards Pinot Noir",
  "Le Grand Noir GSM Blend",
  "Le Macchiole Paleo Rosso",
  "Le Piane Boca",
  "Le Pin Pomerol",
  "Le Ragose Amarone della Valpolicella",
  "Leeuwin Estate Art Series Cabernet Sauvignon",
  "Leeuwin Estate Art Series Chardonnay",
  "Leeuwin Estate Prelude Chardonnay",
  "Leeuwin Estate Prelude Vineyards Chardonnay",
  "Leeuwin Estate Siblings Sauvignon Blanc Semillon",
  "Left Coast Estate Pinot Noir",
  "Leitz Dragonstone Riesling",
  "Leitz Rüdesheimer Berg Roseneck Riesling",
  "Leitz Rüdesheimer Berg Roseneck Riesling Spätlese",
  "Leitz Rüdesheimer Berg Schlossberg Riesling",
  "Lemelson Vineyards Jerome Reserve Pinot Noir",
  "Lemelson Vineyards Pinot Noir",
  "Leonetti Cellar Cabernet Sauvignon",
  "Leroy Chambertin Grand Cru",
  "Leroy Meursault",
  "Les Jamelles Cabernet Sauvignon",
  "Lewis Cellars Reserve Cabernet Sauvignon",
  "Librandi Duca Sanfelice Cirò Rosso Riserva",
  "Librandi Gravello",
  "Librandi Gravello Calabria",
  "Librandi Terre Lontane Cirò Rosso",
  "Limerick Lane Cellars Zinfandel",
  "Lincourt Vineyards Cabernet Sauvignon",
  "Lincourt Vineyards Chardonnay",
  "Lincourt Vineyards Pinot Noir",
  "Lindemans Bin 50 Shiraz",
  "Lindemans Bin 65 Chardonnay",
  "Linden Vineyards Hardscrabble Chardonnay",
  "Lingua Franca Avni Chardonnay",
  "Lingua Franca Avni Pinot Noir",
  "Lingua Franca Bunker Hill Chardonnay",
  "Lingua Franca Chardonnay",
  "Lingua Franca Pinot Noir",
  "Lingua Franca Rosé",
  "Lingua Franca Stars Vineyard Pinot Noir",
  "Linne Calodo Contrarian",
  "Linne Calodo Problem Child",
  "Liquid Farm Pinot Noir",
  "Lisini Brunello di Montalcino",
  "Littorai Chardonnay",
  "Littorai Pinot Noir",
  "Littorai The Haven Chardonnay",
  "Livio Felluga Friulano",
  "Livio Felluga Friuli Colli Orientali Bianco",
  "Livio Felluga Pinot Grigio",
  "Lodi Vineyards Michael David Freakshow Cabernet",
  "Loimer Grüner Veltliner Langenlois",
  "Lokoya Cabernet Sauvignon",
  "Lokoya Diamond Mountain Cabernet",
  "Lokoya Diamond Mountain District Cabernet Sauvignon",
  "Lokoya Howell Mountain Cabernet Sauvignon",
  "Lokoya Mount Veeder Cabernet Sauvignon",
  "Lokoya Spring Mountain District Cabernet Sauvignon",
  "Lomond Pincushion Sauvignon Blanc",
  "Londer Vineyards Pinot Gris",
  "Lone Madrone Cabernet Sauvignon",
  "Long Meadow Ranch Cabernet Sauvignon",
  "Long Meadow Ranch Winery Cabernet Sauvignon",
  "Long Shadows Vintners Pedestal Merlot",
  "Longboard Vineyards Cabernet Sauvignon",
  "Longoria Wines Pinot Noir",
  "Loosen Bros Dr. L Riesling Sekt",
  "Loring Wine Company Cargasacchi Vineyard Pinot Noir",
  "Loring Wine Company Chardonnay",
  "Loring Wine Company Garys' Vineyard Pinot Noir",
  "Loring Wine Company Pinot Noir",
  "Losada El Patán Mencia",
  "Losada Vinos de Finca Mencía",
  "Louis Boillot Julienas",
  "Louis Boillot Juliénas",
  "Louis Jadot Beaujolais-Villages",
  "Louis Jadot Beaune Boucherottes Premier Cru",
  "Louis Jadot Beaune Clos des Couchereaux",
  "Louis Jadot Bourgogne Pinot Noir",
  "Louis Jadot Chablis",
  "Louis Jadot Chambertin-Clos de Bèze Grand Cru",
  "Louis Jadot Chambolle-Musigny",
  "Louis Jadot Clos Saint-Denis Grand Cru",
  "Louis Jadot Corton-Charlemagne Grand Cru",
  "Louis Jadot Gevrey-Chambertin",
  "Louis Jadot Gevrey-Chambertin Clos Saint-Jacques Premier Cru",
  "Louis Jadot Meursault Blagny Premier Cru",
  "Louis Jadot Musigny Grand Cru",
  "Louis Jadot Mâcon-Villages",
  "Louis Jadot Nuits-Saint-Georges",
  "Louis Jadot Pommard Premier Cru Les Rugiens",
  "Louis Jadot Puligny-Montrachet",
  "Louis Jadot Puligny-Montrachet Les Combettes",
  "Louis Jadot Puligny-Montrachet Les Folatieres Premier Cru",
  "Louis Jadot Vosne-Romanée",
  "Louis Latour Bourgogne Pinot Noir",
  "Louis Latour Mâcon-Lugny",
  "Louis Latour Pouilly-Fuissé",
  "Louis M. Martini Cabernet Sauvignon",
  "Louis M. Martini Winery Lot No. 1 Cabernet Sauvignon",
  "Louis M. Martini Winery Monte Rosso Cabernet Sauvignon",
  "Louis M. Martini Winery Napa Valley Cabernet Sauvignon",
  "Louis Michel Chablis Grand Cru Vaudésir",
  "Louis Roederer Blanc de Blancs Vintage",
  "Louis Roederer Brut Rosé",
  "Louis Roederer Collection Brut",
  "Louis Roederer Cristal Brut",
  "Louis Roederer Cristal Rosé",
  "Louis Roederer Estate Brut Rosé",
  "Louis-Antoine Luyt Pipeño País",
  "Louis-Claude Desvignes Morgon Cote du Py",
  "Louis-Claude Desvignes Morgon Côte du Py",
  "Luca Malbec",
  "Luce della Vite Lucente",
  "Luciano Sandrone Barbera d'Alba",
  "Luciano Sandrone Barolo Aleste",
  "Luciano Sandrone Barolo Cannubi Boschis",
  "Luciano Sandrone Barolo Le Vigne",
  "Luciano Sandrone Dolcetto d'Alba",
  "Luciano Sandrone Nebbiolo d'Alba Valmaggiore",
  "Lucien Crochet Sancerre",
  "Lucien Crochet Sancerre La Croix du Roy",
  "Luigi Bosca De Sangre Malbec",
  "Luis Seabra Xisto Cru Tinto",
  "Luna Vineyards Sangiovese",
  "Lungarotti Rubesco Torgiano Rosso",
  "Lungarotti Torgiano Riserva Vigna Monticchio",
  "Lungarotti Torre di Giano Bianco",
  "Lustau Almacenista Manzanilla Sherry",
  "Lustau Almacenista Solera",
  "Lustau Amontillado Los Arcos",
  "Lustau East India Solera Sherry",
  "Lustau Palo Cortado Almacenista",
  "Lustau Pedro Ximenez San Emilio Sherry",
  "Luís Pato Vinha Barrosa",
  "Luís Pato Vinhas Velhas Branco",
  "Luís Pato Vinhas Velhas Tinto",
  "Lynmar Estate Chardonnay",
  "Lynmar Estate Pinot Noir",
  "Lynmar Estate Quail Hill Vineyard Pinot Noir",
  "Lyrarakis Vilana",
  "Léoube Love by Léoube Rosé",
  "López de Heredia Viña Bosconia Reserva",
  "López de Heredia Viña Cubillo Crianza",
  "López de Heredia Viña Gravonia Blanco",
  "López de Heredia Viña Tondonia Gran Reserva",
  "López de Heredia Viña Tondonia Reserva",
  "López de Heredia Viña Tondonia Rioja Reserva",
  "M. Chapoutier Crozes-Hermitage Les Varonniers",
  "M. Chapoutier Côte-Rôtie La Mordorée",
  "M. Chapoutier Hermitage Le Pavillon",
  "M. Chapoutier Saint-Joseph Le Palais",
  "M. Marengo Barolo Bricco delle Viole",
  "Ma(i)sonry Napa Valley Cabernet",
  "Mac Forbes Woori Yallock Pinot Noir",
  "Mac Forbes Yarra Valley Pinot Noir",
  "MacPhail Family Toulouse Vineyard Pinot Noir",
  "MacPhail Family Wines Toulouse Vineyard Pinot Noir",
  "MacRostie Winery & Vineyards Chardonnay",
  "MacRostie Winery & Vineyards Pinot Noir",
  "MacRostie Winery & Vineyards Wildcat Mountain Vineyard Chardonnay",
  "MacRostie Winery Chardonnay",
  "Macari Vineyards Cabernet Franc",
  "Macchia Wines Tenacious Zinfandel",
  "Maculan Acininobili",
  "Maculan Torcolato",
  "Mahi Marlborough Sauvignon Blanc",
  "Mahi Sauvignon Blanc",
  "Main Ridge Estate Pinot Noir",
  "Maison Alex Gambal Gevrey-Chambertin",
  "Maison Bleue Grenache",
  "Maison Chanson Bourgogne Pinot Noir",
  "Maison Drouhin Laforet Bourgogne Pinot Noir",
  "Maison Jadot Pommard",
  "Maison Joseph Drouhin Laforet Bourgogne Pinot Noir",
  "Maison Louis Jadot Beaune Clos des Couchereaux",
  "Maison Louis Latour Corton Grand Cru",
  "Maison Nicolas Potel Gevrey-Chambertin",
  "Maison Roche de Bellene Beaune Premier Cru",
  "Maison Roche de Bellene Pommard",
  "Maison Saint Aix AIX Rosé",
  "Majella The Malleea",
  "Majella The Malleea Cabernet Shiraz",
  "Man O'War Sauvignon Blanc",
  "Manincor Pinot Nero Mazon Alto Adige",
  "Manincor Réserve del Conte Alto Adige",
  "Manincor Sauvignon Blanc Tannenberg Alto Adige",
  "Manousakis Winery Nostos Grenache",
  "Marc Bredif Vouvray",
  "Marc Colin Chassagne-Montrachet",
  "Marc Colin Saint-Aubin En Remilly Premier Cru",
  "Marc Colin Saint-Aubin Premier Cru En Remilly",
  "Marc Hebrart Blanc de Blancs Premier Cru",
  "Marcarini Barbera d'Asti",
  "Marcarini Barolo Brunate",
  "Marcarini Barolo La Serra",
  "Marcarini Dolcetto d'Alba Boschi di Berri",
  "Marcassin Chardonnay",
  "Marcassin Marcassin Vineyard Chardonnay",
  "Marcassin Pinot Noir",
  "Marcel Deiss Alsace Blanc",
  "Marcel Deiss Altenberg de Bergheim Grand Cru",
  "Marcel Deiss Schoenenbourg Grand Cru",
  "Marcel Lapierre Morgon",
  "Marcel Lapierre Morgon Raisins Gaulois",
  "Marchese Antinori Chianti Classico Riserva",
  "Marchesi Antinori Badia a Passignano Chianti Classico Gran Selezione",
  "Marchesi di Barolo Barbera d'Alba",
  "Marchesi di Barolo Barbera d'Asti",
  "Marchesi di Barolo Barolo",
  "Marchesi di Barolo Barolo Sarmassa",
  "Marchesi di Gresy Barbaresco Camp Gros",
  "Marchesi di Gresy Barbaresco Martinenga",
  "Marco de Bartoli Vecchio Samperi Marsala",
  "Margerum Wine Company M5 Red",
  "Margerum Wine Company M5 Red Blend",
  "Marimar Estate Acero Chardonnay",
  "Marimar Estate Pinot Noir",
  "Marisco Vineyards The King's Favour Sauvignon Blanc",
  "Mark Ryan Winery Dead Horse Cabernet",
  "Mark Ryan Winery Long Haul Cabernet Sauvignon",
  "Mark West Pinot Noir",
  "Markham Vineyards Benchmark Red Wine",
  "Markham Vineyards Cabernet Sauvignon",
  "Markham Vineyards Merlot",
  "Markham Vineyards Reserve Cabernet Sauvignon",
  "Markus Molitor Zeltinger Sonnenuhr Riesling Auslese",
  "Marques de Caceres Rioja Crianza",
  "Marques de Murrieta Reserva Rioja",
  "Marques de Murrieta Ygay Gran Reserva Rioja",
  "Marques de Riscal Rioja Reserva",
  "Marques de Vargas Rioja Reserva",
  "Marquis d'Angerville Volnay Champans",
  "Marquis de Terme Margaux",
  "Marqués de Cáceres Rioja Crianza",
  "Marqués de Cáceres Rioja Gran Reserva",
  "Marqués de Cáceres Rosado",
  "Marqués de Griñón Emeritus",
  "Marqués de Murrieta Castillo Ygay Gran Reserva Especial",
  "Marqués de Murrieta Reserva",
  "Marqués de Murrieta Rioja Reserva",
  "Marqués de Riscal Reserva",
  "Marqués de Riscal Rioja Gran Reserva",
  "Marqués de Riscal Rioja Reserva",
  "Marqués de Riscal Rueda Sauvignon Blanc",
  "Marqués de Riscal Rueda Verdejo",
  "Marqués de Vargas Reserva",
  "Marqués de Vargas Reserva Privada",
  "Marramiero Inferi Montepulciano d'Abruzzo",
  "Martin Codax Albarino",
  "Martinborough Vineyard Chardonnay",
  "Martinborough Vineyard Pinot Noir",
  "Martinelli Winery Chardonnay",
  "Martinelli Winery Jackass Hill Vineyard Zinfandel",
  "Martinelli Winery Jackass Vineyard Zinfandel",
  "Martinelli Winery Pinot Noir",
  "Martinelli Winery Zio Tony Ranch Chardonnay",
  "Martinelli Zio Tony Ranch Zinfandel",
  "Martín Códax Albariño",
  "Maryhill Winery Proprietor's Reserve Cabernet",
  "Mas Alta La Creu Alta",
  "Mas Amiel 15 Ans d'Age Maury",
  "Mas Amiel Maury Sec",
  "Mas Amiel Vintage Maury",
  "Mas Doix Les Crestes",
  "Mas Doix Salanques",
  "Mas Jullien Coteaux du Languedoc",
  "Mas de Cadenet Rosé",
  "Mas de Daumas Gassac Rouge",
  "Mas des Bressades Costières de Nîmes Rouge",
  "Mascarello Giuseppe e Figlio Barbera d'Alba Santo Stefano di Perno",
  "Mascarello Giuseppe e Figlio Barolo Monprivato",
  "Mascarello Giuseppe e Figlio Barolo Toetto",
  "Mascarello Giuseppe e Figlio Barolo Villero",
  "Mascarello Giuseppe e Figlio Dolcetto d'Alba Bricco",
  "Masciarelli Marina Cvetic Montepulciano",
  "Masciarelli Montepulciano d'Abruzzo",
  "Masciarelli Villa Gemma Montepulciano d'Abruzzo",
  "Masi Agricola Serego Alighieri Valpolicella Classico",
  "Masi Bonacosta Valpolicella Classico",
  "Masi Brolo Campofiorin Oro",
  "Masi Campofiorin Ripasso",
  "Masi Campofiorin Rosso del Veronese",
  "Masi Campolongo di Torbe Amarone",
  "Masi Costasera Amarone",
  "Masi Costasera Amarone della Valpolicella Classico",
  "Masi Masianco Pinot Grigio-Verduzzo",
  "Masi Mazzano Amarone della Valpolicella",
  "Masi Passo Doble Malbec Corvina",
  "Masi Recioto della Valpolicella Classico Mezzanella",
  "Masi Soave Classico",
  "Masi Soave Classico Colbaraca",
  "Masia Duch Montsant Negre",
  "Mason Cellars Sauvignon Blanc",
  "Massaya Classic Rouge",
  "Masseria Il Falcone Castel del Monte Riserva",
  "Masseto Massetino Toscana",
  "Masseto Masseto",
  "Masseto Toscana IGT",
  "Massolino Barolo",
  "Massolino Barolo Parussi",
  "Massolino Barolo Vigna Rionda Riserva",
  "Mastroberardino Aglianico",
  "Mastroberardino Falanghina del Sannio",
  "Mastroberardino Fiano di Avellino",
  "Mastroberardino Greco di Tufo",
  "Mastroberardino Lacryma Christi del Vesuvio Bianco",
  "Mastroberardino Naturalis Historia Taurasi",
  "Mastroberardino Radici Taurasi",
  "Mastroberardino Redimore Piedirosso Campania",
  "Mastroberardino Taurasi",
  "Mastroberardino Taurasi Riserva",
  "Mastrojanni Brunello di Montalcino",
  "Mastrojanni Brunello di Montalcino Schiena d'Asino",
  "Mastrojanni Rosso di Montalcino",
  "Matanzas Creek Winery Cabernet Sauvignon",
  "Matanzas Creek Winery Sauvignon Blanc",
  "Matrix Winery Pinot Noir",
  "Matthiasson Napa Valley Red",
  "Matua Sauvignon Blanc",
  "Matua Valley Sauvignon Blanc",
  "Mauricio Lorca Fantelli Gran Malbec",
  "Mauritson Family Winery Chardonnay",
  "Mauritson Family Winery Dry Creek Valley Zinfandel",
  "Mauritson Family Winery Rockpile Zinfandel",
  "Maximin Grünhaus Abtsberg Riesling Kabinett",
  "Maximin Grünhaus Abtsberg Riesling Spätlese",
  "Maximin Grünhaus Bruderberg Riesling Kabinett",
  "Maximin Grünhaus Herrenberg Riesling Kabinett",
  "Maximin Grünhaus Herrenberg Riesling Spätlese",
  "Maximin Grünhaus Riesling Kabinett",
  "Mayacamas Vineyards Cabernet Sauvignon",
  "Mayer am Pfarrplatz Grüner Veltliner",
  "Mayo Family Winery Cabernet Sauvignon",
  "Maysara Winery Jamsheed Pinot Noir",
  "Mazzei Badiòla Maremma Toscana",
  "Mazzei Philip Toscana",
  "Mazzei Ser Lapo Chianti Classico",
  "Mazzei Siepi Toscana",
  "McCrea Cellars Syrah",
  "McIvor Estate Heathcote Shiraz",
  "McManis Family Vineyards Cabernet Sauvignon",
  "McManis Family Vineyards Chardonnay",
  "McManis Family Vineyards Pinot Noir",
  "McWilliams Hanwood Estate Cabernet",
  "McWilliams Hanwood Estate Cabernet Sauvignon",
  "McWilliams Mount Pleasant Lovedale Semillon",
  "Medlock Ames Cabernet Sauvignon",
  "Meerlust Rubicon",
  "Meiomi Pinot Noir",
  "Meiomi Rosé",
  "Melini Borghi d'Elsa Chianti",
  "Melini Chianti Classico",
  "Melini Chianti Stiele",
  "Melville Winery Chardonnay",
  "Melville Winery Estate Pinot Noir",
  "Melville Winery Pinot Noir",
  "Memento Mori Cabernet Sauvignon",
  "Menage a Trois Red Blend",
  "Menage à Trois Red Blend",
  "Mendel Malbec",
  "Mendel Wines Malbec",
  "Mer Soleil Pinot Noir",
  "Mer Soleil Reserve Chardonnay",
  "Mer Soleil Silver Unoaked Chardonnay",
  "Mercer Estates Cabernet Sauvignon",
  "Mercouri Estate Refosco",
  "Meridian Vineyards Cabernet Sauvignon",
  "Meridian Vineyards Chardonnay",
  "Merry Edwards Pinot Noir",
  "Merry Edwards Sauvignon Blanc",
  "Merry Edwards Winery Chardonnay",
  "Merry Edwards Winery Coopersmith Pinot Noir",
  "Merry Edwards Winery Olivet Lane Pinot Noir",
  "Merry Edwards Winery Pinot Noir",
  "Merry Edwards Winery Rosé of Pinot Noir",
  "Merry Edwards Winery Sauvignon Blanc",
  "Merryvale Vineyards Napa Valley Cabernet Sauvignon",
  "Merryvale Vineyards Profile",
  "Merryvale Vineyards Starmont Cabernet Sauvignon",
  "Merum Priorati Aspriu",
  "Merus Cabernet Sauvignon",
  "Merus Napa Valley Merlot",
  "Methven Family Vineyards Pinot Noir",
  "Meyer-Nakel Spatburgunder",
  "Mezzacorona Pinot Grigio",
  "Mezzacorona Teroldego Rotaliano",
  "Mi Sueño Winery Cabernet Sauvignon",
  "Michael David Winery 7 Deadly Zins",
  "Michael David Winery Earthquake Zinfandel",
  "Michael David Winery Freakshow Cabernet Sauvignon",
  "Michael David Winery Inkblot Cabernet Franc",
  "Michel Niellon Chassagne-Montrachet",
  "Michel-Schlumberger Cabernet Sauvignon",
  "Michele Chiarlo Barbaresco Reyna",
  "Michele Chiarlo Barbera d'Asti Cipressi",
  "Michele Chiarlo Barbera d'Asti Le Orme",
  "Michele Chiarlo Barbera d'Asti Superiore",
  "Michele Chiarlo Barolo Cerequio",
  "Michele Chiarlo Barolo DOCG",
  "Michele Chiarlo Barolo Le Orme",
  "Michele Chiarlo Barolo Tortoniano",
  "Michele Chiarlo Dolcetto d'Asti",
  "Michele Chiarlo Gavi dei Gavi Rovereto",
  "Michele Chiarlo Langhe Nebbiolo",
  "Michele Chiarlo Moscato d'Asti Nivole",
  "Michele Chiarlo Nivole Moscato d'Asti",
  "Michele Satta Cavaliere d'Oro Bolgheri",
  "Michèle et Patrice Rion Chambolle-Musigny",
  "Milbrandt Vineyards Traditions Cabernet Sauvignon",
  "Milbrandt Vineyards Traditions Syrah",
  "Mill Creek Vineyards Chardonnay",
  "Miner Family Emily's Blend",
  "Miner Family Winery Cabernet Sauvignon",
  "Minuty Prestige Rosé",
  "Mionetto Prosecco Brut",
  "Miraval Rose",
  "Miraval Studio Rosé",
  "Misha's Vineyard The Lacemaker Riesling",
  "Mission Hill Family Estate Reserve Chardonnay",
  "Mitchell Watervale Riesling",
  "Mitchelton Blackwood Park Riesling",
  "Moccagatta Barbaresco Basarin",
  "Moccagatta Barbaresco Bric Balin",
  "Mollydooker Wines The Boxer Shiraz",
  "Mollydooker Wines Velvet Glove Shiraz",
  "Momtazi Vineyard Maysara Pinot Noir",
  "Monsanto Chianti Classico Il Poggio",
  "Monsanto Chianti Classico Riserva Il Poggio",
  "MontGras Ninquen Mountain Cabernet",
  "MontGras Ninquén Mountain Vineyard Syrah",
  "Monte da Peceguina Alentejo Tinto",
  "Montecillo Rioja Gran Reserva",
  "Montes Alpha Cabernet Sauvignon",
  "Montes Alpha M",
  "Montes Alpha Syrah",
  "Montes Folly Syrah",
  "Montes Montes Folly Syrah",
  "Montes Purple Angel Carmenere",
  "Montes Purple Angel Carmenère",
  "Montevertine Le Pergole Torte",
  "Montevertine Montevertine Toscana",
  "Montevertine Pian del Ciampolo",
  "Montevina Zinfandel",
  "Monticello Vineyards Cabernet Sauvignon",
  "Montinore Estate Pinot Gris",
  "Montinore Estate Pinot Noir",
  "Morande Gran Reserva Sauvignon Blanc",
  "Morellino di Scansano Erik Banti Carato",
  "Morellino di Scansano Erik Banti Morellino di Scansano",
  "Morgan Winery Chardonnay",
  "Morgan Winery Double L Vineyard Chardonnay",
  "Morgan Winery Double L Vineyard Pinot Noir",
  "Morgan Winery Pinot Noir",
  "Morgante Nero d'Avola",
  "Morgon Côte du Py Jean Foillard",
  "Moric Blaufranckisch",
  "Moric Blaufränkisch",
  "Morisfarms Avvoltore",
  "Morisfarms Morellino di Scansano",
  "Moselland Bernkasteler Kurfürstlay Riesling Spätlese",
  "Moselland Piesporter Michelsberg Riesling Kabinett",
  "Moshin Vineyards Pinot Noir",
  "Moss Wood Cabernet Sauvignon",
  "Moss Wood Chardonnay",
  "Moss Wood Winery Cabernet Sauvignon",
  "Mouchão Alentejo Tinto",
  "Mouchão Tonel 3-4",
  "Moulin Touchais Coteaux du Layon",
  "Mount Brave Cabernet Sauvignon",
  "Mount Brown Estates Sauvignon Blanc",
  "Mount Eden Vineyards Cabernet Sauvignon",
  "Mount Eden Vineyards Chardonnay",
  "Mount Eden Vineyards Estate Pinot Noir",
  "Mount Eden Vineyards Pinot Noir",
  "Mount Langi Ghiran Cliff Edge Shiraz",
  "Mount Langi Ghiran Grampians Shiraz",
  "Mount Langi Ghiran Langi Shiraz",
  "Mount Langi Ghiran Shiraz",
  "Mount Riley Sauvignon Blanc",
  "Mouton Cadet Bordeaux Rouge",
  "Movia Ribolla",
  "Moët & Chandon Dom Pérignon Rosé Vintage",
  "Moët & Chandon Grand Vintage Brut",
  "Moët & Chandon Imperial Brut",
  "Moët & Chandon Rosé Impérial Brut",
  "Mt Difficulty Pinot Noir",
  "Mud House Sauvignon Blanc",
  "Muddy Water Riesling",
  "Muga Prado Enea Gran Reserva",
  "Muga Reserva",
  "Muga Rioja Crianza",
  "Muga Rioja Prado Enea Gran Reserva",
  "Muga Rioja Reserva",
  "Muga Rioja Rosado Reserva",
  "Muga Torre Muga",
  "Mulderbosch Chenin Blanc",
  "Mulderbosch Vineyards Rosé of Cabernet Sauvignon",
  "Mullineux & Leeu Kloof Street Red",
  "Mullineux Family Wines Kloof Street White Blend",
  "Mullineux Family Wines Syrah",
  "Mullineux Old Vines White",
  "Mumm Napa Brut Prestige",
  "Mumm Napa DVX",
  "Mumm Napa DVX Blanc de Blancs",
  "Murphy-Goode Winery Cabernet Sauvignon",
  "Murphy-Goode Winery Chardonnay",
  "Murphy-Goode Winery Homefront Cabernet Sauvignon",
  "Murphy-Goode Winery Liar's Dice Zinfandel",
  "Murrieta's Well Cabernet Sauvignon",
  "Murrieta's Well The Whip",
  "Muscadet Sèvre et Maine Château de la Ragotière",
  "Muscadet Sèvre et Maine Domaine de la Pépière",
  "Mvemve Raats De Compostella",
  "Méo-Camuzet Clos de Vougeot Grand Cru",
  "Méo-Camuzet Corton Grand Cru",
  "Méo-Camuzet Nuits-Saint-Georges Aux Murgers Premier Cru",
  "Méo-Camuzet Richebourg Grand Cru",
  "Méo-Camuzet Vosne-Romanée",
  "Méo-Camuzet Vosne-Romanée Aux Brûlées Premier Cru",
  "Mönchhof Ürziger Würzgarten Riesling Spätlese",
  "Müller-Catoir Haardter Bürgergarten Riesling Spätlese",
  "Müller-Catoir Muskateller Spätlese",
  "Naia Naiades Verdejo",
  "Nalle Winery Dry Creek Valley Zinfandel",
  "Nalle Winery Zinfandel",
  "Napa Cellars Cabernet Sauvignon",
  "Napa Cellars Chardonnay",
  "Napa Cellars Reserve Cabernet Sauvignon",
  "Napa Valley Vintners Auction Napa Valley Cabernet Sauvignon",
  "Napa Valley Vintners Tres Sabores Rutherford Cabernet Sauvignon",
  "Napa Valley Wine Company Leviathan Red Wine",
  "Napa Valley Wine Train Cabernet Sauvignon",
  "Napa Wine Company Cabernet Sauvignon",
  "Nautilus Estate Pinot Noir",
  "Nautilus Estate Sauvignon Blanc",
  "Navarro Vineyards Chardonnay",
  "Navarro Vineyards Gewurztraminer",
  "Navarro Vineyards Pinot Gris",
  "Navarro Vineyards Pinot Noir",
  "Navarro Vineyards Riesling",
  "Nebbiolo d'Alba Vietti Nebbiolo d'Alba Perbacco",
  "Neil Ellis Groenekloof Sauvignon Blanc",
  "Neil Ellis Vineyard Selection Cabernet Sauvignon",
  "Nemea Skouras Fleva",
  "Nervi-Conterno Gattinara",
  "Neudorf Moutere Chardonnay",
  "Neudorf Vineyards Moutere Chardonnay",
  "Neudorf Vineyards Sauvignon Blanc",
  "Newton Johnson Chardonnay",
  "Newton Johnson Family Vineyards Pinot Noir",
  "Newton Johnson Pinot Noir",
  "Newton Vineyard Chardonnay",
  "Newton Vineyard Unfiltered Cabernet Sauvignon",
  "Newton Vineyard Unfiltered Merlot",
  "Ngatarawa Alwyn Cabernet Merlot",
  "Nickel & Nickel Dragonfly Vineyard Cabernet Sauvignon",
  "Nickel & Nickel Hacienda Vineyard Cabernet Sauvignon",
  "Nickel & Nickel John C. Sullenger Vineyard Cabernet Sauvignon",
  "Nickel & Nickel Quarry Vineyard Cabernet Sauvignon",
  "Nickel & Nickel Suscol Ranch Cabernet",
  "Nicolas Feuillatte Brut Reserve",
  "Nicolas Feuillatte Brut Rosé",
  "Nicolas Feuillatte Brut Réserve",
  "Nicolas Feuillatte Palmes d'Or Brut Vintage",
  "Nicolas Joly Savennieres Clos de la Coulee de Serrant",
  "Nicolas Joly Savennières Coulée de Serrant",
  "Nicolis Amarone della Valpolicella Classico Ambrosan",
  "Nicosia Etna Rosso",
  "Niepoort Batuta",
  "Niepoort Charme",
  "Niepoort Colheita Tawny Port",
  "Niepoort Drink Me",
  "Niepoort Drink Me Tinto",
  "Niepoort LBV Port",
  "Niepoort Redoma Branco",
  "Niepoort Redoma Tinto",
  "Nieto Senetiner Cadus Stamp of Origin Malbec",
  "Nieto Senetiner Malbec",
  "Nikolaihof Grüner Veltliner Federspiel Hefeabzug",
  "Nikolaihof Grüner Veltliner Smaragd im Weingebirge",
  "Nikolaihof Riesling Smaragd Steiner Hund",
  "Nikolaihof Riesling Vinothek Smaragd",
  "Niner Wine Estates Cabernet Sauvignon",
  "Niner Wine Estates Syrah",
  "Nino Franco Rive di Rua Prosecco Superiore",
  "Nino Franco Rustico Prosecco",
  "Nino Negri Valtellina Superiore Sassella",
  "Nisia Verdejo",
  "Nitida Semillon",
  "Nittnaus Blaufränkisch",
  "No Regrets Syrah",
  "Nobilo Regional Collection Sauvignon Blanc",
  "Nora Albariño",
  "Northstar Winery Cabernet Sauvignon",
  "Northstar Winery Merlot",
  "Norton Privada Blend",
  "Novelty Hill Merlot",
  "Novy Family Wines Cabernet Sauvignon",
  "Novy Family Wines Pinot Noir",
  "Numanthia Numanthia",
  "Numanthia Termanthia",
  "Numanthia Termes",
  "Numanthia Toro",
  "Nyetimber Classic Cuvée Brut",
  "O'Brien Estate Cabernet Sauvignon",
  "O'Shaughnessy Estate Cabernet Sauvignon",
  "O. Fournier Alfa Crux Malbec",
  "Oak Farm Vineyards Cabernet Sauvignon",
  "Oak Farm Vineyards Zinfandel",
  "Oakridge 864 Chardonnay",
  "Oakridge 864 Pinot Noir",
  "Oakridge Chardonnay",
  "Oberon Cabernet Sauvignon",
  "Obsidian Ridge Vineyard Cabernet Sauvignon",
  "Occhipinti SP68 Rosso",
  "Occidental Pinot Noir",
  "Occidental Sonoma Coast Chardonnay",
  "Oddero Barolo",
  "Odette Estate Cabernet Sauvignon",
  "Ojai Vineyard Pinot Noir",
  "Ojai Vineyard Roll Ranch Syrah",
  "Ojai Vineyard Syrah",
  "Old Vines Garnacha",
  "Olivier Leflaive Bourgogne Blanc",
  "Olivier Leflaive Meursault",
  "Olivier Leflaive Puligny-Montrachet",
  "Olivier Leflaive Saint-Aubin",
  "Opolo Vineyards Cabernet Sauvignon",
  "Opolo Vineyards Mountain Zinfandel",
  "Opolo Vineyards Zinfandel",
  "Opus One Napa Valley",
  "Opus One Overture",
  "Opus One Winery Opus One",
  "Opus One Winery Overture",
  "Oremus Tokaji Aszu 5 Puttonyos",
  "Orin Swift 8 Years in the Desert",
  "Orin Swift Papillon",
  "Orma Orma Toscana",
  "Ornellaia Bolgheri Superiore",
  "Ornellaia Le Serre Nuove",
  "Ornellaia Le Serre Nuove dell'Ornellaia",
  "Ornellaia Le Volte dell'Ornellaia",
  "Ornellaia Ornellaia Bianco Bolgheri",
  "Ornellaia Ornellaia Bolgheri Superiore",
  "Ornellaia Ornus dell'Ornellaia",
  "Ornellaia Poggio alle Gazze dell'Ornellaia",
  "Osoyoos Larose Le Grand Vin",
  "Ossian Verdejo",
  "Ostertag Fronholz Riesling",
  "Ostertag Muenchberg Grand Cru Riesling",
  "Overgaauw Tria Corda",
  "Ovid Napa Valley Ovid Red Wine",
  "Owen Roe Abbot's Table",
  "Owen Roe Pinot Noir",
  "Owen Roe Winery Pinot Noir",
  "Oyster Bay Sauvignon Blanc",
  "Oyster Bay Wines Pinot Gris",
  "Oyster Bay Wines Pinot Noir",
  "Oyster Bay Wines Sauvignon Blanc",
  "Pacific Echo Brut",
  "Pacific Rim Dry Riesling",
  "Pacific Rim Riesling",
  "Pago de Carraovejas Cuesta de las Liebres",
  "Pago de Carraovejas El Anejón",
  "Pago de Carraovejas Ribera del Duero",
  "Pago de Carraovejas Ribera del Duero Crianza",
  "Pahlmeyer Chardonnay",
  "Pahlmeyer Napa Valley Chardonnay",
  "Pahlmeyer Proprietary Red",
  "Paitin Barbaresco Serraboella",
  "Palacio de Brejoeira Alvarinho",
  "Palacio de Fefiñanes Albariño de Fefiñanes",
  "Palacio de Fefiñanes Albariño de Fefiñanes III Año",
  "Palacios Remondo La Montesa Rioja",
  "Palacios Remondo Plácet Valtomelloso Rioja Blanco",
  "Pali Wine Co. Pinot Noir",
  "Palivou Estate Agiorgitiko",
  "Palliser Estate Pinot Noir",
  "Palliser Estate Sauvignon Blanc",
  "Palmaz Vineyards Cabernet Sauvignon",
  "Palmer & Co Blanc de Blancs Vintage",
  "Palmer & Co Brut Réserve",
  "Palmina Winery Barbera",
  "Palmina Winery Nebbiolo",
  "Paloma Vineyard Cabernet Sauvignon",
  "Paloma Vineyard Merlot",
  "Panther Creek Pinot Noir",
  "Paolo Scavino Barolo",
  "Paolo Scavino Barolo Bric del Fiasc",
  "Paolo Scavino Barolo Bric dël Fiasc",
  "Paolo Scavino Barolo Cannubi",
  "Paolo Scavino Barolo Rocche dell'Annunziata",
  "Papapietro Perry Leras Family Vineyard Pinot Noir",
  "Papapietro Perry Pinot Noir",
  "Papapietro Perry Winery Chardonnay",
  "Papapietro Perry Winery Pinot Noir",
  "Papargyriou Nemea Agiorgitiko",
  "Paradigm Winery Cabernet Sauvignon",
  "Paraduxx Napa Valley Cabernet",
  "Paraduxx Napa Valley Red",
  "Parallel Napa Valley Cabernet",
  "Parducci Wine Cellars Mendocino Pinot Noir",
  "Paringa Estate Pinot Noir",
  "Paringa Estate Shiraz",
  "Parparoussis Palaeogiannos Muscat",
  "Pascal Jolivet Sancerre",
  "Pascual Toso Malbec",
  "Pask Winery Gimblett Gravels Cabernet Merlot",
  "Paso Creek Cabernet Sauvignon",
  "Pasqua Amarone della Valpolicella",
  "Passopisciaro Contrada C Etna Rosso",
  "Passopisciaro Contrada G Etna Rosso",
  "Passopisciaro Contrada R Etna Rosso",
  "Passopisciaro Contrada S Etna Rosso",
  "Passopisciaro Franchetti Terre Siciliane",
  "Passopisciaro Nerello Mascalese",
  "Passopisciaro Passopisciaro Etna Rosso",
  "Patio Cabernet Sauvignon",
  "Patricia Green Cellars Freedom Hill Vineyard Pinot Noir",
  "Patricia Green Cellars Pinot Noir",
  "Patrick Javillier Bourgogne Blanc",
  "Patrick Javillier Meursault",
  "Patrick Javillier Meursault Cuvée Tête de Murger",
  "Patz & Hall Hyde Vineyard Pinot Noir",
  "Patz & Hall Pinot Noir",
  "Patz & Hall Sonoma Coast Pinot Noir",
  "Paul Achs Blaufränkisch",
  "Paul Dolan Vineyards Pinot Noir",
  "Paul Hobbs Pinot Noir",
  "Paul Hobbs Russian River Valley Chardonnay",
  "Paul Hobbs Winery Cabernet Sauvignon",
  "Paul Hobbs Winery Chardonnay",
  "Paul Hobbs Winery CrossBarn Cabernet Sauvignon",
  "Paul Hobbs Winery CrossBarn Chardonnay",
  "Paul Jaboulet Aine Crozes-Hermitage Thalabert",
  "Paul Jaboulet Aîné Côtes du Rhône Parallèle 45",
  "Paul Jaboulet Aîné Hermitage La Chapelle",
  "Paul Pillot Saint-Aubin Premier Cru",
  "Pauletts Polish Hill River Riesling",
  "Paumanok Vineyards Cabernet Sauvignon",
  "Pax Wine Cellars Sonoma Coast Syrah",
  "Pax Wine Cellars The Hermit Syrah",
  "Pazo Señoráns Selección de Añada Albariño",
  "Pazo de Senorans Albarino",
  "Pazo de Señoráns Albariño",
  "Pazo de Señoráns Selección de Añada",
  "Peachy Canyon Winery Incredible Red",
  "Peachy Canyon Winery Incredible Red Zinfandel",
  "Peachy Canyon Winery Westside Zinfandel",
  "Pear Valley Vineyard Distraction",
  "Peay Vineyards Chardonnay",
  "Peay Vineyards Pinot Noir",
  "Peay Vineyards Scallop Shelf Pinot Noir",
  "Pedernales Cellars GSM",
  "Pedernales Cellars Texas Tempranillo",
  "Pedroncelli Winery Cabernet Sauvignon",
  "Pedroncelli Winery Chardonnay",
  "Pedroncelli Winery Dry Creek Valley Zinfandel",
  "Pedroncelli Winery Mother Clone Zinfandel",
  "Pedroncelli Winery Signature Rose",
  "Pegasus Bay Pinot Noir",
  "Pegasus Bay Riesling",
  "Peique Mencia",
  "Peju Province Sauvignon Blanc",
  "Peju Province Winery Cabernet Sauvignon",
  "Peju Province Winery HB Vineyard Cabernet Sauvignon",
  "Pelissero Barbaresco Nubiola",
  "Pelissero Barbaresco Vanotu",
  "Penfolds Bin 138 Barossa Valley Shiraz Grenache",
  "Penfolds Bin 150 Marananga Shiraz",
  "Penfolds Bin 2 Shiraz Mourvèdre",
  "Penfolds Bin 28 Kalimna Shiraz",
  "Penfolds Bin 389 Cabernet Shiraz",
  "Penfolds Bin 407 Cabernet Sauvignon",
  "Penfolds Bin 51 Eden Valley Riesling",
  "Penfolds Bin 51 Riesling",
  "Penfolds Bin 600 Cabernet Shiraz",
  "Penfolds Bin 707 Cabernet Sauvignon",
  "Penfolds Bin 8 Cabernet Shiraz",
  "Penfolds Father Grand Tawny",
  "Penfolds Grandfather Fine Old Tawny",
  "Penfolds Grange",
  "Penfolds Koonunga Hill Chardonnay",
  "Penfolds Magill Estate Shiraz",
  "Penfolds Max's Chardonnay",
  "Penfolds RWT Barossa Valley Shiraz",
  "Penfolds Rawson's Retreat Cabernet Sauvignon",
  "Penfolds St Henri Shiraz",
  "Penfolds Yattarna Chardonnay",
  "Penman Springs Vineyard Cabernet Sauvignon",
  "Penner-Ash Archaeon Pinot Noir",
  "Penner-Ash Pinot Noir",
  "Penner-Ash Riesling",
  "Penner-Ash Wine Cellars Dussin Vineyard Pinot Noir",
  "Penner-Ash Wine Cellars Lynch Vineyard Pinot Noir",
  "Penner-Ash Wine Cellars Pinot Noir",
  "Penner-Ash Wine Cellars Shea Vineyard Pinot Noir",
  "Pepper Bridge Winery Cabernet Sauvignon",
  "Peregrine Wines Pinot Noir",
  "Perelada Cava Brut Reserva",
  "Perrier-Jouet Belle Epoque",
  "Perrier-Jouet Grand Brut",
  "Perrier-Jouët Belle Époque Rosé",
  "Perrier-Jouët Blason Rosé Brut",
  "Perrin & Fils Châteauneuf-du-Pape Les Sinards",
  "Perrin & Fils Côtes du Rhône Réserve",
  "Perrin & Fils Gigondas L'Oustau de Caumont",
  "Perrin & Fils Réserve Côtes du Rhône Rouge",
  "Perrin et Fils Cairanne",
  "Perrin et Fils Vinsobres Les Cornuds",
  "Pesquera Ribera del Duero Reserva",
  "Pessagno Winery Pinot Noir",
  "Peter Lauer Ayler Kupp Riesling Kabinett",
  "Peter Lauer Riesling Kabinett",
  "Peter Lehmann Barossa Shiraz",
  "Peter Lehmann Eight Songs Shiraz",
  "Peter Lehmann Mentor Cabernet Sauvignon",
  "Peter Lehmann Stonewell Shiraz",
  "Peter Lehmann The Barossa Shiraz",
  "Peter Michael Winery Chardonnay",
  "Peter Michael Winery La Carrière Chardonnay",
  "Peter Michael Winery Ma Belle-Fille Chardonnay",
  "Peter Michael Winery Mon Plaisir Chardonnay",
  "Petrolo Bòggina Trebbiano Toscana",
  "Petrolo Galatrona",
  "Petrolo Galatrona Valdarno di Sopra",
  "Petrolo Torrione",
  "Petrolo Torrione Valdarno di Sopra",
  "Pewsey Vale Prima Riesling",
  "Pewsey Vale Riesling",
  "Pewsey Vale The Contour Riesling",
  "Pewsey Vale The Contours Riesling",
  "Peyrassol Commanderie de Peyrassol Rosé",
  "Pezzi King Vineyards Zinfandel",
  "Pfalz Dr. Bürklin-Wolf Riesling",
  "Pheasant's Tears Rkatsiteli",
  "Phelps Creek Vineyards Cabernet Sauvignon",
  "Phelps Creek Vineyards Cuvée Alexandra Pinot Noir",
  "Phelps Creek Vineyards Pinot Noir",
  "Philippe Alliet Chinon Coteau de Noiré",
  "Philippe Alliet Chinon Vieilles Vignes",
  "Philippe Foreau Vouvray Sec",
  "Philipponnat Clos des Goisses Brut",
  "Philipponnat Royale Réserve Brut",
  "Piaggia Il Sasso Toscana",
  "Piancornello Brunello di Montalcino",
  "Piccini Chianti",
  "Piccini Memoro Red Blend",
  "Pichler-Krutzler Grüner Veltliner Smaragd",
  "Pieropan Recioto di Soave Le Colombare",
  "Pieropan Ruberpan Veronese Rosso",
  "Pieropan Soave Classico",
  "Pieropan Soave Classico Calvarino",
  "Pieropan Soave Classico La Rocca",
  "Pierre Breton Bourgueil Galichets",
  "Pierre Breton Bourgueil Trinch",
  "Pierre Gonon Saint-Joseph",
  "Pierre Moncuit Blanc de Blancs",
  "Pierre Morey Meursault",
  "Pierre Péters Cuvée de Réserve Blanc de Blancs",
  "Pierre Péters L'Esprit Blanc de Blancs Grand Cru",
  "Pierre Usseglio Châteauneuf-du-Pape",
  "Pierro Chardonnay",
  "Pietradolce Etna Rosso Archineri",
  "Pietradolce Vigna Barbagalli Etna Rosso",
  "Pikes The Merle Reserve Chardonnay",
  "Pikes Traditionale Riesling",
  "Pine Ridge Vineyards Cabernet Sauvignon",
  "Pine Ridge Vineyards Carneros Dijon Chardonnay",
  "Pine Ridge Vineyards Epitome Red Wine",
  "Pine Ridge Vineyards Fortis Cabernet Sauvignon",
  "Pine Ridge Vineyards Stags Leap District Cabernet Sauvignon",
  "Pingus Flor de Pingus",
  "Pingus PSI",
  "Pingus Pingus",
  "Pio Cesare Arneis Langhe",
  "Pio Cesare Barbaresco",
  "Pio Cesare Barbera d'Alba",
  "Pio Cesare Barbera d'Asti",
  "Pio Cesare Barolo",
  "Pio Cesare Barolo Mosconi",
  "Pio Cesare Barolo Ornato",
  "Pio Cesare Chardonnay Piodilei Langhe",
  "Pio Cesare Dolcetto d'Alba",
  "Pio Cesare Langhe Nebbiolo",
  "Piper's Brook Riesling",
  "Piper-Heidsieck Brut Cuvée",
  "Piper-Heidsieck Rare Brut Millésimé",
  "Piper-Heidsieck Rose Sauvage",
  "Pique-Poul de Pinet Picpoul de Pinet",
  "Pira (Chiara Boschis) Barolo Mosconi",
  "Pira (Chiara Boschis) Barolo Via Nuova",
  "Pirramimma Shiraz",
  "Pisano RPF Tannat",
  "Pisoni Vineyard Estate Pinot Noir",
  "Pittacum Barrica Mencía",
  "Pittacum Petalos del Bierzo",
  "Pittnauer St Laurent",
  "Piña Napa Valley Buckeye Vineyard Cabernet",
  "Piña Napa Valley Cabernet Sauvignon",
  "Placido Pinot Grigio",
  "Planeta Alastro Grecanico Sicilia",
  "Planeta Cerasuolo di Vittoria",
  "Planeta Chardonnay",
  "Planeta Cometa Fiano di Sicilia",
  "Planeta Etna Bianco",
  "Planeta Etna Rosso Eruzione 1614",
  "Planeta La Segreta Bianco",
  "Planeta La Segreta Rosso",
  "Planeta Merlot Sicilia",
  "Planeta Nero d'Avola",
  "Planeta Santa Cecilia Noto",
  "Planeta Syrah Sicilia",
  "Plumpjack Winery Cabernet Sauvignon",
  "Plumpjack Winery Estate Cabernet Sauvignon",
  "Plumpjack Winery Reserve Cabernet Sauvignon",
  "Podere Forte Guardavigna",
  "Podere Il Carnasciale Caberlot",
  "Podere Il Palazzino Chianti Classico",
  "Poderi Aldo Conterno Barbera d'Alba Conca Tre Pile",
  "Poderi Aldo Conterno Barolo Cicala",
  "Poderi Aldo Conterno Barolo Colonnello",
  "Poderi Aldo Conterno Barolo Granbussia Riserva",
  "Poderi Aldo Conterno Barolo Romirasco",
  "Poderi Aldo Conterno Granbussia Barolo Riserva",
  "Poeira Poeira Tinto",
  "Poeira Tinto",
  "Poet's Leap Cabernet Sauvignon",
  "Poet's Leap Riesling",
  "Poggio Antico Brunello di Montalcino",
  "Poggio Antico Rosso di Montalcino Altero",
  "Poggio al Tesoro Dedicato a Walter Bolgheri Superiore",
  "Poggio al Tesoro Solosole Vermentino Bolgheri",
  "Poggio di Sotto Brunello di Montalcino",
  "Poggio di Sotto Brunello di Montalcino Riserva",
  "Poggio di Sotto Rosso di Montalcino",
  "Poggiopiano Rosso di Sera",
  "Pol Roger Blanc de Blancs Vintage",
  "Pol Roger Brut Rosé Vintage",
  "Pol Roger Brut Réserve",
  "Pol Roger Sir Winston Churchill Cuvée",
  "Poliziano Asinone Vino Nobile di Montepulciano",
  "Poliziano Le Stanze Toscana",
  "Poliziano Rosso di Montepulciano",
  "Poliziano Vino Nobile di Montepulciano",
  "Polz Sauvignon Blanc",
  "Pomar Junction Vineyard & Winery Petite Verdot",
  "Pommery Brut Rosé",
  "Pommery Brut Royal",
  "Pommery Louise Vintage Brut",
  "Ponzi Vineyards Abetina Pinot Noir",
  "Ponzi Vineyards Chardonnay",
  "Ponzi Vineyards Pinot Gris",
  "Ponzi Vineyards Pinot Noir",
  "Ponzi Vineyards Reserve Pinot Noir",
  "Pope Valley Winery Cabernet Sauvignon",
  "Port Phillip Estate Red Hill Pinot Noir",
  "Porter Creek Pinot Noir",
  "Porter Creek Vineyards Pinot Noir",
  "Porter Creek Zinfandel",
  "Powers Syrah",
  "Powers Winery Cabernet Sauvignon",
  "Prager Grüner Veltliner Smaragd Hinter der Burg",
  "Prager Riesling Smaragd Wachstum Bodenstein",
  "Prager Wachstum Bodenstein Grüner Veltliner",
  "Prats & Symington Chryseia",
  "Prats & Symington Post Scriptum",
  "Prats & Symington Post Scriptum de Chryseia",
  "Precept Wine Browne Family Vineyards Cabernet Sauvignon",
  "Precept Wine Canoe Ridge Vineyard Cabernet Sauvignon",
  "Presqu'ile Winery Chardonnay",
  "Presqu'ile Winery Pinot Noir",
  "Preston Farm & Winery Dry Creek Valley Zinfandel",
  "Pride Mountain Vineyards Cabernet Sauvignon",
  "Pride Mountain Vineyards Merlot",
  "Prieler Blaufränkisch Johanneshöhe",
  "Priest Ranch Cabernet Sauvignon",
  "Produttori del Barbaresco Barbaresco",
  "Produttori del Barbaresco Barbaresco Montestefano Riserva",
  "Produttori del Barbaresco Barbaresco Rabaja Riserva",
  "Produttori del Barbaresco Barbaresco Riserva Asili",
  "Produttori del Barbaresco Barbaresco Riserva Moccagatta",
  "Produttori del Barbaresco Barbaresco Riserva Montestefano",
  "Produttori del Barbaresco Barbaresco Riserva Ovello",
  "Produttori del Barbaresco Barbaresco Riserva Pajé",
  "Produttori del Barbaresco Barbaresco Riserva Pora",
  "Produttori del Barbaresco Barbaresco Riserva Rabaja",
  "Produttori del Barbaresco Barbaresco Riserva Rio Sordo",
  "Promontory Proprietary Red Wine",
  "Prophet's Rock Pinot Noir",
  "Protos Finca El Grajo Viejo",
  "Protos Gran Reserva",
  "Protos Reserva",
  "Provenance Vineyards Cabernet Sauvignon",
  "Provenance Vineyards Merlot",
  "Provenance Vineyards Reserve Cabernet Sauvignon",
  "Provenance Vineyards Rutherford Cabernet Sauvignon",
  "Prunotto Barbaresco Montestefano",
  "Prunotto Barbera d'Asti",
  "Prunotto Barolo",
  "Prunotto Barolo Bussia",
  "Prunotto Barolo Cannubi",
  "Prunotto Fiulot Barbera d'Asti",
  "Prunotto Mompertone Monferrato Rosso",
  "Prunotto Nebbiolo d'Alba Occhetti",
  "Prunotto Roero Arneis",
  "Pulenta Estate Gran Cabernet Sauvignon",
  "Pulenta Estate Gran Malbec",
  "Pulenta Estate La Flor de Pulenta Malbec",
  "Punset Barbaresco",
  "Punt Road Pinot Noir",
  "Pursued by Bear Cabernet Sauvignon",
  "Pyramid Valley Pinot Noir",
  "Quady Elysium Black Muscat",
  "Quady Essencia Orange Muscat",
  "Quails' Gate Chardonnay",
  "Quartz Reef Bendigo Pinot Noir",
  "Quartz Reef Brut Method Traditionnelle",
  "Querciabella Batàr",
  "Querciabella Camartina",
  "Querciabella Camartina Toscana",
  "Querciabella Chianti Classico",
  "Quilceda Creek Cabernet Sauvignon",
  "Quilceda Creek Galitzine Vineyard Cabernet Sauvignon",
  "Quilceda Creek Vintners Cabernet Sauvignon",
  "Quinta Vale D. Maria Douro Tinto",
  "Quinta da Aveleda Alvarinho",
  "Quinta da Aveleda Vinho Verde",
  "Quinta da Crasto Douro Grande Escolha",
  "Quinta da Pellada Dão Branco",
  "Quinta da Romaneira Douro",
  "Quinta da Romaneira Douro Tinto",
  "Quinta da Rosa Late Bottled Vintage Port",
  "Quinta da Rosa Reserva Tinto",
  "Quinta das Carvalhas Douro",
  "Quinta de Chocapalha Colheita",
  "Quinta de Chocapalha Vinho Regional Lisboa Tinto",
  "Quinta de Pellada Dão Tinto",
  "Quinta de Roriz Prazo de Roriz",
  "Quinta de Roriz Prazo de Roriz Branco",
  "Quinta de Roriz Reserva",
  "Quinta de Ventozelo Douro Tinto",
  "Quinta de la Quietud Corral de Campanas",
  "Quinta de la Rosa Ruby Port",
  "Quinta do Ameal Vinho Verde",
  "Quinta do Crasto 10 Year Old Tawny Port",
  "Quinta do Crasto Douro Superior",
  "Quinta do Crasto Douro Tinto",
  "Quinta do Crasto LBV Port",
  "Quinta do Crasto Late Bottled Vintage Port",
  "Quinta do Crasto Maria Teresa",
  "Quinta do Crasto Reserva Old Vines",
  "Quinta do Crasto Reserva Old Vines Douro",
  "Quinta do Crasto Touriga Nacional",
  "Quinta do Panascal Fonseca Vintage Port",
  "Quinta do Passadouro Douro",
  "Quinta do Portal Grande Reserva",
  "Quinta do Vale D. Maria Douro Reserva",
  "Quinta do Vale Meão Douro",
  "Quinta do Vale Meão Meandro",
  "Quinta do Vale Meão Meandro do Vale Meão",
  "Quinta do Vale Meão Vale Meão",
  "Quinta do Vallado Adelaide Red",
  "Quinta do Vallado Adelaide Reserva",
  "Quinta do Vallado Douro",
  "Quinta do Vallado Reserva",
  "Quinta do Vesuvio Pombal do Vesuvio",
  "Quinta do Vesuvio Vintage Port",
  "Quinta dos Roques Dão Tinto",
  "Quinta dos Roques Encruzado",
  "Quinta dos Roques Touriga Nacional",
  "Quintarelli Amarone della Valpolicella Classico",
  "Quintarelli Valpolicella Classico Superiore",
  "Quintessa Quintessa Red Wine",
  "Quivira Vineyards Dry Creek Valley Zinfandel",
  "Quivira Vineyards Grenache",
  "Quixote Winery Petite Sirah",
  "Qupe Syrah",
  "Qupé Syrah",
  "Qupé Wine Cellars Bien Nacido Vineyard Syrah",
  "Qupé Wine Cellars Syrah",
  "R. Lopez de Heredia Vina Tondonia Blanco Reserva",
  "R. Lopez de Heredia Vina Tondonia Reserva Rioja",
  "R. Lopez de Heredia Viña Tondonia Rosado",
  "R. Stuart & Co. Pinot Noir",
  "Raats Family Wines Cabernet Franc",
  "Raats Family Wines Original Chenin Blanc",
  "Rabl Grüner Veltliner",
  "Radikon Ribolla Gialla",
  "Radio-Coteau La Neblina Pinot Noir",
  "Radio-Coteau Platt Vineyard Syrah",
  "Radio-Coteau Syrah",
  "Rafael Palacios As Sortes Godello",
  "Rafanelli Winery Zinfandel",
  "Ramey Wine Cellars Cabernet Sauvignon",
  "Ramey Wine Cellars Chardonnay",
  "Ramey Wine Cellars Hyde Vineyard Chardonnay",
  "Ramey Wine Cellars Pinot Noir",
  "Ramey Wine Cellars Rochioli-Sweetwater Chardonnay",
  "Ramey Wine Cellars Russian River Valley Chardonnay",
  "Ramonet Montrachet Grand Cru",
  "Ramos Pinto 10 Year Tawny Port",
  "Ramos Pinto 20 Year Old Tawny Quinta da Ervamoira",
  "Ramos Pinto Duas Quintas",
  "Ramos Pinto Duas Quintas Reserva",
  "Ramos Pinto Duas Quintas Tinto",
  "Raptor Ridge Chehalem Mountains Pinot Noir",
  "Raptor Ridge Pinot Noir",
  "Raptor Ridge Winery Pinot Noir",
  "Rare Wine Co. Historic Series New York Malmsey Madeira",
  "Ratti Barolo Marcenasco",
  "Ravenswood Dickerson Vineyard Zinfandel",
  "Ravenswood Lodi Zinfandel",
  "Ravenswood Teldeschi Vineyard Zinfandel",
  "Ravenswood Vintners Blend Zinfandel",
  "Ravenswood Winery Lodi Zinfandel",
  "Ravenswood Winery Old Hill Ranch Zinfandel",
  "Ravenswood Winery Pickberry Cabernet Sauvignon",
  "Ravenswood Winery Vintners Blend Zinfandel",
  "Raventós i Blanc De Nit Rosé Cava",
  "Raventós i Blanc L'Hereu Brut",
  "Raventós i Blanc L'Hereu Cava Brut",
  "Ravines Wine Cellars Argetsinger Riesling",
  "Ravines Wine Cellars Dry Riesling",
  "Raymond Vineyards Reserve Cabernet Sauvignon",
  "Raúl Pérez La Vizcaína",
  "Raúl Pérez Sketch Rias Baixas",
  "Raúl Pérez Ultreia Saint-Jacques",
  "RdV Vineyards Rendezvous",
  "Realm Cellars Cabernet Sauvignon",
  "Realm Cellars Farella Vineyard Cabernet",
  "Realm Cellars The Bard",
  "Red Newt Cellars Riesling",
  "Redhawk Vineyard & Winery Pinot Noir",
  "Reichsgraf von Kesselstatt Riesling Sekt Brut",
  "Reichsrat von Buhl Forster Ungeheuer Riesling Spätlese",
  "Reichsrat von Buhl Riesling Kabinett",
  "Reinhold Haart Piesporter Goldtröpfchen Riesling Auslese",
  "Reinhold Haart Piesporter Goldtröpfchen Riesling Spätlese",
  "Reininger Winery Cabernet Sauvignon",
  "Remhoogte Estate Merlot",
  "Remo Farina Amarone della Valpolicella Classico",
  "Remoissenet Père & Fils Beaune Grèves",
  "Remírez de Ganuza Gran Reserva",
  "Remírez de Ganuza Rioja Gran Reserva",
  "Remírez de Ganuza Rioja Reserva",
  "Renacer Punto Final Malbec",
  "Renato Ratti Barbera d'Alba Torriglione",
  "Renato Ratti Barolo Marcenasco",
  "Renato Ratti Dolcetto d'Alba Colombe",
  "Renato Ratti Langhe Nebbiolo",
  "Renwood Winery Old Vine Zinfandel",
  "Renwood Winery Premier Old Vine Zinfandel",
  "Renwood Winery Premier Zinfandel",
  "René Rostaing Côte-Rôtie Côte Blonde",
  "René Rostaing Côte-Rôtie La Landonne",
  "Resonance Chardonnay",
  "Resonance Pinot Noir",
  "Resonance Vineyard Pinot Noir",
  "Resonance Vineyard Resonance Vineyard Pinot Noir",
  "Reverie Winery Cabernet Sauvignon",
  "Rex Hill Pinot Noir",
  "Rex Hill Vineyards Pinot Noir",
  "Reynolds Family Winery Reserve Cabernet",
  "Rhys Vineyards Alpine Vineyard Chardonnay",
  "Rhys Vineyards Alpine Vineyard Pinot Noir",
  "Rias Baixas Martin Codax Albariño",
  "Ricasoli Rocca Guicciarda Chianti Classico",
  "Ridge Vineyards Dusi Ranch Zinfandel",
  "Ridge Vineyards Estate Cabernet Sauvignon",
  "Ridge Vineyards Geyserville",
  "Ridge Vineyards Lytton Springs",
  "Ridge Vineyards Monte Bello",
  "Ridge Vineyards Pagani Ranch Zinfandel",
  "Ridge Vineyards Santa Cruz Mountains Estate Cabernet Sauvignon",
  "Ridge Vineyards Three Valleys",
  "Ridge Vineyards York Creek Zinfandel",
  "Ridgeview Wine Estate Bloomsbury Brut",
  "Rippon Pinot Noir",
  "Rippon Vineyard Mature Vine Pinot Noir",
  "Rivera Il Falcone",
  "Rivera Il Falcone Castel del Monte",
  "Rivera Puer Apuliae Primitivo",
  "Riverbench Vineyard & Winery Chardonnay",
  "Riverbench Vineyard & Winery Pinot Noir",
  "Riverbench Winery Chardonnay",
  "Riverbench Winery Pinot Noir",
  "Roar Wines Pinot Noir",
  "Robert Biale Vineyards Royal Punisher Zinfandel",
  "Robert Craig Winery Affinity Cabernet Sauvignon",
  "Robert Craig Winery Cabernet Sauvignon",
  "Robert Groffier Bonnes-Mares Grand Cru",
  "Robert Groffier Chambolle-Musigny",
  "Robert Groffier Chambolle-Musigny Les Amoureuses Premier Cru",
  "Robert Hall Winery Cabernet Sauvignon",
  "Robert Hunter Winery Brut de Noirs",
  "Robert Mondavi Winery Cabernet Sauvignon",
  "Robert Mondavi Winery Fumé Blanc",
  "Robert Mondavi Winery Maestro Red Wine",
  "Robert Mondavi Winery Napa Valley Cabernet Sauvignon",
  "Robert Mondavi Winery Napa Valley Chardonnay",
  "Robert Mondavi Winery Napa Valley Merlot",
  "Robert Mondavi Winery Reserve Cabernet Sauvignon",
  "Robert Mondavi Winery Reserve Chardonnay",
  "Robert Mondavi Winery To Kalon Vineyard Cabernet Sauvignon",
  "Robert Mondavi Winery To Kalon Vineyard Reserve Cabernet Sauvignon",
  "Robert Sinskey Vineyards Pinot Noir",
  "Robert Weil Kiedricher Grafenberg Riesling Beerenauslese",
  "Robert Weil Kiedricher Gräfenberg Riesling Auslese",
  "Robert Weil Kiedricher Gräfenberg Riesling Spätlese",
  "Robert Weil Riesling Trocken",
  "Robert Young Estate Winery Cabernet Sauvignon",
  "Roberto Voerzio Barolo Brunate",
  "Roberto Voerzio Barolo Capalot delle Brunate",
  "Roberto Voerzio Barolo Cerequio",
  "Roberto Voerzio Barolo Fossati",
  "Roberto Voerzio Barolo La Serra",
  "Rocca delle Macìe Chianti Classico",
  "Rocca delle Macìe Chianti Classico Gran Selezione Sergio Zingarelli",
  "Rocca delle Macìe Chianti Classico Riserva",
  "Rocca delle Macìe Vernaiolo Chianti",
  "Rocca di Castagnoli Chianti Classico",
  "Rocca di Montegrossi Chianti Classico",
  "Rocca di Montegrossi Chianti Classico Gran Selezione",
  "Rocca di Montegrossi Chianti Classico Riserva San Marcellino",
  "Rocca di Montegrossi Geremia Toscana",
  "Rocca di Montegrossi Vin Santo del Chianti Classico",
  "Rochioli Estate Chardonnay",
  "Rochioli Vineyard & Winery Chardonnay",
  "Rochioli Vineyard & Winery Estate Pinot Noir",
  "Rochioli Vineyard & Winery Pinot Noir",
  "Rochioli Vineyard & Winery West Block Pinot Noir",
  "Rochioli Vineyard Estate Chardonnay",
  "Rochioli Vineyard Estate Sauvignon Blanc",
  "Rochioli Vineyard Sauvignon Blanc",
  "Rockford Basket Press Shiraz",
  "Rockford Wines Basket Press Shiraz",
  "Rockford Wines Rifle Range Cabernet Sauvignon",
  "Rodney Strong Vineyards Alexander's Crown Cabernet",
  "Rodney Strong Vineyards Alexander's Crown Cabernet Sauvignon",
  "Rodney Strong Vineyards Cabernet Sauvignon",
  "Rodney Strong Vineyards Chalk Hill Chardonnay",
  "Rodney Strong Vineyards Chardonnay",
  "Rodney Strong Vineyards Charlotte's Home Sauvignon Blanc",
  "Rodney Strong Vineyards Knotty Vines Zinfandel",
  "Rodney Strong Vineyards Pinot Noir",
  "Roederer Estate Anderson Valley Pinot Noir",
  "Roederer Estate Brut",
  "Roederer Estate L'Ermitage",
  "Roger Perrin Châteauneuf-du-Pape",
  "Rolf Binder Hales Shiraz Grenache",
  "Rolly Gassmann Pinot Gris Réserve",
  "Rolly Gassmann Riesling",
  "Romanée-Conti La Tâche Grand Cru",
  "Rombauer Vineyards Cabernet Sauvignon",
  "Rombauer Vineyards Chardonnay",
  "Rombauer Vineyards Diamond Selection Cabernet Sauvignon",
  "Rombauer Vineyards Proprietors Selection Chardonnay",
  "Rombauer Vineyards Stice Lane Vineyard Cabernet Sauvignon",
  "Rombauer Vineyards Zinfandel",
  "Roodeberg Red Blend",
  "Root:1 Sauvignon Blanc",
  "Rosemount Estate Diamond Label Chardonnay",
  "Rosemount Estate Diamond Label Shiraz",
  "Rosenblum Cellars Continente Vineyard Zinfandel",
  "Rosenblum Cellars Vintners Cuvee Zinfandel",
  "Roulot Meursault",
  "Roulot Meursault Charmes Premier Cru",
  "Roulot Meursault Perrieres Premier Cru",
  "Round Pond Estate Cabernet Sauvignon",
  "Royal Tokaji 5 Puttonyos Aszú",
  "Royal Tokaji 5 Puttonyos Tokaji Aszu",
  "Royal Tokaji Mezes Maly Tokaji Aszu 6 Puttonyos",
  "Ruca Malen Malbec",
  "Ruca Malen Yauquen Malbec",
  "Rudd Estate Cabernet Sauvignon",
  "Rudd Estate Estate Cabernet Sauvignon",
  "Rudd Estate Sauvignon Blanc",
  "Rudolf Fürst Bürgstadter Hundsrück Spätburgunder",
  "Ruffino Chianti Classico Riserva Ducale Gold",
  "Ruffino Chianti Classico Riserva Ducale Oro",
  "Ruffino Chianti DOCG",
  "Ruffino Lumina Pinot Grigio",
  "Ruffino Modus",
  "Ruffino Modus Toscana",
  "Ruffino Prosecco",
  "Ruffino Riserva Ducale Chianti Classico Riserva",
  "Ruffino Riserva Ducale Oro Chianti Classico Gran Selezione",
  "Ruffino Romitorio di Santedame",
  "Rui Reguinga Convento de São Francisco",
  "Ruinart Blanc de Blancs",
  "Ruinart Brut Rosé",
  "Ruinart Dom Ruinart Blanc de Blancs",
  "Ruinart Dom Ruinart Rosé",
  "Rulo Winery Syrah",
  "Russo Etna Rosso",
  "Rust en Vrede Estate Cabernet Sauvignon",
  "Rustenberg Cabernet Sauvignon",
  "Rustenberg John X Merriman",
  "Rutherford Hill Cabernet Sauvignon",
  "Rutherford Hill Merlot",
  "Rutherford Hill Winery Cabernet Sauvignon",
  "Rutherford Ranch Cabernet Sauvignon",
  "Rutini Malbec",
  "Sacred Hill Helmsman Cabernet Sauvignon",
  "Sacred Hill Sauvignon Blanc",
  "Saddleback Cellars Cabernet Sauvignon",
  "Sadie Family Wines Columella",
  "Sadie Family Wines Palladius",
  "Sagrantino di Montefalco Arnaldo Caprai Sagrantino di Montefalco 25 Anni",
  "Saint Clair Family Estate Sauvignon Blanc",
  "Saint Clair Marlborough Sauvignon Blanc",
  "Saint Clair Pioneer Block Sauvignon Blanc",
  "Saintsbury Chardonnay",
  "Saintsbury Pinot Noir",
  "Saintsbury Toyon Farm Pinot Noir",
  "Salomon Undhof Grüner Veltliner Kögl",
  "Salon Le Mesnil Blanc de Blancs",
  "Salvestrin Winery Cabernet Sauvignon",
  "Salvioni Brunello di Montalcino",
  "Samuel's Gorge Shiraz",
  "San Felice Chianti Classico",
  "San Felice Chianti Classico Riserva Il Grigio",
  "San Felice Pugnitello Toscana",
  "San Felice Vigorello Toscana",
  "San Filippo Brunello di Montalcino",
  "San Filippo Brunello di Montalcino Le Lucere Riserva",
  "San Giusto a Rentennano Chianti Classico",
  "San Leonardo San Leonardo Vigneti delle Dolomiti",
  "San Leonardo Villa Gresti Vigneti delle Dolomiti",
  "San Vincenti Chianti Classico",
  "Sancerre Rouge Domaine Thomas",
  "Sandalford Margaret River Cabernet Sauvignon",
  "Sandeman 20 Year Old Tawny Port",
  "Sandeman Founders Reserve Port",
  "Sandhi Sanford & Benedict Chardonnay",
  "Sandhi Santa Barbara County Chardonnay",
  "Sandhi Wines Chardonnay",
  "Sandrone Barolo Le Vigne",
  "Sanford Winery Chardonnay",
  "Sanford Winery La Rinconada Vineyard Pinot Noir",
  "Sanford Winery Pinot Noir",
  "Sanford Winery Sanford & Benedict Pinot Noir",
  "Sangre de Toro Tempranillo",
  "Santa Carolina Reserva de Familia Carmenere",
  "Santa Duc Gigondas Les Hautes Garrigues",
  "Santa Ema Amplus Carmenère",
  "Santa Julia Malbec",
  "Santa Margherita Merlot Alto Adige",
  "Santa Margherita Pinot Grigio",
  "Santa Margherita Pinot Grigio Valdadige",
  "Santa Margherita Prosecco",
  "Santa Margherita Rosé",
  "Santa Rita 120 Cabernet Sauvignon",
  "Santa Rita Casa Real Cabernet Sauvignon",
  "Santa Rita Hills Brewer-Clifton Chardonnay",
  "Santa Rita Medalla Real Cabernet Sauvignon",
  "Santa Sofia Amarone della Valpolicella",
  "Santadi Terre Brune",
  "Santiago Ruiz O Rosal Albariño Blend",
  "Santo Wines Santorini Assyrtiko",
  "Santorini Estate Argyros Cuvée Monsignori",
  "Saracco Moscato d'Asti",
  "Sartarelli Verdicchio dei Castelli di Jesi Classico Superiore",
  "Sassicaia Bolgheri Sassicaia",
  "Sassicaia Guidalberto Bolgheri",
  "Sassicaia Le Difese Toscana",
  "Sassicaia Sassicaia Bolgheri",
  "Sassoalloro Sassoalloro Toscana",
  "Saviah Cellars The Jack Cabernet Sauvignon",
  "Saxum Vineyards Broken Stones",
  "Saxum Vineyards James Berry Vineyard",
  "Scala Dei Cartoixa Reserva",
  "Scala Dei Prior Priorat",
  "Scarecrow Wine Cabernet Sauvignon",
  "Scheid Family Wines Pinot Noir",
  "Schiopetto Tocai Friulano",
  "Schloss Gobelsburg Gobelsburger Grüner Veltliner",
  "Schloss Gobelsburg Grüner Veltliner Gobelsburger",
  "Schloss Gobelsburg Grüner Veltliner Lamm",
  "Schloss Gobelsburg Grüner Veltliner Renner",
  "Schloss Gobelsburg Riesling Heiligenstein",
  "Schloss Johannisberg Riesling Grünlack Spätlese",
  "Schloss Johannisberg Riesling Silberlack",
  "Schloss Johannisberg Riesling Silberlack Spätlese",
  "Schloss Lieser Lieser Niederberg Helden Riesling Spätlese",
  "Schloss Saarstein Riesling Spatlese",
  "Schloss Vollrads Riesling Kabinett",
  "Schlossgut Diel Dorsheimer Goldloch Riesling Auslese",
  "Schlossgut Diel Dorsheimer Pittermännchen Riesling Kabinett",
  "Schrader Cellars CCS Cabernet Sauvignon",
  "Schramsberg Blanc de Blancs Brut",
  "Schramsberg Vineyards Blanc de Blancs",
  "Schramsberg Vineyards Blanc de Noirs",
  "Schramsberg Vineyards J. Schram",
  "Schug Carneros Estate Winery Heritage Reserve Pinot Noir",
  "Schug Carneros Estate Winery Pinot Noir",
  "Scilio Etna Rosso",
  "Scott Harvey Wines Zinfandel",
  "Scott Paul Wines La Paulée Pinot Noir",
  "Screaming Eagle Cabernet Sauvignon",
  "Scribe Winery Cabernet Sauvignon",
  "Scribe Winery Chardonnay",
  "Scribe Winery Estate Cabernet Sauvignon",
  "Scribe Winery Pinot Noir",
  "Scribe Winery Rosé",
  "Sea Smoke Cellars Chardonnay",
  "Sea Smoke Cellars Southing Pinot Noir",
  "Sea Smoke Cellars Ten Pinot Noir",
  "Sea Smoke Southing Pinot Noir",
  "Seavey Vineyard Cabernet Sauvignon",
  "Seavey Vineyard Merlot",
  "Sebastiani Vineyards & Winery Cabernet Sauvignon",
  "Sebastiani Vineyards & Winery Chardonnay",
  "Sebastiani Vineyards Cabernet Sauvignon",
  "Sebastiani Vineyards Pinot Noir",
  "Seghesio Family Cortina Zinfandel",
  "Seghesio Family Home Ranch Zinfandel",
  "Seghesio Family Sonoma Zinfandel",
  "Seghesio Family Vineyards Cabernet Sauvignon",
  "Seghesio Family Vineyards Home Ranch Zinfandel",
  "Seghesio Family Vineyards Old Vine Zinfandel",
  "Seghesio Family Vineyards Sonoma Zinfandel",
  "Segura Viudas Brut Reserva Cava",
  "Selbach-Oster Bernkasteler Schlossberg Riesling Kabinett",
  "Selbach-Oster Riesling Kabinett",
  "Selbach-Oster Riesling Spatlese",
  "Selbach-Oster Riesling Trocken",
  "Selbach-Oster Zeltinger Schlossberg Riesling Kabinett",
  "Selbach-Oster Zeltinger Sonnenuhr Riesling Auslese",
  "Selbach-Oster Zeltinger Sonnenuhr Riesling Beerenauslese",
  "Selbach-Oster Zeltinger Sonnenuhr Riesling Spätlese",
  "Selene Wines Merlot",
  "Sella & Mosca Alghero Tanca Farrà",
  "Sella & Mosca Cannonau di Sardegna",
  "Sella & Mosca Cannonau di Sardegna Riserva",
  "Sella & Mosca La Cala Vermentino di Sardegna",
  "Sella & Mosca Marchese di Villamarina Cabernet Sauvignon",
  "Sella & Mosca Terre Bianche Torbato Alghero",
  "Selvapiana Chianti Rufina",
  "Selvapiana Chianti Rufina Riserva Bucerchiale",
  "Selvapiana Chianti Rufina Vigneto Bucerchiale Riserva",
  "Selvapiana Vin Santo del Chianti Rufina",
  "Senorio de San Vicente Rioja",
  "Sepp Moser Grüner Veltliner",
  "Seppelt Drumborg Riesling",
  "Seppelt Drumborg Vineyard Riesling",
  "Seppelt Great Entertainer Shiraz",
  "Seppelt Show Sparkling Shiraz",
  "Seppeltsfield Barossa Shiraz",
  "Seppeltsfield Para Grand Tawny 21 Years",
  "Sequoia Grove Napa Valley Cabernet Sauvignon",
  "Sequoia Grove Rutherford Reserve Cabernet",
  "Sequoia Grove Winery Cabernet Sauvignon",
  "Sequoia Grove Winery Cambium Red Wine",
  "Seresin Estate Pinot Noir",
  "Seresin Estate Sauvignon Blanc",
  "Settesoli Nero d'Avola",
  "Seven Falls Merlot",
  "Seven Hills Winery Cabernet Sauvignon",
  "Seven Hills Winery Rosé",
  "Seven of Hearts Pinot Noir",
  "Seven of Hearts Winery Pinot Noir",
  "Seña Seña",
  "Señorío de San Vicente San Vicente Rioja",
  "Shadowbrook Cabernet Sauvignon",
  "Shadowfax Pinot Noir",
  "Shafer Vineyards Hillside Select Cabernet Sauvignon",
  "Shafer Vineyards Merlot",
  "Shafer Vineyards One Point Five Cabernet Sauvignon",
  "Shafer Vineyards TD-9 Cabernet Sauvignon Blend",
  "Shafer Vineyards TD-9 Red Blend",
  "Shannon Ridge Winery Cabernet Sauvignon",
  "Shaw + Smith Pinot Noir",
  "Shaw + Smith Shiraz",
  "Shaw and Smith M3 Chardonnay",
  "Shaw and Smith Sauvignon Blanc",
  "Shaw and Smith Shiraz",
  "Shea Wine Cellars Block 23 Pinot Noir",
  "Shea Wine Cellars Pinot Noir",
  "Sherwin Family Vineyards Cabernet Sauvignon",
  "Shinn Estate Vineyards Cabernet Franc",
  "Shinn Estate Vineyards First Fruit Merlot",
  "Shinn Estate Vineyards Merlot",
  "Siduri Wines Anderson Valley Pinot Noir",
  "Siduri Wines Pinot Noir",
  "Siduri Wines Pisoni Vineyard Pinot Noir",
  "Siduri Wines Santa Lucia Highlands Pinot Noir",
  "Sierra Cantabria El Bosque",
  "Signorello Estate Padrone Cabernet Sauvignon",
  "Silver Oak Alexander Valley Cabernet",
  "Silver Oak Alexander Valley Cabernet Sauvignon",
  "Silver Oak Cellars Alexander Valley Cabernet Sauvignon",
  "Silver Oak Cellars Napa Valley Cabernet Sauvignon",
  "Silver Oak Napa Valley Cabernet Sauvignon",
  "Silver Thread Vineyard Riesling",
  "Silverado Vineyards Cabernet Sauvignon",
  "Silverado Vineyards Chardonnay",
  "Silverado Vineyards Mt. George Vineyard Cabernet Sauvignon",
  "Simi Winery Cabernet Sauvignon",
  "Simi Winery Chardonnay",
  "Simi Winery Pinot Noir",
  "Simi Winery Reserve Cabernet Sauvignon",
  "Simon Bize Savigny-les-Beaune",
  "Simonsig Kaapse Vonkel",
  "Simonsig Redhill Pinotage",
  "Simonsig Tiara",
  "Sine Qua Non Syrah",
  "Sineann Pinot Noir",
  "Siro Pacenti Rosso di Montalcino",
  "Skillogalee Clare Valley Riesling",
  "Skouras Moscofilero",
  "Sleight of Hand The Conjurer",
  "Smith Woodhouse Lodge Reserve Port",
  "Smith-Madrone Vineyards Cabernet Sauvignon",
  "Smith-Madrone Vineyards Riesling",
  "Smoking Loon Cabernet Sauvignon",
  "Smoking Loon Chardonnay",
  "Snowden Vineyards The Ranch Cabernet Sauvignon",
  "Soalheiro Alvarinho",
  "Soalheiro Reserva Alvarinho",
  "Sobon Estate Rocky Top Zinfandel",
  "Sobon Estate Zinfandel",
  "Sojourn Cellars Pinot Noir",
  "Sokol Blosser Pinot Noir",
  "Sokol Blosser Winery Evolution Pinot Noir",
  "Sokol Blosser Winery Orchard Block Reserve Pinot Noir",
  "Sokol Blosser Winery Pinot Gris",
  "Sokol Blosser Winery Pinot Noir",
  "Sokol Blosser Winery Rosé of Pinot Noir",
  "Soldera Brunello di Montalcino Case Basse",
  "Sonoma-Cutrer Russian River Ranches Chardonnay",
  "Sonoma-Cutrer The Cutrer Chardonnay",
  "Sonoma-Cutrer Vineyards Les Pierres Chardonnay",
  "Sonoma-Cutrer Vineyards Russian River Ranches Chardonnay",
  "Sonoma-Cutrer Vineyards The Cutrer Chardonnay",
  "Sonoma-Loeb Ambassador's Reserve Chardonnay",
  "Soon Cabernet Sauvignon",
  "Sori San Lorenzo Gaja Barbaresco",
  "Soter Vineyards Estates Pinot Noir",
  "Soter Vineyards Mineral Springs Pinot Noir",
  "Soter Vineyards Mineral Springs Ranch Pinot Noir",
  "Soter Vineyards North Valley Pinot Noir",
  "Speri Amarone della Valpolicella",
  "Speri Amarone della Valpolicella Classico",
  "Speri Amarone della Valpolicella Classico Sant'Urbano",
  "Speri Valpolicella Ripasso Classico Superiore",
  "Spice Route Chakalaka Red Blend",
  "Spice Route Pinotage",
  "Spier Creative Block 5 White Blend",
  "Spier Signature Chenin Blanc",
  "Spottswoode Estate Cabernet Sauvignon",
  "Spottswoode Estate Lyndenhurst Cabernet Sauvignon",
  "Spottswoode Estate Sauvignon Blanc",
  "Spottswoode Estate Vineyard & Winery Sauvignon Blanc",
  "Spottswoode Sauvignon Blanc",
  "Spreitzer Oestricher Doosberg Riesling Spätlese",
  "Spreitzer Oestricher Lenchen Riesling Spätlese",
  "Spring Mountain Vineyard Estate Cabernet",
  "Spring Valley Vineyard Frederick Cabernet Sauvignon",
  "Spy Valley Pinot Gris",
  "Spy Valley Sauvignon Blanc",
  "Spy Valley Wines Sauvignon Blanc",
  "St Hallett Blackwell Shiraz",
  "St Hallett Faith Shiraz",
  "St Hallett Old Block Shiraz",
  "St. Clement Vineyards Cabernet Sauvignon",
  "St. Clement Vineyards Chardonnay",
  "St. Francis Winery Cabernet Sauvignon",
  "St. Francis Winery Chardonnay",
  "St. Francis Winery Merlot",
  "St. Francis Winery Reserve Cabernet Sauvignon",
  "St. Francis Winery Zinfandel",
  "St. Innocent Winery Pinot Noir",
  "St. Innocent Winery Temperance Hill Vineyard Pinot Noir",
  "St. Innocent Winery Villages Cuvée Pinot Noir",
  "St. Urbans-Hof Ockfener Bockstein Riesling Spätlese",
  "Staatliche Weinbaudomäne Mosel Bernkasteler Doctor Riesling Auslese",
  "Stadlmann Zierfandler Mandel-Höh",
  "Stag's Leap Wine Cellars Arcadia Vineyard Chardonnay",
  "Stag's Leap Wine Cellars Artemis Cabernet Sauvignon",
  "Stag's Leap Wine Cellars Cask 23 Cabernet Sauvignon",
  "Stag's Leap Wine Cellars Chardonnay",
  "Stag's Leap Wine Cellars Fay Vineyard Cabernet Sauvignon",
  "Stag's Leap Wine Cellars Hands of Time Chardonnay",
  "Stag's Leap Wine Cellars Hands of Time Red Wine",
  "Stag's Leap Wine Cellars Karia Chardonnay",
  "Stag's Leap Wine Cellars LEAP Cabernet Sauvignon",
  "Stag's Leap Wine Cellars Merlot",
  "Stag's Leap Wine Cellars Rosé",
  "Stag's Leap Wine Cellars Rosé of Merlot",
  "Stag's Leap Wine Cellars S.L.V. Cabernet Sauvignon",
  "Stag's Leap Wine Cellars Winemaker's Note Cabernet",
  "Stag's Leap Winery Cabernet Sauvignon",
  "Staglin Family Vineyard Estate Cabernet Sauvignon",
  "Stags' Leap Winery Merlot",
  "Stags' Leap Winery Ne Cede Malis Cabernet Sauvignon",
  "Stags' Leap Winery Petite Sirah",
  "Standing Stone Vineyards Riesling",
  "Stanger Vineyards Cabernet Sauvignon",
  "Stanton & Killeen Classic Rutherglen Muscat",
  "Stark-Condé Cabernet Sauvignon",
  "Stark-Condé Three Pines Cabernet Sauvignon",
  "Ste Michelle Wine Estates Eroica Gold Riesling",
  "Steele Wines Zinfandel",
  "Steenberg Catharina",
  "Stefano Accordini Amarone della Valpolicella",
  "Stella Bella Cabernet Sauvignon",
  "Steltzner Vineyards Cabernet Sauvignon",
  "Stemmari Pinot Grigio",
  "Sterling Vineyards Chardonnay",
  "Sterling Vineyards Reserve Cabernet Sauvignon",
  "Stewart Cellars Cabernet Sauvignon",
  "Stoller Family Estate Cathy's Reserve Pinot Noir",
  "Stoller Family Estate Chardonnay",
  "Stoller Family Estate Pinot Noir",
  "Stoller Family Estate Reserve Pinot Noir",
  "Stoller Family Estate Rosé",
  "Stoller Family Estate SV Estate Pinot Noir",
  "Stolpman Vineyards Estate Grown La Cuadrilla",
  "Stolpman Vineyards Syrah",
  "Stone Tower Winery Cabernet Franc",
  "Stonefish Sauvignon Blanc",
  "Stonefly Vineyard Cabernet Sauvignon",
  "Stonefly Vineyard Pinot Noir",
  "Stonefly Vineyard Reserve Cabernet Sauvignon",
  "Stoneleigh Sauvignon Blanc",
  "Stonestreet Estate Monument Ridge Cabernet",
  "Stonestreet Estate Vineyards Cabernet Sauvignon",
  "Stonestreet Estate Vineyards Chardonnay",
  "Stonestreet Estate Vineyards Monument Ridge Cabernet Sauvignon",
  "Stonestreet Estate Vineyards Upper Barn Chardonnay",
  "Stonestreet Legacy Cabernet Sauvignon",
  "Stonier Pinot Noir",
  "Stonier Reserve Pinot Noir",
  "Stony Hill Vineyard Chardonnay",
  "Storm Wines Ridge Pinot Noir",
  "Story Winery Zinfandel",
  "Storybook Mountain Vineyards Estate Zinfandel",
  "Storybook Mountain Vineyards Zinfandel",
  "Storypoint Wines Cabernet Sauvignon",
  "Storypoint Wines Chardonnay",
  "Stratus Icewine",
  "Stuhlmuller Vineyards Cabernet Sauvignon",
  "Stuhlmuller Vineyards Chardonnay",
  "Stéphane Ogier Côte-Rôtie La Belle Hélène",
  "Stéphane Ogier Côte-Rôtie Mon Village",
  "Suavia Soave Classico Monte Carbonare",
  "Substance Cabernet Sauvignon",
  "Suertes del Marques 7 Fuentes",
  "Sullivan Vineyards Cabernet Sauvignon",
  "Summers Estate Wines Cabernet Sauvignon",
  "Summers Estate Wines Reserve Cabernet Sauvignon",
  "Summerwood Winery Diosa",
  "Susana Balbo Brioso Red Blend",
  "Susana Balbo Crios Malbec",
  "Susana Balbo Signature Malbec",
  "Sutter Home Winery Cabernet Sauvignon",
  "Sutter Home Winery Chardonnay",
  "Sutter Home Winery Moscato",
  "Sutter Home Winery White Zinfandel",
  "Swanson Vineyards Alexis Cabernet Sauvignon",
  "Swanson Vineyards Merlot",
  "Swanson Vineyards Salon Red Blend",
  "Swanson Vineyards Sangiovese",
  "Switchback Ridge Cabernet Sauvignon",
  "Switchback Ridge Peterson Family Vineyard Merlot",
  "Sylvain Cathiard Bourgogne Rouge",
  "Symington Altano Douro",
  "Syncline Subduction Red",
  "Syncline Wine Cellars Grüner Veltliner",
  "Syncline Wine Cellars Subduction Red",
  "Sérafin Père et Fils Gevrey-Chambertin Les Cazetiers Premier Cru",
  "Sérafin Père et Fils Gevrey-Chambertin Vieilles Vignes",
  "Tabali Pedregoso Gran Reserva Syrah",
  "Tabalí Reserva Especial Pinot Noir",
  "Tablas Creek Vineyard Cotes de Tablas Blanc",
  "Tablas Creek Vineyard Côtes de Tablas",
  "Tablas Creek Vineyard Côtes de Tablas Blanc",
  "Tablas Creek Vineyard Esprit de Tablas",
  "Tablas Creek Vineyard Grenache",
  "Tablas Creek Vineyard Mourvèdre",
  "Tahbilk 1860 Vines Marsanne",
  "Tahbilk 1927 Vines Marsanne",
  "Tahbilk Marsanne",
  "Tahbilk Shiraz",
  "Taittinger Brut La Francaise",
  "Taittinger Brut Millésimé Vintage",
  "Taittinger Comtes de Champagne Blanc de Blancs",
  "Taittinger Comtes de Champagne Rosé",
  "Taittinger Prélude Grands Crus Brut",
  "Talbott Vineyards Pinot Noir",
  "Talbott Vineyards Sleepy Hollow Vineyard Chardonnay",
  "Talenti Brunello di Montalcino",
  "Talenti Rosso di Montalcino",
  "Talley Vineyards Chardonnay",
  "Talley Vineyards Pinot Noir",
  "Tamarack Cellars Cabernet Sauvignon",
  "Tandem Pinot Noir",
  "Tandem Winery Pinot Noir",
  "Tantara Winery Pinot Noir",
  "Tardieu-Laurent Châteauneuf-du-Pape",
  "Tardieu-Laurent Côtes du Rhône Vieilles Vignes",
  "Tardieu-Laurent Hermitage Rouge",
  "TarraWarra Estate Chardonnay",
  "TarraWarra Estate Pinot Noir",
  "Tasca d'Almerita Lamuri Nero d'Avola",
  "Tasca d'Almerita Nozze d'Oro Contessa Entellina Bianco",
  "Tasca d'Almerita Regaleali Bianco",
  "Tasca d'Almerita Regaleali Nero d'Avola",
  "Tasca d'Almerita Rosso del Conte",
  "Tasca d'Almerita Tascante Contrada Sciaranuova Etna Bianco",
  "Tasca d'Almerita Tascante Ghiaia Nera Etna Rosso",
  "Tatachilla Foundation Shiraz",
  "Taurino Patriglione",
  "Taurino Salice Salentino Riserva",
  "Tawny Port Kopke 10 Year",
  "Tawse Winery Pinot Noir",
  "Taylor Fladgate 10 Year Tawny Port",
  "Taylor Fladgate 20 Year Old Tawny Port",
  "Taylor Fladgate 20 Year Tawny Port",
  "Taylor Fladgate 30 Year Old Tawny Port",
  "Taylor Fladgate First Estate Reserve Port",
  "Taylor Fladgate LBV Port",
  "Taylor Fladgate Late Bottled Vintage Port",
  "Taylor Fladgate Vargellas Vintage Port",
  "Taylor Fladgate Vintage Port",
  "Taylors Wines Jaraman Riesling",
  "Taylors Wines St Andrews Cabernet Sauvignon",
  "Taz Vineyards Pinot Noir",
  "Te Kairanga Pinot Noir",
  "Te Mata Coleraine",
  "Te Mata Coleraine Cabernet Merlot",
  "Te Mata Estate Vineyards Chardonnay",
  "Te Whare Ra Pinot Gris",
  "Tedeschi Amarone della Valpolicella Capitel Monte Olmi Riserva",
  "Tedeschi Amarone della Valpolicella Classico",
  "Tedeschi Amarone della Valpolicella Marne 180",
  "Tedeschi Capitel Monte Fontana Recioto della Valpolicella",
  "Tedeschi Capitel Monte Olmi Amarone",
  "Tedeschi Valpolicella Ripasso Superiore",
  "Teliani Valley Kindzmarauli",
  "Telmo Rodriguez Al Muvedre",
  "Telmo Rodriguez Almuvedre",
  "Telmo Rodriguez Basa Blanco",
  "Telmo Rodriguez Dehesa Gago",
  "Telmo Rodriguez Gaba do Xil Godello",
  "Telmo Rodriguez LZ Rioja",
  "Telmo Rodriguez Las Beatas Rioja",
  "Telmo Rodriguez Matallana",
  "Telmo Rodriguez Molino Real Mountain Wine",
  "Tement Sauvignon Blanc",
  "Tendril Wine Cellars Pinot Noir",
  "Tensley Syrah",
  "Tenuta Guado al Tasso Il Bruciato",
  "Tenuta Sella Lessona",
  "Tenuta Sette Ponti Crognolo Toscana",
  "Tenuta Sette Ponti Oreno Toscana",
  "Tenuta di Biserno Biserno Toscana",
  "Tenuta di Biserno Il Pino di Biserno Toscana",
  "Tenuta di Trinoro Palazzi Toscana",
  "Tenuta di Trinoro Toscana Rosso",
  "Terlan Pinot Grigio",
  "Tero Estates Cabernet Sauvignon",
  "Terra Valentine Cabernet Sauvignon",
  "Terra Valentine Wurtele Vineyard Cabernet",
  "TerraNoble Carmenere",
  "TerraNoble Gran Reserva Carmenère",
  "Terrabianca Chianti Classico",
  "Terras Gauda Albariño",
  "Terras Gauda O Rosal",
  "Terrazas de los Andes Reserva Malbec",
  "Terre Nere Calderara Sottana Etna Rosso",
  "Terre Nere Etna Bianco",
  "Terre Nere Etna Rosso",
  "Terre Nere Prephylloxera La Vigna di Don Peppino Etna Rosso",
  "Terre Rouge Syrah",
  "Terre Rouge Viognier",
  "Terre Rouge Wines Sentinel Oak Vineyard Syrah",
  "Terre Rouge Wines Syrah",
  "Terre de Trinci Montefalco Sagrantino",
  "Terre di Trinci Montefalco Sagrantino",
  "Terre di Trinci Sagrantino",
  "Terredora Fiano di Avellino",
  "Terredora Taurasi",
  "Terredora di Paolo Falanghina",
  "Terredora di Paolo Taurasi",
  "Terroir Al Límit Les Tosses",
  "Terroir Al Límit Pedra de Guix",
  "Terroir al Limit Arbossar",
  "Terroir al Límit Arbossar",
  "Terry Hoage The Hedge",
  "Testarossa Winery Pinot Noir",
  "Testarossa Winery Pisoni Vineyard Pinot Noir",
  "Tetramythos Roditis",
  "Thandi Pinotage",
  "Thanisch Bernkasteler Doctor Riesling",
  "Thanisch Bernkasteler Doctor Riesling Auslese",
  "The Eyrie Vineyards Pinot Gris",
  "The Federalist Cabernet Sauvignon",
  "The Hess Collection Allomi Cabernet Sauvignon",
  "The Hess Collection Cabernet Sauvignon",
  "The Hess Collection Select Cabernet Sauvignon",
  "The Prisoner Wine Company Blindfold Rosé",
  "The Prisoner Wine Company Red Blend",
  "The Prisoner Wine Company Thorn Cabernet Sauvignon",
  "The Prisoner Wine Company Unshackled Cabernet Sauvignon",
  "The Prisoner Wine Company Unshackled Chardonnay",
  "The Wolftrap Red Blend",
  "Thelema Mountain Vineyards Cabernet Sauvignon",
  "Thierry Allemand Cornas Chaillot",
  "Thierry Allemand Cornas Reynard",
  "Thierry Germain Saumur-Champigny",
  "Thomas Fogarty Cabernet Sauvignon",
  "Thomas Fogarty Pinot Noir",
  "Thomas Fogarty Winery Pinot Noir",
  "Thomas George Estates Pinot Noir",
  "Three Rivers Winery Meritage",
  "Three Sticks Chardonnay",
  "Three Sticks Pinot Noir",
  "Three Sticks Wines Cabernet Sauvignon",
  "Three Sticks Wines Pinot Noir",
  "Tiefenbrunner Lagrein Alto Adige",
  "Tiefenbrunner Pinot Grigio",
  "Tignanello Toscana IGT",
  "Tikal Patriota",
  "Tinhorn Creek Oldfield Reserve Cabernet Franc",
  "Toad Hollow Chardonnay",
  "Tobin James Ballistic Zinfandel",
  "Tobin James Cellars Ballistic Zinfandel",
  "Tobin James Cellars Fat Boy Zinfandel",
  "Tokara Chardonnay",
  "Tokara Director's Reserve Red",
  "Tollot-Beaut Chorey-les-Beaune",
  "Tollot-Beaut Chorey-lès-Beaune",
  "Tommasi Amarone della Valpolicella Classico",
  "Tommasi Le Rosse Pinot Grigio delle Venezie",
  "Tommasi Valpolicella Ripasso Classico Superiore",
  "Torbreck RunRig Shiraz",
  "Torbreck Struie Shiraz",
  "Torbreck The Bothie Muscat",
  "Torbreck The Steading",
  "Torbreck The Struie Shiraz",
  "Torbreck Woodcutter's Shiraz",
  "Torchiana Grenache",
  "Torii Mor Winery Deux Verres Pinot Noir",
  "Torii Mor Winery Pinot Noir",
  "Tormaresca Masseria Maime Negroamaro",
  "Tormaresca Neprica",
  "Tormaresca Neprica Primitivo",
  "Tormaresca Primitivo Torcicoda Salento",
  "Toro Albala Don PX Gran Reserva",
  "Torre Quarto Tavoliere Primitivo",
  "Torres De Casta Rosé",
  "Torres Fransola Sauvignon Blanc",
  "Torres Gran Coronas Cabernet Sauvignon",
  "Torres Gran Coronas Reserva",
  "Torres Mas La Plana Cabernet Sauvignon",
  "Torres Mas la Plana",
  "Torres Viña Sol White",
  "Torrontés Riojano Crios Torrontés",
  "Toulouse Vineyards Pinot Noir",
  "Transcendence Wine Pinot Noir",
  "Trapiche Broquel Malbec",
  "Trapiche Iscay Malbec Merlot",
  "Trapiche Medalla Malbec",
  "Trapiche Oak Cask Malbec",
  "Travaglini Gattinara",
  "Travaglini Gattinara Riserva",
  "Travaglini Gattinara Tre Vigne",
  "Trefethen Family Vineyards Cabernet Sauvignon",
  "Trefethen Family Vineyards Chardonnay",
  "Trefethen Family Vineyards Dragon's Tooth Red Wine",
  "Trefethen Merlot",
  "Trentadue Winery La Storia Cabernet Sauvignon",
  "Tres Sabores Cabernet Sauvignon",
  "Trimbach Clos Sainte Hune Riesling",
  "Trimbach Frédéric Émile Riesling",
  "Trimbach Gewurztraminer Réserve",
  "Trimbach Gewurztraminer Selection de Grains Nobles",
  "Trimbach Pinot Blanc",
  "Trimbach Pinot Gris Réserve",
  "Trimbach Riesling",
  "Trimbach Riesling Clos Sainte Hune",
  "Trimbach Riesling Réserve",
  "Trinchero Mario's Vineyard Cabernet",
  "Trinchero Napa Valley Forte Cabernet Sauvignon",
  "Trinchero Napa Valley Mario's Vineyard Cabernet Sauvignon",
  "Trinity Hill Gimblett Gravels Syrah",
  "Trione Family Vineyards Cabernet Sauvignon",
  "Trione Vineyards & Winery Cabernet Sauvignon",
  "Trione Vineyards Russian River Valley Pinot Noir",
  "Trisaetum Coast Range Pinot Noir",
  "Trisaetum Coast Range Riesling",
  "Trisaetum Pinot Gris",
  "Trisaetum Pinot Noir",
  "Trisaetum Ribbon Ridge Pinot Noir",
  "Trivento Reserve Malbec",
  "Trois Noix Cabernet Sauvignon",
  "Troon Vineyard Pinot Noir",
  "Truchard Vineyards Cabernet Sauvignon",
  "Truchard Vineyards Chardonnay",
  "Truchard Vineyards Merlot",
  "Truchard Vineyards Pinot Noir",
  "Truchard Vineyards Syrah",
  "Truchard Vineyards Zinfandel",
  "Trujillo Wines Cabernet Sauvignon",
  "Tsantali Rapsani Reserve",
  "Tua Rita Giusto di Notri",
  "Tua Rita Giusto di Notri Toscana",
  "Tua Rita Per Sempre Syrah Toscana",
  "Tua Rita Redigaffi Toscana",
  "Tuck Beckstoffer Wines Cabernet Sauvignon",
  "Turley Wine Cellars Dusi Vineyard Zinfandel",
  "Turley Wine Cellars Hayne Vineyard Zinfandel",
  "Turley Wine Cellars Juvenile Zinfandel",
  "Turley Wine Cellars Old Vines Zinfandel",
  "Turley Wine Cellars Pesenti Vineyard Zinfandel",
  "Turley Wine Cellars Petite Sirah",
  "Turley Wine Cellars Rattlesnake Ridge Zinfandel",
  "Turnbull Wine Cellars Cabernet Sauvignon",
  "Turnbull Wine Cellars Old Bull Cabernet",
  "Turnbull Wine Cellars Reserve Cabernet Sauvignon",
  "Twenty Rows Cabernet Sauvignon",
  "Twisted Oak Winery Tempranillo",
  "Two Hands Angels' Share Shiraz",
  "Two Hands Gnarly Dudes Shiraz",
  "Two Hands Wines Bella's Garden Shiraz",
  "Two Hands Wines Gnarly Dudes Shiraz",
  "Two Paddocks Pinot Noir",
  "Two Vines Cabernet Sauvignon",
  "Twomey Cellars Cabernet Sauvignon",
  "Twomey Cellars Chardonnay",
  "Twomey Cellars Merlot",
  "Twomey Cellars Pinot Noir",
  "Twomey Sauvignon Blanc",
  "Txomin Etxaniz Txakoli",
  "Tyrrell's Vat 1 Hunter Valley Semillon",
  "Tyrrell's Vat 1 Semillon",
  "Tyrrell's Vat 47 Chardonnay",
  "Tyrrell's Vat 9 Shiraz",
  "Téofilo Reyes Ribera del Duero Crianza",
  "Ulysse Collin Les Maillons",
  "Ulysse Collin Les Pierrières Blanc de Blancs",
  "Umani Ronchi Casal di Serra Verdicchio",
  "Umani Ronchi Conero Riserva Campo San Giorgio",
  "Umani Ronchi Cumaro Conero",
  "Umani Ronchi Montepulciano d'Abruzzo",
  "Umani Ronchi Pelago Marche Rosso",
  "Umani Ronchi Plenio Verdicchio Riserva",
  "Umani Ronchi Rosso Conero Serrano",
  "Umani Ronchi Verdicchio dei Castelli di Jesi Classico Superiore Casal di Serra Vecchie Vigne",
  "Umani Ronchi Villa Bianchi Verdicchio dei Castelli di Jesi",
  "Umathum Blaufränkisch",
  "Underwood Cellars Pinot Noir",
  "Undurraga Sibaris Gran Reserva Carmenere",
  "Undurraga Sibaris Gran Reserva Pinot Noir",
  "Undurraga T.H. Pinot Noir",
  "Unison Vineyard Reserve Red",
  "Unti Vineyards Grenache",
  "Unti Vineyards Segromigno",
  "Utopia Vineyard Pinot Noir",
  "V. Sattui Winery Cabernet Sauvignon",
  "Va Piano Vineyards Cabernet Sauvignon",
  "Vacqueyras Les Christins Perrin & Fils Vacqueyras",
  "Valdesil Valdeorras Godello",
  "Valdespino Inocente Fino Sherry",
  "Valentini Montepulciano d'Abruzzo",
  "Valentini Trebbiano d'Abruzzo",
  "Vall Llach Embruix",
  "Valle Reale Montepulciano d'Abruzzo",
  "Valle dell'Acate Grillo",
  "Valle dell'Acate Il Moro",
  "Valli Central Otago Pinot Noir",
  "Valli Vineyards Pinot Noir",
  "Van Ruiten Family Winery Zinfandel",
  "Van Volxem Wiltinger Gottefuss Riesling",
  "Varner Wine Pinot Noir",
  "Varner Wine Spring Ridge Vineyard Chardonnay",
  "Varramista Syrah",
  "Vasse Felix Cabernet Sauvignon",
  "Vasse Felix Chardonnay",
  "Vasse Felix Heytesbury",
  "Vasse Felix Heytesbury Chardonnay",
  "Vasse Felix Premier Cabernet Sauvignon",
  "Vavasour Sauvignon Blanc",
  "Vecchie Terre di Montefili Anfiteatro",
  "Vega Sicilia Alión",
  "Vega Sicilia Macan",
  "Vega Sicilia Macan Clásico",
  "Vega Sicilia Pintia",
  "Vega Sicilia Valbuena 5°",
  "Vega Sicilia Único",
  "Vega Sicilia Único Reserva Especial",
  "Velenosi Roggio del Filare Rosso Piceno Superiore",
  "Velich Tiglat Chardonnay",
  "Venge Vineyards Cabernet Sauvignon",
  "Vergelegen Cabernet Sauvignon Merlot",
  "Verget Mâcon-Villages",
  "Verget Pouilly-Fuisse Terroir de Fuisse",
  "Verité La Joie",
  "Verité Le Désir",
  "Vespa Granello Primitivo",
  "Veuve Clicquot La Grande Dame Brut",
  "Veuve Clicquot La Grande Dame Rosé",
  "Veuve Clicquot Rose",
  "Veuve Clicquot Vintage Brut",
  "Veuve Clicquot Yellow Label Brut",
  "Viader Estate",
  "Viader Vineyards & Winery Proprietary Red Blend",
  "Vida Nova Rosé",
  "Vie di Romans Chardonnay",
  "Vietti Barbaresco Masseria",
  "Vietti Barbera d'Alba Scarrone Vigna Vecchia",
  "Vietti Barbera d'Asti La Crena",
  "Vietti Barbera d'Asti Nizza La Crena",
  "Vietti Barbera d'Asti Scarrone",
  "Vietti Barbera d'Asti Tre Vigne",
  "Vietti Barolo Brunate",
  "Vietti Barolo Castiglione",
  "Vietti Barolo Lazzarito",
  "Vietti Barolo Monvigliero",
  "Vietti Barolo Ravera",
  "Vietti Barolo Rocche di Castiglione",
  "Vietti Barolo Villero",
  "Vietti Brunello di Montalcino",
  "Vietti Langhe Rosso",
  "Vietti Moscato d'Asti Cascinetta",
  "Vietti Perbacco Langhe Nebbiolo",
  "Vietti Roero Arneis",
  "Vieux Chateau Certan Pomerol",
  "Vieux Château Certan Pomerol",
  "Vilicich Family Winery Zinfandel",
  "Villa Creek Cellars Avenger",
  "Villa Maria Estate Private Bin Sauvignon Blanc",
  "Villa Maria Estate Reserve Sauvignon Blanc",
  "Villa Maria Pinot Noir",
  "Villa Maria Private Bin Sauvignon Blanc",
  "Villa Matilde Falanghina",
  "Villa Sandi Prosecco Brut",
  "Villiera Bush Vine Sauvignon Blanc",
  "Vilmart & Cie Grand Cellier",
  "Vilmart & Cie Grand Cellier d'Or Premier Cru",
  "Vina Leyda Pinot Noir",
  "Vina Robles Cabernet Sauvignon",
  "Vina Salceda Rioja Reserva",
  "Vincent Girardin Meursault",
  "Vineyard 29 Aida Estate Cabernet Sauvignon",
  "Vineyard 29 Cabernet Sauvignon",
  "Vinha da Defesa Monsaraz",
  "Vinum Cellars Chevignol Pinot Noir",
  "Vista Hills Vineyard Pinot Noir",
  "Viu Manent Single Vineyard Malbec",
  "Viviani Amarone della Valpolicella",
  "Vizcarra Ribera del Duero Crianza",
  "Vizcarra Senda del Oro Roble",
  "Viña Carmen Cabernet Sauvignon Reserva",
  "Viña Carmen Carmen Gold Reserve Cabernet Sauvignon",
  "Viña Cobos Bramare Malbec",
  "Viña Cobos Cobos Malbec",
  "Viña Cobos Felino Malbec",
  "Viña Concha y Toro Don Melchor Cabernet Sauvignon",
  "Viña Falernia Carmenere",
  "Viña Godeval Godello",
  "Viña Leyda Pinot Noir Las Brisas",
  "Viña Leyda Sauvignon Blanc Garuma",
  "Viña Maipo Vitral Reserva Carmenère",
  "Viña Montes Alpha Cabernet Sauvignon",
  "Viña Salceda Rioja Crianza",
  "Viña San Pedro Castillo de Molina Cabernet",
  "Viña Tondonia Rioja Blanco Reserva",
  "Viña Undurraga Aliwen Carmenere",
  "Viña Ventisquero Carmenere Gran Reserva",
  "Viña Von Siebenthal Montelig",
  "Viñedo Chadwick Chadwick",
  "Viñedos del Contino Rioja Graciano",
  "Volker Eisele Cabernet Sauvignon",
  "Volnay Clos des Chênes Domaine Marquis d'Angerville",
  "Volpaia Chianti Classico",
  "Volpaia Chianti Classico Riserva",
  "Volpaia Coltassala Chianti Classico Gran Selezione",
  "Volver Tarima Monastrell",
  "Von Kesselstatt Riesling",
  "Von Strasser Cabernet Sauvignon",
  "Voyager Estate Cabernet Sauvignon Merlot",
  "Voyager Estate Chardonnay",
  "Vérité La Muse",
  "Wachau Domane Gruner Veltliner Smaragd Kellerberg",
  "Wachau Winzer Krems Grüner Veltliner",
  "Wairau River Pinot Noir",
  "Wairau River Sauvignon Blanc",
  "Wakefield Riesling",
  "Walla Walla Vintners Cabernet Sauvignon",
  "Walter Hansel Cuvee Alyce Chardonnay",
  "Walter Hansel Pinot Noir",
  "Walter Hansel Winery Chardonnay",
  "Walter Hansel Winery Pinot Noir",
  "Walter Scott Wines Pinot Noir",
  "Warre's Otima 10 Year Old Tawny Port",
  "Warre's Vintage Port",
  "Warre's Warrior Reserve Port",
  "Warwick Estate First Lady Cabernet Sauvignon",
  "Warwick Estate Three Cape Ladies",
  "Warwick The Blue Lady Cabernet Franc",
  "Waterbrook Winery Cabernet Sauvignon",
  "Waterbrook Winery Merlot",
  "Waterbrook Winery Reserve Cabernet Sauvignon",
  "Waterford Estate Cabernet Sauvignon",
  "Wayfarer Wine Chardonnay",
  "Wayfarer Wine Pinot Noir",
  "Wegeler Bernkasteler Doctor Riesling Spätlese",
  "Weinert Cabernet Sauvignon",
  "Weinert Carrascal Cabernet Sauvignon",
  "Weingut Alzinger Grüner Veltliner",
  "Weingut Alzinger Riesling Smaragd Loibenberg",
  "Weingut Brundlmayer Grüner Veltliner Berg Vogelsang",
  "Weingut Brundlmayer Grüner Veltliner Lamm",
  "Weingut Brundlmayer Riesling Heiligenstein",
  "Weingut Emmerich Knoll Riesling Kellerberg Smaragd",
  "Weingut Gunderloch Jean-Baptiste Riesling",
  "Weingut Gunderloch Nackenheimer Rothenberg Riesling Auslese",
  "Weingut Heinrich Blaufränkisch",
  "Weingut Hirt Grüner Veltliner",
  "Weingut Keller Riesling Trocken G-Max",
  "Weingut Keller Riesling von der Fels",
  "Weingut Keller Westhofen Riesling",
  "Weingut Loimer Grüner Veltliner Langenlois",
  "Weingut Loimer Riesling Seeberg",
  "Weingut Pauly-Bergweiler Bernkasteler Alte Badstube Riesling Spätlese",
  "Weingut Pichler-Krutzler Riesling",
  "Weingut Pittnauer Zweigelt",
  "Weingut Prager Grüner Veltliner Smaragd Achleiten",
  "Weingut Prager Riesling Smaragd",
  "Weingut Robert Weil Kiedrich Gräfenberg Riesling Spätlese",
  "Weingut Stadt Krems Grüner Veltliner",
  "Weingut Wittmann Westhofener Riesling Trocken",
  "Weingut am Stein Stein Riesling Trocken",
  "Weingut van Volxem Scharzhofberger Riesling",
  "Weinviertel DAC Pfaffl Grüner Veltliner",
  "Wente Vineyards Charles Wetmore Reserve Cabernet Sauvignon",
  "Wente Vineyards Morning Fog Chardonnay",
  "Wente Vineyards Nth Degree Chardonnay",
  "Wente Vineyards Riva Ranch Chardonnay",
  "Wente Vineyards Riva Ranch Reserve Chardonnay",
  "Wente Vineyards Southern Hills Cabernet Sauvignon",
  "Westrey Wine Company Oracle Pinot Noir",
  "Whispering Angel Côtes de Provence Rosé",
  "White Rock Vineyards Cabernet Sauvignon",
  "White Rose Estate Pinot Noir",
  "Whitehall Lane Cabernet Sauvignon",
  "Whitehall Lane Merlot",
  "Whitehall Lane Winery Cabernet Sauvignon",
  "Whitehall Lane Winery Chardonnay",
  "Whitehall Lane Winery Reserve Cabernet Sauvignon",
  "Whitehaven Sauvignon Blanc",
  "Whitford Cellars Cabernet Sauvignon",
  "Wieninger Grüner Veltliner Select",
  "Wieninger Nussberg Alte Reben Grüner Veltliner",
  "Wild Earth Pinot Noir",
  "Wildekrans Chenin Blanc",
  "WillaKenzie Estate Pierre Leon Pinot Noir",
  "WillaKenzie Estate Pinot Gris",
  "WillaKenzie Estate Pinot Noir",
  "Willamette Valley Vineyards Bernau Block Pinot Noir",
  "Willamette Valley Vineyards Chardonnay",
  "Willamette Valley Vineyards Elton Pinot Noir",
  "Willamette Valley Vineyards Pinot Gris",
  "Willamette Valley Vineyards Pinot Noir",
  "Willamette Valley Vineyards Rosé of Pinot Noir",
  "Willamette Valley Vineyards Whole Cluster Pinot Noir",
  "Willi Schaefer Graacher Domprobst Riesling Auslese",
  "Willi Schaefer Graacher Domprobst Riesling Spätlese",
  "William Chris Vineyards Cabernet Sauvignon",
  "William Chris Vineyards Texas Roussanne",
  "William Fèvre Chablis Grand Cru Les Clos",
  "William Fèvre Chablis Premier Cru",
  "William Hill Estate Reserve Cabernet Sauvignon",
  "William Hill Estate Winery Cabernet Sauvignon",
  "William Hill Estate Winery Reserve Cabernet Sauvignon",
  "Williams & Humbert Dry Sack Medium Sherry",
  "Williams Selyem Chardonnay",
  "Williams Selyem Drake Estate Pinot Noir",
  "Williams Selyem Harvest Moon Zinfandel",
  "Williams Selyem Pinot Noir",
  "Williams Selyem Rochioli Riverblock Vineyard Pinot Noir",
  "Williams Selyem Russian River Valley Pinot Noir",
  "Williams Selyem Sonoma Coast Chardonnay",
  "Williams Selyem Sonoma Coast Pinot Noir",
  "Willowcroft Farm Pinot Noir",
  "Wilson Winery Zinfandel",
  "Wind Gap Chardonnay",
  "Windsor Vineyards Chardonnay",
  "Windy Oaks Estate Pinot Noir",
  "Wine & Soul Pintas",
  "Wine & Soul Pintas Character",
  "Wines & Winemakers Quinta do Cardido Vinho Verde",
  "Wines by Geoff Hardy Pertaringa Understudy Shiraz",
  "Winter's Hill Estate Pinot Noir",
  "Wirra Wirra RSW Shiraz",
  "Wirra Wirra The Angelus Cabernet Sauvignon",
  "Witness Tree Pinot Noir",
  "Witness Tree Vineyard Pinot Noir",
  "Wittmann 100 Hills Riesling",
  "Wittmann Morstein Riesling Grosses Gewächs",
  "Wittmann Riesling Trocken",
  "Wolf Blass Gold Label Cabernet Sauvignon",
  "Wolf Blass Gold Label Shiraz",
  "Wolf Blass Grey Label Cabernet Sauvignon",
  "Wolf Blass Platinum Label Shiraz",
  "Wolf Blass Red Label Shiraz Cabernet",
  "Wolf Blass Yellow Label Cabernet Sauvignon",
  "Wolfberger Pinot Gris",
  "Wolffer Estate Cabernet Franc",
  "Wolffer Estate Rosé",
  "Wolffer Estate Summer in a Bottle Rosé",
  "Woodbridge Chardonnay",
  "Woodbridge by Robert Mondavi Cabernet Sauvignon",
  "Woodbridge by Robert Mondavi Chardonnay",
  "Woodward Canyon Artist Series Cabernet Sauvignon",
  "Woodward Canyon Winery Cabernet Sauvignon",
  "Wynns Black Label Cabernet Sauvignon",
  "Wynns Coonawarra Estate Black Label Cabernet Sauvignon",
  "Wynns Coonawarra Estate Cabernet Sauvignon",
  "Wynns Coonawarra Estate John Riddoch Cabernet Sauvignon",
  "Xanadu Cabernet Sauvignon",
  "Yalumba Pewsey Vale Eden Valley Riesling",
  "Yalumba Samuel's Collection Shiraz",
  "Yalumba Signature Cabernet Sauvignon Shiraz",
  "Yalumba The Menzies Coonawarra Cabernet",
  "Yalumba The Octavius Old Vine Shiraz",
  "Yalumba The Signature Cabernet Shiraz",
  "Yalumba Y Series Shiraz Viognier",
  "Yangarra Estate GSM",
  "Yangarra Estate Ovitelli",
  "Yannick Amirault Saint-Nicolas-de-Bourgueil",
  "Yannick Amirault Saint-Nicolas-de-Bourgueil Les Malgagnes",
  "Yardstick Cabernet Sauvignon",
  "Yealands Estate Sauvignon Blanc",
  "Yellow Tail Cabernet Sauvignon",
  "Yellow Tail Chardonnay",
  "Yellow Tail Shiraz",
  "Yering Station Chardonnay",
  "Yering Station Reserve Chardonnay",
  "Yering Station Reserve Pinot Noir",
  "Yering Station Village Pinot Noir",
  "Youngberg Hill Pinot Noir",
  "Yountville Cabernet Sauvignon",
  "Yves Cuilleron Condrieu Les Chaillets",
  "Yves Cuilleron Côte-Rôtie Bassenon",
  "Yves Cuilleron Saint-Joseph Les Serines",
  "Yvon Métras Fleurie",
  "ZD Wines Cabernet Sauvignon",
  "ZD Wines Chardonnay",
  "ZD Wines Reserve Cabernet Sauvignon",
  "Zaca Mesa Winery Syrah",
  "Zaca Mesa Winery Z Cuvée",
  "Zaccagnini Montepulciano d'Abruzzo",
  "Zardetto Prosecco Brut",
  "Zenaida Cellars Syrah",
  "Zenato Alanera Rosso Veronese",
  "Zenato Amarone della Valpolicella Classico",
  "Zenato Amarone della Valpolicella Riserva Sergio Zenato",
  "Zenato Cresasso Corvina Veronese",
  "Zenato Lugana",
  "Zenato Lugana San Benedetto",
  "Zenato Pinot Grigio",
  "Zenato Ripassa Superiore Valpolicella",
  "Zenato Ripassa Valpolicella Ripasso",
  "Zenato Ripassa Valpolicella Ripasso Superiore",
  "Zenato San Benedetto Lugana",
  "Zenato Soave Classico",
  "Zenato Soave Classico Superiore San Benedetto",
  "Zenato Valpolicella Superiore",
  "Zeni Bardolino",
  "Zeni Bardolino Chiaretto Rosé",
  "Zidarich Vitovska",
  "Zilliken Saarburger Rausch Riesling Auslese",
  "Zilliken Saarburger Rausch Riesling Spätlese",
  "Zina Hyde Cunningham Mencia",
  "Zind-Humbrecht Gewurztraminer",
  "Zind-Humbrecht Gewurztraminer Brand Grand Cru",
  "Zind-Humbrecht Gewurztraminer Rangen de Thann Clos Saint Urbain",
  "Zind-Humbrecht Gewurztraminer Vendanges Tardives",
  "Zind-Humbrecht Pinot Gris Clos Windsbuhl",
  "Zind-Humbrecht Pinot Gris Rangen de Thann Clos Saint Urbain",
  "Zind-Humbrecht Riesling Clos Windsbuhl",
  "Zind-Humbrecht Riesling Goldert Grand Cru",
  "Zind-Humbrecht Riesling Rangen de Thann Clos Saint Urbain",
  "Zind-Humbrecht Riesling Vendanges Tardives",
  "Zotovich Cellars Pinot Noir",
  "Zuani Collio Bianco",
  "Zuccardi Aluvional Malbec",
  "Zuccardi Concreto Malbec",
  "Zuccardi Emma Zuccardi Malbec",
  "Zuccardi Fósil Malbec",
  "Zuccardi Malamado Malbec",
  "Zuccardi Q Malbec",
  "Zuccardi Serie A Malbec",
  "Zuccardi Valle de Uco Malbec",
  "Zuccardi Valle de Uco Serie A Malbec",
  "Zuccardi Valle de Uco Serie A Rosé",
  "Zuccardi Valle de Uco Valle de Uco Malbec",
  "Zyme Amarone della Valpolicella",
  "Zárate Albariño El Palomar",
  "d'Arenberg The Coppermine Road Cabernet Sauvignon",
  "d'Arenberg The Dead Arm Shiraz",
  "d'Arenberg The Stump Jump Grenache Shiraz Mourvèdre",
  "d'Arenberg The Stump Jump Red",
  "von Strasser Winery Cabernet Sauvignon",
  "Álvaro Castro Dão Reserva",
  "Álvaro Castro Pelourinho",
  "Álvaro Palacios Camins del Priorat",
  "Álvaro Palacios Finca Dofí",
  "Álvaro Palacios L'Ermita",
  "Álvaro Palacios Les Terrasses",
  "àMaurice Cellars Cabernet Sauvignon"
];
